export const pt = {
  inventory_history_reference: {
    fefo_override: {
      title: 'Exceção FEFO #{{id}}',
      earlier_lot: 'lote anterior {{lot}}',
      expiring: 'vence {{date}}',
      at_location: 'em {{location}}',
      acknowledged: 'alerta confirmado',
      no_warning: 'sem alerta',
    },
  },
  general: {
    product: {
      insert: 'Enxerto',
    },
    messages: {
      no_options: 'Nenhuma opção encontrada',
    },
  },

  dropdown_menu: {
    warehouse_associated_one: '{{count}} armazém associado',
    warehouse_associated_other: '{{count}} armazéns associados',
    role_assigned_one: '{{count}} cargo atribuído',
    role_assigned_other: '{{count}} cargos atribuídos',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },

  inputPlaceholder: {
    pdfFiles: 'Clique aqui ou arraste seus arquivos PDF.',
    addImage: 'Clique aqui ou arraste a imagem.',
    select: 'Selecionar',
    required_field: 'Campo obrigatório',
  },
  claims: {
    reimbursables: {
      cost_cubbo: 'Custo Operacional Cubbo',
      cost_shipping: 'Custo de guia do pedido',
      product_value: 'Valor indicado do produto',
      cost_shipping_replace: 'Custo de guia para enviar a reposição do pedido',
      cost_shipping_reposition: 'Custo do guia para enviar reposição de pedidos',
      return_cost: 'Custo da guia de devolução do produto errado',
    },
    motives: {
      delivery_delay: 'Pedido foi coletado pela transportadora mas está sem movimentação.',
      false_delivery: 'O status do pedido indica que o pedido foi entregue, mas meu cliente não o recebeu.',
      package_stolen: 'O status do pedido indica que foi roubado.',
      package_lost: 'O status do pedido indica que foi extraviado ou roubado.',
      damaged_product: 'Pedido foi entregue avariado.',
      incorrect_content: 'Pedido entregue não corresponde ao que o cliente encomendou.',
      none_of_the_above: 'Nenhuma das opções acima.',
      missing_products: 'Faltaram produtos no pedido',
      unwanted_products: 'Produtos não encomendados foram recebidos',
      wrong_order: 'Meu cliente recebeu um pedido completo que não era dele.',
      paid_product: '...algo que meu cliente comprou.',
      promotional_product: '...algo que deveria ter sido enviado como um produto promocional.',
    },
    motive_names: {
      unwanted_products: 'Producto incorrecto',
      missing_products: 'Producto faltante',
      wrong_order: 'Guía cruzada',
      operations_others: 'Otros - Operaciones',
      damaged_product: 'Dañado',
      incorrect_charge: 'Mal cobrado',
      other: 'Otro - Área del Comercial',
      origin_error: 'Error de origen',
      package_lost: 'Perdido',
      damaged_product: 'Dañado',
      delivery_delay: 'Demora en entrega',
      false_delivery: 'Entrega Incorrecta',
      package_stolen: 'Robo',
      delivery_others: 'Otros - Paquetería',
      missing_products: 'Producto faltante',
    },
    operations: {
      unwanted_products: {
        description: 'Producto incorrecto',
        recomendation:
          'Lembramos que pode duplicar a encomenda com incidência e ajustar os produtos a reenviar para enviar ao seu cliente os produtos pendentes.',
      },
      missing_products: {
        description: 'Producto faltante',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      wrong_order: {
        description: 'Guía cruzada',
        recomendation: 'Atenção: Acesse o link para realizar corretamente o reenvio de um pedido que sofreu algum incidente:',
        url: 'https://scribehow.com/shared/Como_gerar_Reenvio_de_Pedido__QPK47MegT3qhfXZB7Wcrog',
      },
      operations_others: {
        description: 'Otros - Operaciones',
        recomendation: '',
      },
    },
    commercial: {
      unwanted_products: {
        description: 'Producto incorrecto',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      wrong_order: {
        description: 'Guía cruzada',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      operations_others: {
        description: 'Otros - Operaciones',
        recomendation: '',
      },
      damaged_product: {
        description: 'Dañado',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      package_lost: {
        description: 'Perdido',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      delivery_delay: {
        description: 'Demora en entrega',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      false_delivery: {
        description: 'Entrega Incorrecta',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      package_stolen: {
        description: 'Robo',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      missing_products_delivery: {
        description: 'Producto faltante - Paquetería',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      missing_products_operations: {
        description: 'Producto faltante - Operaciones',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
    },
    client: {
      origin_error: {
        description: 'Error de origen',
        recomendation: '',
      },
      other: {
        description: 'Otro - Área del cleinte',
        recomendation: '',
      },
    },
    delivery: {
      package_lost: {
        description: 'Perdido',
        recomendation: 'Atenção: Acesse o link para realizar corretamente o reenvio de um pedido que sofreu algum incidente:.',
        url: 'https://scribehow.com/shared/Como_gerar_Reenvio_de_Pedido__QPK47MegT3qhfXZB7Wcrog',
      },
      damaged_product: {
        description: 'Dañado',
        recomendation:
          'Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.',
      },
      delivery_delay: {
        description: 'Demora en entrega',
        recomendation:
          'Relembramos que pode duplicar a encomenda para enviar os seus produtos ao seu cliente e iniciar a devolução da encomenda com uma incidência para a devolver ao armazém caso seja recuperada.',
      },
      false_delivery: {
        description: 'Entrega Incorrecta',
        recomendation: 'Lembramos que pode duplicar a encomenda com incidência para fazer chegar os seus produtos ao seu cliente.',
      },
      package_stolen: {
        description: 'Robo',
        recomendation:
          'Lembramos que você pode duplicar o pedido com um incidente para enviar ao seu cliente os produtos que ele pediu e proporcionar uma melhor experiência.',
      },
      delivery_others: {
        description: 'Otros - Paquetería',
        recomendation: '',
      },
    },
    html: {
      rejected: {
        message_initial: 'Tivemos que recusar a disputa do pedido',
        category: 'categorizado como',
        apologies: 'lamentamos o inconveniente.',
        reazon: 'O motivo da rejeição é porque',
        evidence: 'Anexado a este e-mail, compartilhamos as evidências que apoiam esta decisão.',
        recommendation: 'Para proporcionar a melhor experiência possível ao seu cliente, recomendamos você',
        contact: 'Você pode entrar em contato conosco pelo chat da plataforma se precisar de mais detalhes.',
        farewell: 'Será um prazer atendê-lo',
        sender: 'Cubbo',
      },
      accepted: {
        message_initial: 'Aceitamos a disputa do pedido',
        category: 'categorizado como',
        apologies: 'lamentamos o inconveniente.',
        resolution:
          'Você verá o valor a ser reembolsado refletido em sua próxima fatura como um crédito a favor. Estes são os conceitos considerados para o reembolso:',
        contact: 'Você pode entrar em contato conosco pelo chat da plataforma se precisar de mais detalhes.',
        farewell: 'Será um prazer atendê-lo',
        sender: 'Cubbo',
      },
    },
    status: {
      accepted: 'Aceptado',
      rejected: 'Rechazado',
    },
    messages: {
      none: 'Nenhum',
      without_reason: 'Sim motivo',
      success_message: 'A disputa foi resolvida com sucesso',
      success_update_message: 'A disputa foi atualizada.',
      error_message: 'Erro ao salvar disputa',
    },
  },

  formatted_relative_time: {
    today: 'Hoje',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
    date: '{{day}} de {{month}}',
    from_now: 'Há {{days}} dias',
  },

  orders: {
    filters: {
      order_number: 'Número do pedido',
      paste_order_numbers: 'Cole os números de os pedidos',
      paste_shipping_numbers: 'Cole os números de os rastreamentos',
      shipping_number: 'Etiqueta de envio',
      channel_name: 'Canal de venda',
      shipping_method: 'Método de envio',
      status: 'Estado do pedido',
      shipping_status: 'Estado de envio',
      shipping_date: 'Data de envio',
      channel_name_placeholder: 'Selecione um canal de venda',
      shipping_method_placeholder: 'Selecione um método de envio',
      shipping_status_placeholder: 'Selecione um estado de envio',
      tracking_description: 'Motivo do incidente',
      tracking_description_placeholder: 'Selecione um motivo',
      tracking_description_none: 'Sem motivo nem subestado',
      shipping_incident_category_placeholder: 'Qualquer tipo',
      shipping_incident_status_placeholder: 'Qualquer estado',
      status_placeholder: 'Selecione um estado',
      multifilter_bulk: 'Pesquisa em pedido em massa ou rastreamento',
      store: 'Loja',
      is_delayed: 'Atrasados',
      first_delivery_on_time: 'Tentativa de entrega no prazo',
      failed_delivery: 'Entrega sem sucesso',
      shipping_incident: 'Com incidente',
      without_shipping_incident: 'Sem incidente',
      unsolved_shipping_incident: 'Incidente não resolvido',
    },
    incidents_bar: {
      select_action: 'Selecione uma ação',
      deselect_all_orders: 'Desmarcar todos os pedidos',
      orders_selected: 'Pedidos selecionados',
      update_incident: 'Atualizar estado do incidente',
      update_shipping_status: 'Atualizar estado de envio',
      update_current_status_for: 'Atualizar estado atual para',
      update_current_shipping_status_for: 'Atualizar estado de envio atual para',
      dialog: {
        create_title: 'Tem certeza de que deseja criar incidente de',
        for: 'para',
        orders_selected: 'pedidos selecionados?',
        errors_intro: 'Pedidos para los cuales no es posible crear este incidente',
      },
    },
    incidents_container: {
      previous_delivery_date: 'Data de entrega anterior',
      new_address: 'Nova morada de entrega',
      address: 'Endereço',
      number: 'Número',
      neighborhood: 'Bairro',
      city: 'Cidade',
      zip_code: 'CEP',
      state: 'Estado',
    },
    list: {
      created_at: 'Criado em',
      eta: 'Entrega estimada',
      at: 'El',
      create_incident: 'Criar incidente',
      update_shipping_status: 'Atualizar status de envio',
      sure_to_report: 'Tem certeza de que deseja criar um incidente de ',
      requiring_monitoring: 'Requerem monitoramento',
      no_information: 'Sem Status',
      no_pieces: 'Sem produtos para enviar',
    },
    order_details: {
      title: 'Ver Pedido',
      order_number: 'Número do pedido',
      tracking_number: 'Número de rastreamento',
      status: 'Estado',
      shipping_status: 'Status de envio',
      creation_date: 'Data de criação',
      proof_of_delivery: 'Comprovante de entrega',
      packing_video: 'Vídeo de packing',
      romaneios: 'Romaneio',
      store: 'Loja',
      shipping_method: 'Método de envio',
      shipping_information: 'Informações de envio',
      name: 'Nome',
      phone: 'Telefone',
      email: 'Email',
      address: 'Endereço',
      country: 'País',
      state: 'Estado',
      city: 'Cidade',
      zip_code: 'CEP',
      billing_name: 'Nome',
      billing_address: 'Endereço',
      billing_country: 'País',
      billing_state: 'Estado',
      billing_city: 'Cidade',
      billing_zip_code: 'CEP',
      billing_information: 'Informações de Faturamento',
      edit_billing: 'Editar Informações',
      picking: 'Picking',
      picker: 'Picker',
      assigned: 'Atribuído',
      started: 'Iniciado',
      tote: 'Tote',
      list: 'Lista',
      download: 'Baixar',
      completed: 'Concluído',
      packing: 'Packing',
      products: 'Produtos',
      quantity: 'Quantidade',
      no_packing_evidence: 'Não há evidências de packing para este pedido.',
      shipping_incidents: 'Incidentes criados para paqueteria',
      partial_shipment: 'Envio Parcial',
      items_removed: 'Itens removidos do envio',
      upc: 'UPC:',
      sku: 'SKU:',
      kit: 'Kit',
      damaged: 'Danificado',
      downloading: 'Baixando...',
      download_failed: 'Não foi possível baixar o vídeo. Tente novamente.',
      mb: 'MB',
      printed_guide: 'Guia Impressa',
    },
    shipping_incident: {
      status: {
        PENDING: 'Pendente',
        IN_REVIEW: 'Sob revisão',
        RESOLVED: 'Resolvido',
      },
      category: {
        CANCELED: 'Cancelamento solicitado',
        CANCEL_ATTEMPT: 'Tentativa de cancelamento',
        DELAYED: 'Entrega atrasada',
        MISSING_REFERENCES: 'Completar endereço',
        DAMAGED: 'Pedido avariado',
        MISSING_PRODUCT: 'Faltam produtos',
        FALSE_DELIVERY: 'Entrega incorreta',
        CHANGE_ADDRESS: 'Alterar endereço',
        RESCHEDULE: 'Reagendar data de entrega',
        LOADING_ERROR: 'Pedido con error de carga',
      },
      resolution: {
        STOLEN: 'Pedido roubado',
        LOST: 'Pedido extraviado',
        NON_REFUNDABLE_DAMAGED: 'Produto avariado não reembolsável',
        RETURNED: 'Retornou ao armazém',
        DELIVERED: 'Pedido entregue',
        REFUNDABLE: 'Reembolsável',
      },
      cant_update: 'Nenhum dos pedidos selecionados tem incidentes criados, então não há itens para atualizar',
      cant_create: {
        order_returned: 'O pedido já foi devolvido',
        order_not_shipped_or_returning: 'O pedido não foi enviado ou está em processo de devolução',
        unresolved_same_category_incident: 'O pedido já tem um incidente deste tipo não resolvido',
        only_damaged_missing_product_false_delivery_incidents_allowed: 'Somente incidentes de avaria, faltando produtos ou entrega incorreta são permitidos',
        only_delayed_canceled_missing_references_incidents_allowed: 'Somente incidentes de atraso, cancelamento ou endereço incompleto são permitidos',
        remove_stock_order: 'Este tipo de pedido não pode criar incidentes',
        temporarily_disabled: 'Estamos trabalhando nisso, use o formulário',
      },
      errors: {
        create: {
          INVALID_CATEGORY_FOR_ORDER_STATUS: 'A categoria de incidente não é válida para o estado do pedido',
          ORDER_ALREADY_RETURNED: 'O pedido já foi devolvido',
          ORDER_NOT_SHIPPED: 'O pedido não foi enviado',
          UNRESOLVED_INCIDENT: 'O pedido já tem um incidente deste tipo não resolvido',
          ERROR_DESCRIPTION_REQUIRED: 'A descrição do incidente é obrigatória',
          ERROR_INCIDENT_ALREADY_RESOLVED: 'O incidente já foi resolvido',
          ERROR_INCOMPATIBLE_ORDER: 'Este tipo de pedido não pode criar incidentes',
          ORDER_HAS_RETURN: 'O Pedido já foi retornou ou retornando.',
          ORDER_HAS_DELIVERY: 'O pedido já foi entregue.',
          NO_INCIDENT_CREATED: 'O pedido não tem um incidente criado.',
        },
        error_modal: {
          confirmations: {
            CREATE_INCIDENT: 'Tem certeza de que deseja criar incidentes do tipo {incident_type} para {order_count} pedidos selecionados?',
            UPDATE_SHIPPING_STATUS: 'Tem certeza de que deseja atualizar o status de envio {status} para {order_count} pedidos selecionados?',
            RESOLVE_INCIDENT: 'Tem certeza de que deseja resolver incidentes para os {order_count} pedidos selecionados?',
            UPDATE_SHIPPING_STATUS: 'Tem certeza de que deseja atualizar o status de envio {shipping_status} para os {order_count} pedidos selecionados?',
            omit_errors_and_submit: 'Omitir e aceitar o resto',
            no_valid_elements: 'Nenhum elemento válido.',
          },
          messages: {
            action_not_possible: 'Detectamos {quantity} pedidos para os quais não é possível realizar esta ação',
            omit_errors_and_submit_question: 'Deseja ignorar esses pedidos e aceitar o restante da seleção?',
            order_labels_with_errors: 'Tracking dos pedidos com erros',
            no_valid_elements_tooltip: 'Não é possível realizar esta ação para nenhum dos pedidos selecionados',
          },
        },
      },
      pod: {
        download: 'Baixar',
        received_by: 'Recebido por',
        title: 'Comprovante de entrega',
        not_provided: 'Esta transportadora não fornece comprovante de entrega',
        unavailable: 'Não temos comprovante de entrega para este pedido',
        proof: 'Comprovante',
        download_success: 'Comprovante de entrega baixado com sucesso',
        download_error: 'Não foi possível baixar o comprovante de entrega, tente novamente mais tarde',
      },
    },
    show_shipping_incidents: {
      from_date: '. De ',
      created_by: {
        RECIPIENT: 'Criado pelo comprador final ',
        CUBBO: 'Criado pela Cubbo ',
      },
      info_types: {
        important: 'Importante: ',
      },
      toggle_description: {
        hide: 'Ocultar ',
        show: 'Mostrar ',
      },
      description_title: {
        MISSING_REFERENCES: 'endereço compartilhado',
        OTHER: 'evidência compartilhada',
      },
      categories: {
        DELAYED: 'Incidente: Atraso na entrega',
        MISSING_REFERENCES: 'Incidente: Complementar endereço',
        CANCELED: 'Incidente: Cancelar entrega',
        CANCEL_ATTEMPT: 'Incidente: Tentativa de cancelamento',
        DAMAGED: 'Incidente: Produto danificado',
        MISSING_PRODUCT: 'Incidente: Produtos faltando',
        FALSE_DELIVERY: 'Incidente: Entrega incorreta',
        CHANGE_ADDRESS: 'Incidente: Alterar endereço',
        RESCHEDULE: 'Incidente: Reagendar data de entrega',
      },

      status: {
        PENDING: 'Pendente',
        IN_REVIEW: 'Em revisão',
        RESOLVED: 'Resolvido',
      },

      evidence_type: {
        product_images: 'Fotos detalhadas do incidente.',
        label_images: 'Fotos da etiqueta de envio.',
        package_images: 'Fotos da embalagem.',
      },
    },
    packing_material: {
      BUBBLE_WRAP: 'Plástico bolha',
      KRAFT_PAPER: 'Papel Kraft',
      CORN_EXTRUDATE: 'Extrusado de milho',
      KRAFT_PAPER_AND_BUBBLE_WRAP: 'Papel Kraft + Plástico bolha',
    },
  },

  cubbo_lastmile_events: {
    order_events: 'Histórico',
    created_email: 'Por {{user_email}}',
    created_email_xdock: 'Por {{user_email}} em {{xdock_name}}',
    no_events: 'Não existem eventos disponíveis',
    errors: 'Conflito registrado: {{error_codes}}',
    is_collapsed: 'Ver tudo',
    is_not_collapsed: 'Recolher',
    event_types: {
      CREATED_LABEL: 'Guia gerada',
      RECEIVED_AT_XDOCK: 'Recebido no Xdock',
      ASSIGN_ROUTE: 'Rota atribuída',
      CREATED_DELIVERY_ROUTE: 'Rota de entrega gerada',
      GROUPING_PACKAGES: 'Empacotamento guia',
      GROUPED_PACKAGES: 'Guia empacotada',
      DISPATCHED_TO_MIDDLE_MILE: 'Despachado para Middle Mile',
      MIDDLE_MILE_IN_TRANSIT: 'Em trânsito pelo Middle Mile',
      DISPATCHED_FOR_DELIVERY: 'Despachado para motorista',
      IN_DELIVERY: 'Em rota de entrega',
      DELIVERED: 'Entregue',
      SHIPPING_INCIDENT: 'Incidente',
      FAILED_DELIVERY_ATTEMPT: 'Tentativa de entrega falhou',
      RESCHEDULED_DELIVERY: 'Entrega reprogramada',
      CANCELLED: 'Cancelado',
      RETURNING: 'Retornando',
      DISPATCHED_TO_XDOCK: 'Despachado para Xdock',
      RETURNED: 'Retornado',
      LOST: 'Pacote reportado como perdido',
      DAMAGED: 'Pacote reportado como danificado',
      STOLEN: 'Pacote reportado como roubado',
      SHIPPING_INCIDENT_DELAYED: 'Incidente: Atraso na entrega',
      SHIPPING_INCIDENT_MISSING_REFERENCES: 'Incidente: Complementar endereço',
      SHIPPING_INCIDENT_MISSING_PRODUCT: 'Incidente: Produto faltante',
      SHIPPING_INCIDENT_FALSE_DELIVERY: 'Incidente: Entrega incorreta',
      SHIPPING_INCIDENT_CHANGE_ADDRESS: 'Incidente: Alterar endereço',
      DISPATCHED_TO_WAREHOUSE: 'Despachado para armazém',
      INVALID_LABEL: 'Guia inválida',
      PACKAGING_LABEL: 'Guia embalada',
      UNPACKED_LABEL: 'Guia desembalada',
      PACKED_LABEL: 'Guia empacotada',
      ARRIVED_AT_PICKUP_POINT: 'Chegou ao ponto de retirada',
      COLLECTED_BY_CUSTOMER: 'Retirado pelo cliente',
    },
    error_codes: {
      LABEL_NOT_FOUND: 'Guia não encontrada',
      LABEL_WRONG_CARRIER: 'Transportadora incorreta',
      LABEL_INVALID_STATUS: 'Guia com status incorreto',
      WRONG_OPERATION: 'Operação incorreta',
      WRONG_ROUTE: 'Rota incorreta',
      NO_ROUTE: 'Sem rota',
      CANCELLED: 'Pedido cancelado',
      PROCESS_REVERSE_LOGISTICS: 'Processando logística reversa',
      REPROGRAMMED: 'Entrega reprogramada',
      WRONG_STATUS: 'Status incorreto',
      INCIDENT_LOST: 'Incidente: Perdido',
      INCIDENT_DAMAGED: 'Incidente: Danificado',
      INCIDENT_STOLEN: 'Incidente: Roubado',
      LABEL_NOT_RECEIVED: 'Guia não recebida no Xdock',
    },
  },

  returns: {
    proof_videos: {
      title: 'Vídeo do recebimento',
      loading: 'Carregando vídeo...',
      empty: 'Nenhum vídeo gravado para este retorno.',
      error: 'Não foi possível carregar o vídeo agora.',
      recorded_at: 'Gravado em {{date}} · {{size}} MB',
      download: 'Baixar',
      watch: 'Assistir',
      hide: 'Ocultar',
      processing: 'O vídeo está sendo enviado. Ele aparece aqui em instantes.',
      refresh_error: 'Não foi possível atualizar os links dos vídeos. Tente de novo em instantes.',
      unavailable: 'Este vídeo não está mais disponível.',
      playback_failed: 'Não foi possível reproduzir este vídeo no navegador. Use Baixar.',
    },
    lot_label: 'Lote',
    unidentified: 'Não identificado',
    errors: {
      cubbito_wrong_warehouse: 'Esta devolução vai para {{warehouse_code}}: separe-a para transferência.',
      not_belong_to_warehouse: "O retorno da ordem #{{order_number}} pertence ao armazém '{{warehouse_name}}', !SEPARA¡ para processá-lo no armazém correto.",
      return_not_found: 'O pedido #{{order_number}} precisa ser retornado pela ZEBRA antes de começar o BOT-BOV.',
      order_not_found: 'O pedido #{{order_number}} não foi encontrado.',
      received_more_products_than_expected:
        'Não é possível receber mais produtos do que os enviados; espera-se receber {{quantity}} peças do produto com UPC: {{upc}}',
      unidentified_returns_disabled: 'Pedido não encontrado. O recebimento de devoluções não identificadas não está habilitado neste armazém.',
      warehouse_config_unavailable:
        'Pedido não encontrado. Não foi possível ler a configuração deste armazém, então não dá para verificar se ele aceita devoluções não identificadas. Tente novamente; se a mensagem persistir, recarregue a página e acione o suporte.',
      error_codes: {
        no_approved_sale_invoice:
          'Não há nota fiscal de venda aprovada para este pedido, então não é possível emitir a nota de devolução. Acione o time fiscal.',
        no_products: 'Nenhum produto foi informado para o recebimento da devolução.',
        all_missing_not_confirmed:
          'Todos os produtos estão marcados como faltantes e o fechamento sem sucesso não foi confirmado. Recarregue a página e salve novamente para ver a confirmação.',
        certificate_invalid: 'O certificado fiscal da loja é inválido ou está expirado. Acione o time fiscal.',
        no_icms_rate: 'Este retorno contém item(ns) sem alíquota de ICMS cadastrada, então não é possível emitir a nota de devolução. Acione o time fiscal.',
        estorno_missing_subtotal: 'Falta o subtotal do produto para calcular o estorno de crédito (CFOP de perda de estoque). Acione o time fiscal.',
        product_invalid_price: 'Há item com preço unitário inválido (menor ou igual a zero). Corrija o cadastro do produto.',
        fiscal_rejection: 'A nota fiscal de devolução foi rejeitada pela SEFAZ:',
        invoice_generation_failed: 'Falha ao gerar a nota fiscal de devolução. Tente novamente; se o erro persistir, acione o suporte.',
        transient_retry: 'Erro temporário do sistema. Aguarde alguns instantes e tente novamente.',
        unidentified_not_enabled: 'O recebimento de devoluções não identificadas não está habilitado neste armazém.',
        unidentified_require_webmania: 'Devoluções não identificadas exigem faturamento Webmania para lojas brasileiras. Acione o time fiscal.',
        unidentified_require_replenishment_invoices:
          'Devoluções não identificadas exigem notas fiscais de reposição habilitadas para a loja. Acione o time fiscal.',
      },
    },
    return_types: {
      unknown: 'Desconhecido',
      simple_return: 'Devolução',
      exchange: 'Troca',
      immediate_exchange: 'Troca imediata',
      returned_by_carrier: 'Paquetería',
      unidentified: 'Não identificado',
    },
    receive_return: {
      all_sealed_question: 'Todos os produtos estão selados?',
      all_sealed_yes: 'Sim',
      all_sealed_no: 'Não',
      inspection_modal_title: 'Separe o pedido para inspeção',
      inspection_modal_description: 'O pedido foi marcado como aguardando inspeção. Separe-o fisicamente para inspeção.',
      inspection_modal_confirm: 'Entendido',
      confirm_receipt_title: 'Confirmar Recepção de Retorno',
      confirm_receipt_description: 'Confirma que retornaram um total de {{count}} produto{{plural}}.',
      missing_products_header: 'Os seguintes produtos eram esperados mas não foram recebidos e serão marcados como faltantes:',
      all_missing_title: 'Nada chegou nesta devolução?',
      all_missing_description:
        'Todos os produtos esperados estão marcados como faltantes. Ao confirmar, a devolução será fechada como sem sucesso, sem recibo, e as unidades abaixo serão registradas como perda.',
      all_missing_products_header: 'Serão registrados como perda:',
      all_missing_quantity: 'Quantidade: {{quantity}}',
      all_missing_irreversible: 'Esta ação não pode ser desfeita.',
      all_missing_confirm: 'Confirmar que nada chegou',
      resolve_scanned_products_first: 'Antes de salvar, marque cada produto escaneado como recebido, danificado ou faltante.',
      nothing_booked_to_save: 'Escaneie ou busque ao menos um produto e marque-o como recebido, danificado ou faltante antes de salvar.',
      expected: 'Esperados',
      received: 'Recebidos',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Salvar',
      return_label_title: 'Guia de retorno',
      no_products_found: 'Nenhum produto encontrado',
      product_not_in_order: 'Este produto não pertence ao pedido',
      no_upc: 'Sem UPC',
      search_lot_placeholder: 'Buscar lote',
      product_marked_damaged: 'O produto está marcado como danificado no retorno',
      view_order: 'Ver Pedido',
      page_title_receive_by_courier: 'Receber Retorno Por Transportadora',
      page_title_receive_order: 'Receber Pedido Em Devolução',
      damaged_pieces: '(Peças Danificadas)',
      no_lot_required: 'Não requer lote',
      await_inspection_failed: 'Não foi possível enviar o retorno para inspeção. Tente novamente.',
      scan_unit_code_placeholder: 'Escaneie o código único',
      select_unit_code_first: 'Selecione o código único da unidade antes de recebê-la.',
      unit_code_not_for_product: 'Este código único não pertence a este produto.',
      unit_code_already_used: 'Este código único já foi selecionado.',
      receive: 'Receber',
      remove_product: 'Remover produto',
      lot_tooltip: 'Se você não encontrar o lote do produto, pode criar um.',
      create_new_lot: 'Criar um novo lote',
      select_lot_first: 'Para poder receber este produto,<br/>primeiro você deve selecionar <strong>a qual<br/>lote pertence</strong>.',
      damaged: 'Danificado',
      missing: 'Faltante',
      returned_undamaged_pieces: 'Peças retornadas sem danos',
      returned_damaged_pieces: 'Peças retornadas com danos',
      missing_pieces: 'Peças faltantes',
      returns_breadcrumb: 'Retornos →',
    },
  },

  generic: {
    order: 'Pedido',
    orders: 'Pedidos',
    error: 'Erro',
    store: 'Loja',
    warehouse: 'Armazém',
    country: 'País',
    status: 'Estado',
    from: 'De',
    to: 'Até',
    usages: 'Usos',
    billing_statements: 'Cobranças',
    empty_table: 'Sem dados para mostrar',
    undefined: 'Não definido',
    active: 'Ativo',
    pending: 'Pendente',
    disabled: 'Desativado',
    not_having_current_billing_configuration: 'Sem configuração de faturamento',
    having_current_billing_configuration: 'Com configuração de faturamento',
    store: 'Loja',
    stores: 'Lojas',
    store_name: 'Nome da loja',
    cancel: 'Cancelar',
    completed: 'Completado',
    close: 'Fechar',
  },

  access_denied: 'Desculpe, você não tem permissão para acessar esta página',
  filter: {
    button: 'Filtrar',
    reset: 'Limpar filtros',
    apply: 'Aplicar filtros',
    select: 'Selecione um estado',
    from_to: 'de-até',
    export: 'Exportar',
    in: 'em',
  },

  dialog: {
    yes: 'Sim',
    no: 'Não',
  },
  statuses: {
    order_statuses: {
      unknow: 'STATUS_NO_DEF',
      initial: 'Sincronizando',
      empty: 'Pedido vazio',
      pending: 'Pendente',
      processing: 'Processando',
      shipped: 'Enviado',
      returning: 'Em devolução a Cubbo',
      returned: 'Devolução recebida',
      canceled: 'Cancelado',
      error: 'Informação Pendente',
      entirely_dropshipping: 'Dropshipping',
      backorder: 'Sem Estoque',
      unpaid: 'Pagamento pendente',
      cancelation_window: 'Janela de Cancelamento',
      hold: 'Pausado',
      interrupted: 'Interrompido',
      waiting_pick_up: 'Aguardando coleta',
      awaiting_pick_up: 'Retirada pendente',
      picked_up: 'Coletado',
      in_warehouse: 'Recebido em armazém',
      delayed: 'Atrasado',
      picking: 'Em picking',
      packing: 'Em packing',
    },
    tracking_statuses: {
      unknown: 'Sem Status',
      in_transit: 'Em trânsito',
      shipment_delivered: 'Entrega Realizada',
      shipment_with_incident: 'Incidente',
      shipment_canceled: 'Entrega Cancelada',
      shipment_to_be_self_collected: 'Retire no ponto de coleta',
      shipment_out_for_delivery: 'Na rota de entrega',
      shipment_with_incident_lost: 'Incidente: Perdido',
      shipment_with_incident_stolen: 'Incidente: Roubado',
      shipment_with_incident_damaged: 'Incidente: Danificado',
      delayed: 'Atrasado',
      shipment_returned: 'Retornado por transportadora',
      shipment_with_incident_missing_references: 'Incidente: Problema no endereço',
      shipment_with_incident_refused_package: 'Incidente: Pacote recusado',
      shipment_with_incident_client_requested: 'Incidente: Entrega Cancelada pela Natura',
      shipment_with_incident_carrier_requested: 'Incidente: Duplicidade',
    },
    returns_statuses: {
      unknow: 'Sem status',
      requested: 'Aguardando retorno',
      pending: 'Decisão pendente',
      cancelled: 'Reenvio cancelado',
      ordered: 'Reenvio solicitado',
      received: 'Recebendo retorno',
      arrived_at_warehouse: 'Chegou ao armazém',
      awaiting_inspection: 'Aguardando Inspeção',
      reentered: 'Retorno reingressado',
    },

    tracking_descriptions: {
      second_try: 'Segunda tentativa',
      third_try: 'Terceira tentativa',
      client_requested: 'Solicitação do comprador',
      missing_references: 'Referências ausentes',
      not_at_home: 'O comprador estava ausente',
      refused_payment: 'O comprador se recusou a pagar',
      refused_package: 'O comprador recusou o pacote',
      cubbo_requested: 'Solicitação do Cubbo',
      carrier_requested: 'Solicitação de operadora',
      stolen: 'Roubaram',
      lost: 'Perda',
      damaged: 'Danificado',
      delivery_failed: 'Entrega não realizada',
      returned_by_carrier: 'Por entrega sem sucesso',
      returned_by_client: 'Por devolução solicitada',
      in_return: 'Em devolução pela transportadora',
    },
  },
  billing: {
    copy_config_filter: 'Selecione a loja da qual você deseja copiar a configuração',
    copy_config_duplicate: 'Digite o nome da loja da qual deseja duplicar a configuração',
    copy_config_results: 'Os primeiros 5 resultados são exibidos, refine sua pesquisa para encontrar a loja desejada',
    copy_config: 'Copiar configuração de outra loja',
    create_error_title: 'Ocorreu um erro, tente novamente mais tarde',
    create_invalid_content_error_title: 'Complete as informações necessárias e/ou corrija para poder criar a configuração de cobrança',
    from_prefix: 'Mais de ',
    title: 'Cobrança',
    continue: 'Continuar',
    save: 'Finalizar e salvar configuração',
    create: 'Criar configuração',
    disable: 'Desativar',
    duplicate: 'Duplicar',
    disable_title: 'Desativar cobrança no corte',
    already_disabled: 'A configuração de cobrança já foi desativada',
    billing_configurations_history: 'Histórico de configurações de cobrança',
    billing_custom_services: 'Cobranças/Descontos adicionais',
    statements_section_title: 'Histórico de cortes',
    statements_empty: 'Não há cortes disponíveis',
    view_statement_history: 'Ver histórico',
    disable_billing_for_store_success: 'A configuração de cobrança será desativada no próximo corte',
    status: {
      ACTIVE: 'Ativo',
      DISABLED: 'Desativado',
      UNREQUIRED: 'Não requerido',
      PENDING: 'Pendente',
    },
    stores: {
      start_date: 'Início da vigência',
      end_date: 'Próximo corte',
      empty: 'Não há Lojas para mostrar.',
      about: 'Sobre a loja',
      no_data: 'Sem informações',
      configure: 'Configurar tarifas de cobrança',
      next_cutoff_at: 'Data do corte',
      due_next_week: 'Vence na próxima semana',
      download_preview: 'Baixar pré-visualização de Cobrança do mês atual',
      export_generating: 'Gerando arquivo...',
      export_completed: 'Arquivo gerado',
      export_description: 'Um arquivo será gerado com a pré-visualização de Cobrança do mês atual para este armazém',
      export_success_message: 'O arquivo foi gerado com sucesso',
      export_already_in_progress: 'Já existe uma exportação em progresso para este armazém',
      export_error: 'Erro ao gerar o arquivo',
      export_progress_error: 'Erro ao obter o progresso',
      missing_channel_tech_fee: 'Tech Fee sem configuração por canal',
      missing_channel_tech_fee_select_channel: 'Selecione um canal',
    },
    channels: {
      manual: 'Manual',
      unidentified: 'Não identificado',
    },
    save_dialog: {
      title: 'Criar configuração de cobrança',
      description: 'Confirme a criação da configuração de cobrança',
      confirm_button: 'Confirmar',
      cancel_button: 'Cancelar',
    },
    discard_channel_prices_dialog: {
      title: 'Os preços por canal serão removidos',
      description:
        'A configuração atual tem preços de Tech Fee por canal e a nova não os inclui. Se continuar, todos os canais serão cobrados com o preço geral.',
      confirm_button: 'Remover e salvar',
      cancel_button: 'Cancelar',
    },
    confirm_disable_dialog: {
      title: 'Desativar no próximo corte',
      description: 'Confirme a desativação da configuração de cobrança no próximo corte',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    confirm_delete_dialog: {
      title: 'Excluir configuração de cobrança',
      description: 'Tem certeza de que deseja excluir esta configuração de cobrança? Esta ação não pode ser desfeita.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    delete_config: {
      button: 'Excluir',
      success_message: 'Configuração de cobrança excluída com sucesso',
      error_has_usages:
        'Não é possível excluir esta configuração porque possui cobranças associadas a cortes. Recalcule o corte com uma configuração diferente primeiro.',
      error_replacement_in_progress: 'Não é possível excluir a configuração enquanto houver uma substituição em andamento para esta loja',
      error_operation_in_progress: 'Já existe outra operação de configuração em andamento para esta loja',
      error_generic: 'Ocorreu um erro ao excluir a configuração',
    },
    confirm_exit_dialog: {
      title: 'As alterações serão descartadas. Deseja continuar?',
    },
    replace_config: {
      title: 'Sustituir configuración actual',
      description: 'Seleccione uma configuração futura para substituir a configuração atual',
      warning: 'Esta ação eliminará todas as configurações futuras.',
      select_future_config: 'Selecionar configuração futura',
      no_future_configs: 'Não há configurações futuras disponíveis',
      confirm: 'Confirmar substituição',
      replacing: 'Substituindo configuração...',
      completed: 'Substituição completada',
      success_message: 'A configuração foi substituída com sucesso',
      already_in_progress: 'Já há uma substituição em progresso para esta loja',
      error: 'Erro ao substituir a configuração',
      progress_error: 'Erro ao obter o progresso',
      stages: {
        validation: 'Validando configuração...',
        config_validation: 'Validação completada',
        database_operations: 'Executando operações de banco de dados...',
        rake_task: 'Executando tarefas do sistema...',
        completing: 'Finalizando...',
      },
    },
    recalculate_statement: {
      title: 'Recalcular corte',
      description: 'Selecione um corte e uma configuração de cobrança para recalcular',
      warning: 'Esta ação recalculará todas as cobranças do corte selecionado com a configuração escolhida. As cobranças atuais serão substituídas.',
      select_statement: 'Selecionar corte',
      no_statements: 'Não há cortes disponíveis',
      select_config: 'Selecionar configuração de cobrança',
      custom_services_title: 'Ajustes ao corte',
      custom_services_description: 'Revise as cobranças/descontos existentes e opcionalmente adicione novos que serão aplicados durante o recálculo',
      existing_section_title: 'Cobranças/descontos existentes',
      new_section_title: 'Adicionar nova cobrança/desconto',
      add_new_toggle: '+ Adicionar cobrança/desconto',
      add_custom_service: 'Adicionar',
      is_discount: 'É desconto',
      title_label: 'Título',
      description_label: 'Descrição',
      amount_label: 'Valor',
      send_email: 'Enviar notificação por email ao finalizar',
      send_email_warning: 'Ao ativar esta opção, o email do corte será reenviado à loja com os novos valores',
      pending_overrides: 'Novas cobranças/descontos a adicionar',
      original_value: 'Original',
      reset_field: 'Restaurar valor original',
      type_charge: 'Cobrança',
      type_discount: 'Desconto',
      confirm: 'Recalcular',
      next: 'Seguinte',
      back: 'Voltar',
      recalculating: 'Recalculando corte...',
      completed: 'Recálculo completado',
      success_message: 'O corte foi recalculado com sucesso',
      result_summary: 'Resumo das alterações',
      result_total: 'Total sem impostos',
      result_credit: 'Créditos',
      result_tax: 'Impostos',
      result_no_changes: 'Os totais do corte não mudaram com esta configuração',
      already_in_progress: 'Já há um recálculo em progresso para este corte',
      error: 'Erro ao recalcular o corte',
      progress_error: 'Erro ao obter o progresso',
      timeout_error: 'O recálculo está demorando demais. Por favor, verifique o status do corte e tente novamente se necessário.',
      statement_cutoff: 'Corte',
      statement_total: 'Total sem impostos',
      statement_tax: 'Impostos',
      statement_credits: 'Créditos/descontos',
      statement_pay_before: 'Pagamento até',
      statement_created_at: 'Gerado',
      statement_status_GENERATED: 'Gerado',
      statement_status_FILES_READY: 'Arquivos prontos',
      statement_status_NOTIFIED: 'Notificado',
      statement_status_NOT_NOTIFIED: 'Não notificado',
      statement_status_BILLED: 'Faturado',
      existing_services_title: 'Cobranças/descontos existentes do corte',
      existing_services_loading: 'Carregando serviços existentes...',
      existing_services_empty: 'Não há cobranças/descontos personalizados neste corte',
      existing_services_error: 'Erro ao carregar os serviços existentes',
      edit_action: 'Editar',
      remove_action: 'Remover',
      save_edit_action: 'Salvar',
      cancel_edit_action: 'Cancelar',
      marked_for_removal: 'Marcado para remover',
      undo_action: 'Desfazer',
      edited_label: 'Editado',
      stages: {
        validation: 'Validando configuração...',
        processing: 'Recalculando cobranças...',
        completing: 'Finalizando...',
      },
    },
    configuration_history: {
      title: 'Histórico de alterações',
      event: 'Evento',
      details: 'Detalhes',
      config_statement: 'Config / Corte',
      user: 'Usuário',
      date: 'Data',
      system_user: 'Sistema',
      no_history: 'Não há histórico de alterações disponível',
      refresh: 'Atualizar',
      event_CONFIGURATION_CREATED: 'Configuração criada',
      event_CONFIGURATION_REPLACED: 'Configuração substituída',
      event_CONFIGURATION_DELETED: 'Configuração excluída',
      event_CONFIGURATION_DISABLED: 'Configuração desativada',
      event_STATEMENT_GENERATED: 'Corte gerado',
      event_STATEMENT_RECALCULATED: 'Corte recalculado',
      event_CUSTOM_SERVICE_ADDED: 'Cobrança/desconto adicionado',
      event_CUSTOM_SERVICE_EDITED: 'Cobrança/desconto editado',
      event_CUSTOM_SERVICE_REMOVED: 'Cobrança/desconto removido',
      config_id: 'Config',
      from_config: 'Config anterior',
      to_config: 'Config nova',
      valid_from: 'Vigente desde',
      valid_to: 'Vigente até',
      scenario: 'Cenário',
      scenario_standard_replacement: 'Substituição padrão',
      scenario_current_cutoff_no_billed_usages: 'Sem cobranças no período atual — excluída',
      scenario_current_cutoff_preserved_for_analysis: 'Com cobranças no período atual — preservada',
      service_title: 'Título',
      amount: 'Valor',
      description: 'Descrição',
      source: 'Origem',
      source_standalone: 'Criação direta',
      source_recalculation: 'Durante recálculo',
      statement_id: 'Corte',
      services_count: 'Serviços criados',
      previous_config: 'Config prévia',
      reason: 'Razão',
      reason_manual_deletion: 'Exclusão manual',
      reason_replaced_during_current_cutoff: 'Substituída durante período atual',
      reason_unused_future_configuration_cleanup: 'Limpeza de config futura não utilizada',
      deleted_config: 'Config excluída',
      restored_valid_to: 'Vigência restaurada para',
      replaced_by_config: 'Substituída pela config',
      deleted_during_replacement: 'Excluída durante substituição da config',
      future_configs_deleted: 'Configs futuras excluídas',
      none: 'Nenhuma',
      usages_count: 'Cobranças incluídas',
      cutoff_date: 'Data de corte',
      total_before: 'Total antes',
      total_after: 'Total depois',
      credit_before: 'Crédito antes',
      credit_after: 'Crédito depois',
      tax_before: 'Imposto antes',
      tax_after: 'Imposto depois',
      overrides_applied: 'Ajustes aplicados',
      service_id: 'Serviço ID',
    },
    tabTitles: {
      billing_date: 'Data de faturamento',
      storage: 'Armazenamento',
      pick_and_pack: 'Pick and Pack',
      shipping_label: 'Envios nacionais',
      international_shipping_label: 'Envios internacionais',
      replenishment: 'Recebimento de inventário',
      returns: 'Retornos',
      work_orders: 'Maquilas',
      difal: 'Difal',
      shipping_insurance: 'Seguro de envio',
      packing_material: 'Materiais de embalagem',
      tech_fee: 'Tech Fee',
      natura_shipping_label: 'Natura - Guia de Envio',
      natura_additional_label: 'Natura - Guia Adicional',
      natura_pick_and_pack: 'Natura - Pick and Pack',
    },
    ongoing: 'Em andamento',
    billed: 'Anterior',
    future: 'Futura',
    duplicate_configuration: 'Duplicar configuração de cobrança',
    show_configuration: 'Ver configuração de cobrança',
    store_billing_config: {
      cutoff_interval: {
        title: 'Frequência do corte',
        options: {
          YEAR: 'Anual',
          MONTH: 'Mensal',
          WEEK: 'Semanal',
        },
      },
    },
    range_billing_price_config_table: {
      errors: {
        MISSING_FROM_VALUE: 'Insira um valor',
        MISSING_TO_VALUE: 'Insira um valor',
        MISSING_PRICE_VALUE: 'Insira um preço',
        MISSING_UNIT_VALUE: 'Selecione uma unidade',
        FROM_IS_GREATER_THAN_TO: "'Deve ser menor que 'Até'",
        FROM_AND_TO_ARE_EQUAL: "'Deve ser menor que 'Até'",
        EXCESS_IS_ONLY_ALLOWED_AT_END: "'Excesso' só pode ser o último elemento",
        MISSING_PRICE_MODE: '',
        INVALID_UNIT_VALUE: 'Selecione uma unidade',
      },
      unit_options: {
        PER_UNIT: 'Cobrança por peça',
        TOTAL: 'Cobrança total',
        EXCESS_PER_UNIT: 'Cobrança extra por peça excedida',
        EXCESS_TOTAL: 'Cobrança extra fixa por excesso',
      },
      last_row_placeholder: 'Sem limite',
    },
    table_headers: {
      from_piece: 'De peça',
      to_piece: 'Até peça',
      from_weight: 'De kg',
      to_weight: 'Até kg',
      price: 'Preço',
      percentage: 'Porcentagem',
      unit: 'Unidade de cobrança',
      package: 'Pacote',
      packing_material: 'Material de embalagem',
      location_type: 'Tipo de localização',
      tariff: 'Tarifa por localização',
      NORTH_AMERICA: 'Preço América do Norte',
      LATIN_AMERICA: 'Preço América Latina',
      CARIBBEAN: 'Preço Caribe',
      EUROPE: 'Preço Europa',
      ASIA: 'Preço Ásia',
      AFRICA: 'Preço África',
    },
    pick_and_pack_services: {
      picking_title: 'Picking',
      insert_title: 'Itens promocionais',
      serial_number_title: 'Controle de saída por número de série',
      fragile_title: 'Embalagem de pacote frágil',
      packages_title: 'Embalagens',
      package_title: {
        parcel_bag: 'Saco de encomenda',
        jiffy_envelope: 'Envelope Jiffy',
        cubbo_box: 'Caixa Cubbo',
        customer_box: 'Caixa do cliente',
      },
      picking_unit_options: {
        PER_UNIT: 'Cobrança por peça',
        TOTAL: 'Cobrança por pedido',
        EXCESS_PER_UNIT: 'Cobrança extra por peça excedida',
        EXCESS_TOTAL: 'Cobrança extra fixa por excesso',
      },
      package_unit_options: {
        TOTAL: 'Cobrança por pacote',
      },
      fragile_picking_unit_options: {
        TOTAL: 'Cobrança por pacote',
      },
    },
    picking_productivities: {
      title: 'Produtividades de Picking',
      subtitle: 'Torre de Controle de Produtividade',
      active_pickers_today: 'Pickers Ativos Hoje',
      active_pickers_last_hour: 'Pickers Ativos Última Hora',
      total_items_24h: 'Total Itens 24h',
      avg_items_per_interval: 'Média Itens/Intervalo',
      productivity_score: 'Pontuação Produtividade',
      view_by_day: 'Ver por Dia',
      view_by_hour: 'Ver por Hora',
      view_by_10min: 'Ver por 10 Minutos',
      insights: 'Insights Gerais',
      picker_performance: 'Desempenho por Picker',
      hourly_breakdown: 'Detalhamento por Hora',
      interval_breakdown: 'Detalhamento por Intervalos',
      no_data: 'Não há dados disponíveis',
      loading: 'Carregando...',
      error: 'Erro ao carregar dados',
      retry: 'Tentar Novamente',
    },
    billing_storage_table: {
      STORAGE_BY_LOCATION: 'Cobrança por localização',
      STORAGE_BY_PRODUCT: 'Cobrança por peça armazenada',
      missing_picking_standard_error: 'ERRO: Localização PICKING STANDARD inexistente',
      category_codes: {
        PICKING_STANDARD: 'Regular',
        LOST: 'Perdidos',
        DAMAGED: 'Danificados',
        PALLET: 'Palete',
        RECEPTION: 'Recepção',
        PRESALE: 'Pré-venda',
        RELOCATION: 'Recolocação',
        OFF_PREMISES: 'Fora do local',
        PICKING_MINIBIN: 'Picking minibin',
        PULMAO: 'Pulmão',
        CURVA_A: 'Curva A',
        ESTANTE: 'Estante',
        FLOW_RACK: 'Flow rack',
        CESTO: 'Cesto',
        PRATELEIRA_LONGARINA: 'Prateleira longarina',
        CAIXOTE_GDG: 'Caixote GDG',
        PRATELEIRA_NATURA: 'Prateleira',
        PORTA_PALLET: 'Porta-palete',
        MINI_CAIXOTE: 'Mini-caixote',
        PRATELEIRA_G: 'Prateleira grande',
        PRATELEIRA_M: 'Prateleira média',
        PRATELEIRA_P: 'Prateleira pequena',
        CAIXA_PLASTICA: 'Caixa plástica',
        CAIXA_BIN: 'Caixa bin',
        MINI_RACK: 'Mini rack',
      },
      calculated_tariff_tooltip: 'Valor calculado com base no preço definido da localização regular',
      tariff_error_message: 'Insira a tarifa',
      units: 'localização/mês',
    },
    billing_stroage_table_by_unit: {
      unit_options: {
        PER_UNIT: 'Cobrança por peça armazenada',
      },
    },
    replenishment_services: {
      replenishment_title: 'Recebimento de peças regulares',
      replenishment_lots_title: 'Recebimento de peças com controle de lote',
      unit_options: {
        PER_UNIT: 'Cobrança por peça recebida',
        TOTAL: 'Cobrança por recebimento',
        EXCESS_PER_UNIT: 'Cobrança extra por peça excedida',
        EXCESS_TOTAL: 'Cobrança extra fixa por excesso',
      },
    },
    minimum_fee_services: {
      minimum_fee_title: 'Faturamento mínimo',
      amount_label: 'Valor mínimo mensal',
      add: 'Adicionar faturamento mínimo',
      remove: 'Remover faturamento mínimo',
      helper: 'Se o faturamento do mês da loja ficar abaixo deste valor, a loja paga a diferença.',
      errors: {
        INVALID_AMOUNT: 'Informe um valor maior que 0',
      },
    },
    difal_services: {
      difal_title: 'Difal',
      unit_options: {
        TOTAL: 'Cobrança por pedido',
      },
    },
    shipping_insurance_services: {
      shipping_insurance_title: 'Seguro de envio',
      unit_options: {
        TOTAL: 'Cobrança por pedido',
      },
    },
    packing_material_services: {
      packing_material_title: 'Materiais de empacotamiento',
      packing_material_codes: {
        BUBBLE_WRAP: 'Plástico bolha',
        CORN_EXTRUDATE: 'Extrusado de milho',
        KRAFT_PAPER: 'Papel Kraft',
        KRAFT_PAPER_AND_BUBBLE_WRAP: 'Papel Kraft + Plástico bolha',
      },
      unit_options: {
        TOTAL: 'Cobrança por pacote',
      },
    },
    return_services: {
      return_order_title: 'Recebimento de peças regulares',
      return_order_lots_title: 'Recebimento de peças com controle de lote',
      return_shipping_label_title: 'Guias de retorno',
      unit_options: {
        PER_UNIT: 'Cobrança por peça recebida',
        TOTAL: 'Cobrança por recebimento',
        EXCESS_PER_UNIT: 'Cobrança extra por peça excedida',
        EXCESS_TOTAL: 'Cobrança extra fixa por excesso',
      },
      return_label_unit_options: {
        TOTAL: 'Cobrança por guia',
        EXCESS_PER_UNIT: 'Cobrança extra por quilo excedido',
      },
    },
    shipping_method_prices: {
      extended_zone_row: 'zona estendida',
      import_extended_zone_filled: '{{count}} zonas estendidas preenchidas.',
      import_shipping_method_note:
        'Toda zona que estava no arquivo passou a ter preço próprio desta transportadora. Para manter uma zona no preço padrão, use "Usar preço padrão" nela ou apague a coluna antes de importar.',
      excess_row: 'adicional por kg extra',
      import_error_unordered_weight_ranges:
        'As faixas de peso do arquivo estão fora de ordem na linha {{row}}: cada faixa precisa terminar depois da anterior.',
      import_csv: 'Importar CSV',
      download_template: 'Exportar tabela atual (CSV)',
      import_filled: '{{count}} zonas preenchidas nesta aba. Revise e salve a configuração para aplicar.',
      import_not_covered: 'Zonas ignoradas, não fazem parte desta aba: {{zones}}',
      import_invalid: 'Zonas ignoradas, com preço vazio, inválido ou ambíguo (para R$ 1.200, escreva 1200 ou 1.200,00): {{zones}}',
      import_invalid_extended_zone: 'Zona estendida não importada nestas zonas, com preço inválido ou ambíguo (fica o valor anterior): {{zones}}',
      import_ignored_columns: 'Colunas ignoradas, não são zonas: {{columns}}',
      import_error_no_zone_columns: 'Nenhuma coluna do arquivo é uma zona. Use o modelo: Weight min; Weight max; SP-CAP; SP-INT; ...',
      import_error_no_weight_ranges: 'O arquivo não tem nenhuma faixa de peso.',
      import_error_unreadable_weight_row: 'O peso da linha {{row}} não é um número: corrija a faixa (ex.: 0,5) para não juntar os preços com a faixa seguinte.',
      default_tab: 'Padrão',
      not_added_notice: 'As zonas não adicionadas nesta transportadora usam o preço padrão.',
      remove_confirm: 'Todos os preços desta transportadora serão removidos e as zonas voltarão a usar o preço padrão.',
      cancel: 'Cancelar',
      select_shipping_method: 'Selecione uma transportadora',
      add: 'Adicionar preço por transportadora',
      remove: 'Remover preços da transportadora',
      use_default: 'Usar preço padrão',
      set_price: 'Definir preço',
      no_longer_covered: 'a transportadora não cobre mais esta zona',
      uses_default: 'Usa o preço padrão',
      loading: 'Carregando transportadoras...',
      load_error: 'Não foi possível carregar as transportadoras do armazém.',
    },
    tech_fee_services: {
      order_tech_fee_title: 'Tech Fee por pedido',
      return_tech_fee_title: 'Tech Fee por retorno',
      order_unit_options: {
        TOTAL: 'Cobrança por pedido',
      },
      return_unit_options: {
        TOTAL: 'Cobrança por retorno',
      },
      channel_prices: {
        title: 'Preços por canal de venda (opcional)',
        description: 'Os canais sem preço próprio são cobrados com o preço geral acima.',
        headers: {
          channel: 'Canal de venda',
          business_type: 'Tipo de negócio',
          price: 'Preço',
        },
        select_channel: 'Selecione um canal',
        select_business_type: 'Selecione um tipo',
        add_channel: '+ Adicionar canal',
        loading_channels: 'Carregando canais...',
        load_error: 'Não foi possível carregar os canais de venda. Recarregue a página para configurar preços por canal.',
        mixed_store_hint: 'Esta loja vende D2C e B2B, então cada canal precisa do preço para os dois.',
        business_types: {
          d2c: 'D2C',
          b2b: 'B2B',
          not_applicable: 'Não se aplica',
        },
        errors: {
          channel_required: 'Selecione um canal',
          price_required: 'Informe um preço',
          duplicated_row: 'Já existe uma linha para este canal e tipo de negócio',
          channel_unavailable: 'Este canal não está disponível para esta loja',
          business_type_required: 'Selecione o tipo de negócio',
          business_type_pair_required: 'Este canal precisa de preço para D2C e para B2B',
        },
      },
    },
    work_orders_services: {
      work_order_title: 'Maquilas',
      unit_options: {
        PER_UNIT: 'Cobrança por pessoa/dia',
      },
    },
    national_shipping_label_services: {
      titles: {
        SUPER_SAVER: 'Super saver',
        LOCAL: 'Local',
        PREMIUM: 'Premium',
        ECONOMY: 'Econômico',
        PICKUP: 'Recolhimento no depósito',
        GROUND_SP_CAP: 'Ground SP Capital',
        GROUND_SP_INT: 'Ground SP Interior',
        GROUND_RJ_CAP: 'Ground RJ Capital',
        GROUND_RJ_INT: 'Ground RJ Interior',
        GROUND_ES_CAP: 'Ground ES Capital',
        GROUND_ES_INT: 'Ground ES Interior',
        GROUND_MG_CAP: 'Ground MG Capital',
        GROUND_MG_INT: 'Ground MG Interior',
        GROUND_BA_CAP: 'Ground BA Capital',
        GROUND_BA_INT: 'Ground BA Interior',
        GROUND_SE_CAP: 'Ground SE Capital',
        GROUND_SE_INT: 'Ground SE Interior',
        GROUND_PE_CAP: 'Ground PE Capital',
        GROUND_PE_INT: 'Ground PE Interior',
        GROUND_AL_CAP: 'Ground AL Capital',
        GROUND_AL_INT: 'Ground AL Interior',
        GROUND_PB_CAP: 'Ground PB Capital',
        GROUND_PB_INT: 'Ground PB Interior',
        GROUND_RN_CAP: 'Ground RN Capital',
        GROUND_RN_INT: 'Ground RN Interior',
        GROUND_CE_CAP: 'Ground CE Capital',
        GROUND_CE_INT: 'Ground CE Interior',
        GROUND_PI_CAP: 'Ground PI Capital',
        GROUND_PI_INT: 'Ground PI Interior',
        GROUND_MA_CAP: 'Ground MA Capital',
        GROUND_MA_INT: 'Ground MA Interior',
        GROUND_PA_CAP: 'Ground PA Capital',
        GROUND_PA_INT: 'Ground PA Interior',
        GROUND_AP_CAP: 'Ground AP Capital',
        GROUND_AP_INT: 'Ground AP Interior',
        GROUND_AM_CAP: 'Ground AM Capital',
        GROUND_AM_INT: 'Ground AM Interior',
        GROUND_RR_CAP: 'Ground RR Capital',
        GROUND_RR_INT: 'Ground RR Interior',
        GROUND_AM_INT_2: 'Ground AM Interior 2',
        GROUND_AC_CAP: 'Ground AC Capital',
        GROUND_AC_INT: 'Ground AC Interior',
        GROUND_DF_CAP: 'Ground DF Capital',
        GROUND_DF_INT: 'Ground DF Interior',
        GROUND_GO_CAP: 'Ground GO Capital',
        GROUND_DF_INT_2: 'Ground DF Interior 2',
        GROUND_GO_CAP_2: 'Ground GO Capital 2',
        GROUND_GO_INT: 'Ground GO Interior',
        GROUND_RO_CAP: 'Ground RO Capital',
        GROUND_RO_INT: 'Ground RO Interior',
        GROUND_TO_CAP: 'Ground TO Capital',
        GROUND_TO_INT: 'Ground TO Interior',
        GROUND_MT_CAP: 'Ground MT Capital',
        GROUND_MT_INT: 'Ground MT Interior',
        GROUND_RO_INT_2: 'Ground RO Interior 2',
        GROUND_RO_INT_3: 'Ground RO Interior 3',
        GROUND_MS_CAP: 'Ground MS Capital',
        GROUND_MS_INT: 'Ground MS Interior',
        GROUND_PR_CAP: 'Ground PR Capital',
        GROUND_PR_INT: 'Ground PR Interior',
        GROUND_SC_CAP: 'Ground SC Capital',
        GROUND_SC_INT: 'Ground SC Interior',
        GROUND_RS_CAP: 'Ground RS Capital',
        GROUND_RS_INT: 'Ground RS Interior',
        /*
                EXPRESS_SP_CAP: "Express SP Capital",
                EXPRESS_SP_INT: "Express SP Interior",
                EXPRESS_RJ_CAP: "Express RJ Capital",
                EXPRESS_RJ_INT: "Express RJ Interior",
                EXPRESS_ES_CAP: "Express ES Capital",
                EXPRESS_ES_INT: "Express ES Interior",
                EXPRESS_MG_CAP: "Express MG Capital",
                EXPRESS_MG_INT: "Express MG Interior",
                EXPRESS_BA_CAP: "Express BA Capital",
                EXPRESS_BA_INT: "Express BA Interior",
                EXPRESS_SE_CAP: "Express SE Capital",
                EXPRESS_SE_INT: "Express SE Interior",
                EXPRESS_PE_CAP: "Express PE Capital",
                EXPRESS_PE_INT: "Express PE Interior",
                EXPRESS_AL_CAP: "Express AL Capital",
                EXPRESS_AL_INT: "Express AL Interior",
                EXPRESS_PB_CAP: "Express PB Capital",
                EXPRESS_PB_INT: "Express PB Interior",
                EXPRESS_RN_CAP: "Express RN Capital",
                EXPRESS_RN_INT: "Express RN Interior",
                EXPRESS_CE_CAP: "Express CE Capital",
                EXPRESS_CE_INT: "Express CE Interior",
                EXPRESS_PI_CAP: "Express PI Capital",
                EXPRESS_PI_INT: "Express PI Interior",
                EXPRESS_MA_CAP: "Express MA Capital",
                EXPRESS_MA_INT: "Express MA Interior",
                EXPRESS_PA_CAP: "Express PA Capital",
                EXPRESS_PA_INT: "Express PA Interior",
                EXPRESS_AP_CAP: "Express AP Capital",
                EXPRESS_AP_INT: "Express AP Interior",
                EXPRESS_AM_CAP: "Express AM Capital",
                EXPRESS_AM_INT: "Express AM Interior",
                EXPRESS_RR_CAP: "Express RR Capital",
                EXPRESS_RR_INT: "Express RR Interior",
                EXPRESS_AM_INT_2: "Express AM Interior 2",
                EXPRESS_AC_CAP: "Express AC Capital",
                EXPRESS_AC_INT: "Express AC Interior",
                EXPRESS_DF_CAP: "Express DF Capital",
                EXPRESS_DF_INT: "Express DF Interior",
                EXPRESS_GO_CAP: "Express GO Capital",
                EXPRESS_DF_INT_2: "Express DF Interior 2",
                EXPRESS_GO_CAP_2: "Express GO Capital 2",
                EXPRESS_GO_INT: "Express GO Interior",
                EXPRESS_RO_CAP: "Express RO Capital",
                EXPRESS_RO_INT: "Express RO Interior",
                EXPRESS_TO_CAP: "Express TO Capital",
                EXPRESS_TO_INT: "Express TO Interior",
                EXPRESS_MT_CAP: "Express MT Capital",
                EXPRESS_MT_INT: "Express MT Interior",
                EXPRESS_RO_INT_2: "Express RO Interior 2",
                EXPRESS_RO_INT_3: "Express RO Interior 3",
                EXPRESS_MS_CAP: "Express MS Capital",
                EXPRESS_MS_INT: "Express MS Interior",
                EXPRESS_PR_CAP: "Express PR Capital",
                EXPRESS_PR_INT: "Express PR Interior",
                EXPRESS_SC_CAP: "Express SC Capital",
                EXPRESS_SC_INT: "Express SC Interior",
                EXPRESS_RS_CAP: "Express RS Capital",
                EXPRESS_RS_INT: "Express RS Interior"
                */
      },
      extended_zone_titles: {
        SUPER_SAVER: 'Zona estendida Super saver',
        LOCAL: 'Zona estendida Local',
        PREMIUM: 'Zona estendida Premium',
        ECONOMY: 'Zona estendida Econômica',
        GROUND_SP_CAP: 'Zona estendida Ground SP Capital',
        GROUND_SP_INT: 'Zona estendida Ground SP Interior',
        GROUND_RJ_CAP: 'Zona estendida Ground RJ Capital',
        GROUND_RJ_INT: 'Zona estendida Ground RJ Interior',
        GROUND_ES_CAP: 'Zona estendida Ground ES Capital',
        GROUND_ES_INT: 'Zona estendida Ground ES Interior',
        GROUND_MG_CAP: 'Zona estendida Ground MG Capital',
        GROUND_MG_INT: 'Zona estendida Ground MG Interior',
        GROUND_BA_CAP: 'Zona estendida Ground BA Capital',
        GROUND_BA_INT: 'Zona estendida Ground BA Interior',
        GROUND_SE_CAP: 'Zona estendida Ground SE Capital',
        GROUND_SE_INT: 'Zona estendida Ground SE Interior',
        GROUND_PE_CAP: 'Zona estendida Ground PE Capital',
        GROUND_PE_INT: 'Zona estendida Ground PE Interior',
        GROUND_AL_CAP: 'Zona estendida Ground AL Capital',
        GROUND_AL_INT: 'Zona estendida Ground AL Interior',
        GROUND_PB_CAP: 'Zona estendida Ground PB Capital',
        GROUND_PB_INT: 'Zona estendida Ground PB Interior',
        GROUND_RN_CAP: 'Zona estendida Ground RN Capital',
        GROUND_RN_INT: 'Zona estendida Ground RN Interior',
        GROUND_CE_CAP: 'Zona estendida Ground CE Capital',
        GROUND_CE_INT: 'Zona estendida Ground CE Interior',
        GROUND_PI_CAP: 'Zona estendida Ground PI Capital',
        GROUND_PI_INT: 'Zona estendida Ground PI Interior',
        GROUND_MA_CAP: 'Zona estendida Ground MA Capital',
        GROUND_MA_INT: 'Zona estendida Ground MA Interior',
        GROUND_PA_CAP: 'Zona estendida Ground PA Capital',
        GROUND_PA_INT: 'Zona estendida Ground PA Interior',
        GROUND_AP_CAP: 'Zona estendida Ground AP Capital',
        GROUND_AP_INT: 'Zona estendida Ground AP Interior',
        GROUND_AM_CAP: 'Zona estendida Ground AM Capital',
        GROUND_AM_INT: 'Zona estendida Ground AM Interior',
        GROUND_AM_INT_2: 'Zona estendida Ground AM Interior 2',
        GROUND_RR_CAP: 'Zona estendida Ground RR Capital',
        GROUND_RR_INT: 'Zona estendida Ground RR Interior',
        GROUND_AC_CAP: 'Zona estendida Ground AC Capital',
        GROUND_AC_INT: 'Zona estendida Ground AC Interior',
        GROUND_DF_CAP: 'Zona estendida Ground DF Capital',
        GROUND_DF_INT: 'Zona estendida Ground DF Interior',
        GROUND_DF_INT_2: 'Zona estendida Ground DF Interior 2',
        GROUND_GO_CAP: 'Zona estendida Ground GO Capital',
        GROUND_GO_CAP_2: 'Zona estendida Ground GO Capital 2',
        GROUND_GO_INT: 'Zona estendida Ground GO Interior',
        GROUND_RO_CAP: 'Zona estendida Ground RO Capital',
        GROUND_RO_INT: 'Zona estendida Ground RO Interior',
        GROUND_RO_INT_2: 'Zona estendida Ground RO Interior 2',
        GROUND_RO_INT_3: 'Zona estendida Ground RO Interior 3',
        GROUND_TO_CAP: 'Zona estendida Ground TO Capital',
        GROUND_TO_INT: 'Zona estendida Ground TO Interior',
        GROUND_MT_CAP: 'Zona estendida Ground MT Capital',
        GROUND_MT_INT: 'Zona estendida Ground MT Interior',
        GROUND_MS_CAP: 'Zona estendida Ground MS Capital',
        GROUND_MS_INT: 'Zona estendida Ground MS Interior',
        GROUND_PR_CAP: 'Zona estendida Ground PR Capital',
        GROUND_PR_INT: 'Zona estendida Ground PR Interior',
        GROUND_SC_CAP: 'Zona estendida Ground SC Capital',
        GROUND_SC_INT: 'Zona estendida Ground SC Interior',
        GROUND_RS_CAP: 'Zona estendida Ground RS Capital',
        GROUND_RS_INT: 'Zona estendida Ground RS Interior',
        /*
                EXPRESS_SP_CAP: "Zona estendida Express SP Capital",
                EXPRESS_SP_INT: "Zona estendida Express SP Interior",
                EXPRESS_RJ_CAP: "Zona estendida Express RJ Capital",
                EXPRESS_RJ_INT: "Zona estendida Express RJ Interior",
                EXPRESS_ES_CAP: "Zona estendida Express ES Capital",
                EXPRESS_ES_INT: "Zona estendida Express ES Interior",
                EXPRESS_MG_CAP: "Zona estendida Express MG Capital",
                EXPRESS_MG_INT: "Zona estendida Express MG Interior",
                EXPRESS_BA_CAP: "Zona estendida Express BA Capital",
                EXPRESS_BA_INT: "Zona estendida Express BA Interior",
                EXPRESS_SE_CAP: "Zona estendida Express SE Capital",
                EXPRESS_SE_INT: "Zona estendida Express SE Interior",
                EXPRESS_PE_CAP: "Zona estendida Express PE Capital",
                EXPRESS_PE_INT: "Zona estendida Express PE Interior",
                EXPRESS_AL_CAP: "Zona estendida Express AL Capital",
                EXPRESS_AL_INT: "Zona estendida Express AL Interior",
                EXPRESS_PB_CAP: "Zona estendida Express PB Capital",
                EXPRESS_PB_INT: "Zona estendida Express PB Interior",
                EXPRESS_RN_CAP: "Zona estendida Express RN Capital",
                EXPRESS_RN_INT: "Zona estendida Express RN Interior",
                EXPRESS_CE_CAP: "Zona estendida Express CE Capital",
                EXPRESS_CE_INT: "Zona estendida Express CE Interior",
                EXPRESS_PI_CAP: "Zona estendida Express PI Capital",
                EXPRESS_PI_INT: "Zona estendida Express PI Interior",
                EXPRESS_MA_CAP: "Zona estendida Express MA Capital",
                EXPRESS_MA_INT: "Zona estendida Express MA Interior",
                EXPRESS_PA_CAP: "Zona estendida Express PA Capital",
                EXPRESS_PA_INT: "Zona estendida Express PA Interior",
                EXPRESS_AP_CAP: "Zona estendida Express AP Capital",
                EXPRESS_AP_INT: "Zona estendida Express AP Interior",
                EXPRESS_AM_CAP: "Zona estendida Express AM Capital",
                EXPRESS_AM_INT: "Zona estendida Express AM Interior",
                EXPRESS_AM_INT_2: "Zona estendida Express AM Interior 2",
                EXPRESS_RR_CAP: "Zona estendida Express RR Capital",
                EXPRESS_RR_INT: "Zona estendida Express RR Interior",
                EXPRESS_AC_CAP: "Zona estendida Express AC Capital",
                EXPRESS_AC_INT: "Zona estendida Express AC Interior",
                EXPRESS_DF_CAP: "Zona estendida Express DF Capital",
                EXPRESS_DF_INT: "Zona estendida Express DF Interior",
                EXPRESS_DF_INT_2: "Zona estendida Express DF Interior 2",
                EXPRESS_GO_CAP: "Zona estendida Express GO Capital",
                EXPRESS_GO_CAP_2: "Zona estendida Express GO Capital 2",
                EXPRESS_GO_INT: "Zona estendida Express GO Interior",
                EXPRESS_RO_CAP: "Zona estendida Express RO Capital",
                EXPRESS_RO_INT: "Zona estendida Express RO Interior",
                EXPRESS_RO_INT_2: "Zona estendida Express RO Interior 2",
                EXPRESS_RO_INT_3: "Zona estendida Express RO Interior 3",
                EXPRESS_TO_CAP: "Zona estendida Express TO Capital",
                EXPRESS_TO_INT: "Zona estendida Express TO Interior",
                EXPRESS_MT_CAP: "Zona estendida Express MT Capital",
                EXPRESS_MT_INT: "Zona estendida Express MT Interior",
                EXPRESS_MS_CAP: "Zona estendida Express MS Capital",
                EXPRESS_MS_INT: "Zona estendida Express MS Interior",
                EXPRESS_PR_CAP: "Zona estendida Express PR Capital",
                EXPRESS_PR_INT: "Zona estendida Express PR Interior",
                EXPRESS_SC_CAP: "Zona estendida Express SC Capital",
                EXPRESS_SC_INT: "Zona estendida Express SC Interior",
                EXPRESS_RS_CAP: "Zona estendida Express RS Capital",
                EXPRESS_RS_INT: "Zona estendida Express RS Interior"
                */
      },
      unit_options: {
        TOTAL: 'Cobrança por guia',
        EXCESS_PER_UNIT: 'Cobrança extra por quilo excedido',
      },
      pickup_unit_options: {
        TOTAL: 'Cobrança por pedido',
      },
    },
    international_shipping_label_services: {
      unit_options: {
        TOTAL: 'Cobrança por guia',
        EXCESS_PER_UNIT: 'Cobrança extra por quilo excedido',
      },
    },
    natura_services: {
      shipping_label_title: 'Guia de Envio Natura Venda Direta',
      additional_label_title: 'Guia Adicional Natura Venda Direta',
      pick_and_pack_title: 'Pick and Pack Natura Venda Direta',
      shipping_unit_options: {
        TOTAL: 'Cobrança por guia',
        EXCESS_PER_UNIT: 'Cobrança extra por quilo excedido',
      },
      pick_and_pack_unit_options: {
        PER_UNIT: 'Cobrança por peça',
        TOTAL: 'Cobrança por pedido',
        EXCESS_PER_UNIT: 'Cobrança extra por peça excedida',
        EXCESS_TOTAL: 'Cobrança extra fixa por excesso',
      },
    },
    custom_services: {
      create_current_title: 'Criar cobrança/desconto adicional para o corte atual',
      create_button: 'Criar cobrança/desconto adicional',
      types: {
        discount: 'Desconto',
        charge: 'Cobrança',
      },
      no_services: 'Sem informações',
      create_custom_service: {
        init_error: 'Ocorreu um erro ao inicializar, tente novamente mais tarde',
        create_error: 'Ocorreu um erro durante a criação, tente novamente mais tarde',
        store_name: 'Loja: ',
        warehouse_name: 'Depósito: ',
        is_discount: 'É desconto?',
        title: 'Título',
        title_placeholder: 'Insira um título',
        description: 'Descrição',
        description_placeholder: 'Insira uma descrição',
        amount_discount: 'Valor do desconto',
        amount_placeholder_discount: 'Insira um valor de desconto',
        amount_charge: 'Valor da cobrança',
        amount_placeholder_charge: 'Insira um valor de cobrança',
        no_amount: 'O valor não pode ser 0',
        create_button: 'Criar serviço personalizado',
        remaining_text_length: 'Caracteres restantes disponíveis: ',
        confirm_create_dialog: {
          title_DISCOUNT: 'Criar desconto adicional',
          title_CHARGE: 'Criar cobrança adicional',
          description_DISCOUNT: 'Confirme a criação do desconto adicional para a loja {STORE_NAME} no depósito {WAREHOUSE_NAME}',
          description_CHARGE: 'Confirme a criação da cobrança adicional para a loja {STORE_NAME} no depósito {WAREHOUSE_NAME}',
          confirm_button: 'Confirmar',
          cancel_button: 'Cancelar',
        },
      },
      list_custom_services: {
        table_columns: {
          id: 'ID',
          billed_total_price: 'Valor',
          type: 'Tipo',
          title: 'Título',
          description: 'Descrição',
        },
        init_error: 'Ocorreu um erro ao inicializar, tente novamente mais tarde',
        table_filters: {
          title: 'Título',
          title_placeholder: 'Buscar por título',
          billed_total_price: 'Valor',
          greater_or_equal_than_billed_total_price: 'Maior ou igual ao valor',
          less_or_equal_than_billed_total_price: 'Menor ou igual ao valor',
          is_discount: 'É desconto',
          is_charge: 'É cobrança',
          description: 'Descrição',
        },
      },
    },
  },
  workforce: {
    tabs: {
      costs: 'Análise',
      rates: 'Tarifas',
      shifts: 'Turnos',
      schedule: 'Programação',
      operators: 'Operadores',
      attendance: 'Presença',
    },
    days: {
      sun: 'Dom',
      mon: 'Seg',
      tue: 'Ter',
      wed: 'Qua',
      thu: 'Qui',
      fri: 'Sex',
      sat: 'Sáb',
    },
    cancel: 'Cancelar',
    save: 'Salvar',
    saving: 'Salvando...',
    edit: 'Editar',
    updating: 'Atualizando...',
    errors: {
      generic: 'Ocorreu um erro.',
      save_failed: 'Não foi possível salvar.',
    },
    rates: {
      title: 'Tarifas de operadores',
      add_new: 'Nova tarifa',
      info_add_title: 'Adicionar tarifa',
      info_add_body: 'Crie uma nova tarifa vigente a partir de uma data.',
      info_fix_title: 'Corrigir tarifa',
      info_fix_body: 'A correção sobrescreve a tarifa atual sem criar histórico. Use somente para erros.',
      all_types: 'Todos os tipos',
      all_contracts: 'Todos os contratos',
      operator_type: 'Tipo de operador',
      contract: 'Contrato',
      daily_rate: 'Tarifa diária',
      extra_hour_rate: 'Tarifa hora extra',
      day_rates: 'Tarifas diurnas',
      night_rates: 'Tarifas noturnas',
      day_daily_rate: 'Tarifa dia (diária)',
      day_extra_hour_rate: 'Hora extra dia',
      night_daily_rate: 'Tarifa noite (diária)',
      night_extra_hour_rate: 'Hora extra noite',
      daily_short: 'Diária',
      extra_hour_short: 'Hora extra',
      night_seed_banner: 'As tarifas noturnas foram inicializadas com os valores diurnos — revise e ajuste se diferirem.',
      effective_from: 'Vigente a partir de',
      status: 'Status',
      status_active: 'Ativa',
      status_history: 'Histórico',
      fix_mistake: 'Corrigir',
      hide_history: 'Ocultar histórico',
      show_history: 'Ver histórico',
      empty: 'Sem tarifas configuradas.',
      add_title: 'Adicionar tarifa',
      fix_title: 'Corrigir tarifa',
      fix_warning: 'Você vai sobrescrever a tarifa atual. Esta ação não cria histórico.',
      select_operator_type: 'Selecione um tipo',
      operator_type_placeholder: 'ex. WAREHOUSE_AUXILIARY',
      operator_type_hint: 'Escolha um existente ou digite um novo. Será criado ao salvar a tarifa.',
      select_contract: 'Selecione um contrato',
      currency: 'Moeda',
      effective_from_hint: 'Os custos dos dias posteriores serão recalculados em ~1 minuto.',
      save_new: 'Salvar tarifa',
      review_fix: 'Revisar correção',
      confirm_fix: 'Confirmar correção',
      errors: {
        required: 'Campo obrigatório',
        positive: 'Deve ser maior que 0',
      },
    },
    costs: {
      title: 'Custos de operadores',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
      fix_in_rates: 'Corrigir em Tarifas →',
      empty: 'Ainda não há presença registrada no intervalo selecionado.',
      total_cost: 'Custo total',
      primary_cost: 'Custo principal',
      extra_cost: 'Custo extra',
      total_present: 'Operadores presentes',
      daily_cost: 'Custo por dia',
      breakdown: 'Detalhamento',
      breakdown_empty: 'Sem dados no intervalo.',
      operator_type: 'Tipo de operador',
      contract: 'Contrato',
      row_type: 'Tipo',
      shift_period: 'Período',
      units: 'Unidades',
      rate: 'Tarifa',
      total: 'Total',
      extra: 'Extra',
      primary: 'Principal',
      hours_ops: '{{hours}}h · {{ops}} ops',
      days: '{{days}} dias',
      no_rate_linked: 'Sem tarifa vinculada',
      errors: {
        from_before_to: 'A data inicial deve ser anterior ou igual à final.',
        max_range: 'O intervalo máximo é de {{max}} dias.',
      },
    },
    analytics: {
      title: 'Análise de presença',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
      empty: 'Ainda não há presenças registradas no intervalo selecionado.',
      kpi_present: 'Operadores presentes',
      kpi_present_hint: 'Dia: {{day}} · Noite: {{night}}',
      kpi_active_days: 'Dias com presença',
      kpi_extras_ops: 'Turnos extras',
      kpi_extras_hours: 'Horas extras',
      daily_attendance: 'Presença diária',
      breakdown: 'Detalhamento por contrato e turno',
      breakdown_empty: 'Sem dados no intervalo.',
      contract: 'Contrato',
      shift_period: 'Turno',
      operator_types: 'Tipos de operador',
      row_type: 'Tipo',
      primary: 'Principal',
      extra: 'Extra',
      present_days: 'Presenças',
      extra_ops: 'Ops. extras',
      extra_hours: 'Horas extras',
      series_day: 'Dia (principal)',
      series_night: 'Noite (principal)',
      series_unknown: 'Sem período',
      series_extras: 'Extras',
      axis_operators: 'Operadores',
      errors: {
        from_before_to: 'A data inicial deve ser anterior ou igual à final.',
        max_range: 'O intervalo máximo é de {{max}} dias.',
      },
    },
    shifts: {
      title: 'Turnos de trabalho',
      create: 'Novo turno',
      create_title: 'Criar turno',
      edit_title: 'Editar turno',
      show_inactive: 'Mostrar inativos',
      empty: 'Sem turnos configurados.',
      name: 'Nome',
      schedule_days: 'Dias',
      start_time: 'Hora de início',
      end_time: 'Hora de fim',
      is_active: 'Ativo',
      overnight_hint: 'O turno termina no dia seguinte.',
      overnight_badge: 'Noturno',
      next_day: 'dia seguinte',
      no_days: 'Sem dias',
      edit_shift: 'Editar turno',
      operators_assigned: '{{count}} operadores atribuídos',
      shift_period: 'Período do turno',
      period_day: 'Dia',
      period_night: 'Noite',
      period_hint: 'Dia: horário diurno. Noite: se o turno cai principalmente entre 22:00 e 06:00. Determina qual coluna de tarifa é aplicada ao custo.',
      help_title: 'Quando criar um novo turno ou editar um existente?',
      help_create_title: 'Crie um novo turno quando:',
      help_create_1:
        'Os horários de início ou fim mudarem daqui para a frente (por exemplo, "Manhã" passa de 8-15 para 7-14). A frequência passada permanece vinculada ao turno antigo, para que os relatórios reflitam as horas realmente trabalhadas.',
      help_create_2: 'Um novo padrão de turno é introduzido (adicionar um turno noturno, turno de fim de semana, etc.).',
      help_create_3: 'Os dias programados mudarem significativamente (Seg-Sex → Ter-Sáb).',
      help_create_note:
        'Ao criar uma substituição, desative o turno antigo (ativo: não) — o histórico de frequência permanece intacto, mas o seletor só mostra os turnos vigentes.',
      help_edit_title: 'Edite um turno existente quando:',
      help_edit_1: 'Corrigir um erro de digitação no nome ("Manha" → "Manhã").',
      help_edit_2: 'Pausar ou retomar um turno (ativar/desativar).',
      help_edit_3:
        'Corrigir um dado que estava errado desde o início (por exemplo, digitou 8:15 mas sempre foi 8:00) — é seguro, porque não há um "antes" para ser mal representado.',
      errors: {
        name_required: 'O nome é obrigatório',
        days_required: 'Selecione ao menos um dia',
        period_required: 'Selecione o período do turno (dia ou noite)',
      },
    },
    operators: {
      title: 'Operadores do armazém',
      assign: 'Atribuir operador',
      assign_title: 'Atribuir operador',
      edit_title: 'Editar operador',
      search_user: 'Buscar usuário',
      search_placeholder: 'Nome ou email...',
      all_shifts: 'Todos os turnos',
      all_types: 'Todos os tipos',
      include_inactive: 'Incluir inativos',
      empty: 'Sem operadores atribuídos.',
      name: 'Nome',
      operator_type: 'Tipo',
      contract_type: 'Contrato',
      work_shift: 'Turno',
      status: 'Status',
      active: 'Ativo',
      inactive: 'Inativo',
      select_type: 'Selecione tipo',
      select_contract: 'Selecione contrato',
      select_shift: 'Selecione turno',
      is_active: 'Ativo',
      searching: 'Buscando...',
      no_results: 'Sem resultados',
      clear: 'Limpar',
      start_date: 'Data de início',
      start_date_hint: 'Se o operador foi cadastrado depois do primeiro dia, antecipe a data de início.',
      effective_date: 'Válido a partir de',
      end_date: 'Data de desligamento',
      history: 'Histórico',
      history_current: 'atual',
      columns: {
        start_date: 'Início',
        end_date: 'Desligamento',
      },
      errors: {
        user_required: 'Você deve selecionar um usuário',
        operator_type_required: 'Selecione um tipo',
        contract_type_required: 'Selecione um contrato',
        shift_required: 'Selecione um turno',
        codes: {
          FUTURE_DATE: 'A data não pode ser posterior a hoje.',
          SHIFT_NOT_IN_WAREHOUSE: 'O turno não pertence a este armazém.',
          NO_RATE: 'Não há tarifa para este tipo e contrato nessa data.',
          BEFORE_LATEST_ASSIGNMENT: 'A data cai dentro de uma atribuição anterior do operador.',
          BEFORE_TERMINATION: 'A data é anterior ao início da última atribuição, já encerrada.',
          NOT_ACTIVE: 'O operador não tem uma atribuição ativa para encerrar.',
          BEFORE_START: 'A data de desligamento é anterior ao início da atribuição atual.',
          ATTENDANCE_AFTER_END_DATE: 'O operador tem presença registrada depois da data de desligamento. Remova essa presença primeiro.',
          ASSIGNMENT_CHANGED: 'Outra pessoa alterou o operador enquanto você salvava. Recarregue e tente de novo.',
          TERMINATED: 'O operador está desligado. Reative-o para alterar a atribuição.',
          WAREHOUSE_NOT_MEMBER: 'Você não pode gerenciar operadores de um armazém ao qual não pertence.',
        },
      },
    },
    attendance: {
      title: 'Presença',
      off_roster: 'Fora da escala nesta data',
      date: 'Data',
      no_shifts: 'Não há turnos configurados.',
      assigned_operators: 'Operadores atribuídos',
      no_assigned: 'Sem operadores atribuídos a este turno.',
      extra_shift: 'Turno extra',
      add_extra: 'Adicionar extra',
      add: 'Adicionar',
      remove: 'Remover',
      no_extras: 'Sem extras.',
      extra_hours: 'Horas extras',
      search_operator: 'Buscar operador',
      summary: '{{present}} de {{total}} presentes · {{extra}} extras',
      unsaved: 'alterações não salvas',
      unsaved_prompt: 'Há alterações não salvas. Sair mesmo assim?',
      saved: 'Presença salva',
      saved_note: 'Os custos serão recalculados em ~1 minuto.',
      overnight_hint: 'Turno noturno: registrado contra a data de início.',
      not_scheduled_title: 'Este turno não está programado para esta data',
      not_scheduled_body: 'Não há um período ativo do turno que cubra o dia {{date}}. Programe o turno primeiro para registrar presença.',
      schedule_this_shift: 'Ir para Programação',
      errors: {
        future_date: 'Não é possível registrar presença em datas futuras.',
        duplicate_operator: 'Este operador já está na lista.',
      },
    },
    schedule: {
      title: 'Programação de turnos',
      roster_until: 'até {{date}}',
      schedule_shift: 'Programar turno',
      today: 'Hoje',
      all_shifts: 'Todos os turnos',
      shift: 'Turno',
      no_shifts: 'Ainda não há turnos. Crie um turno na aba Turnos.',
      schedule_on: 'Programar este turno no {{date}}',
      always_on_tag: 'Contínuo (migração)',
      create_title: 'Programar turno',
      edit_title: 'Editar período',
      select_shift: 'Selecione um turno',
      start_date: 'De',
      end_date: 'Até',
      range_hint: 'Um período cobre um intervalo de datas. Para apenas um dia, use a mesma data em ambos os campos.',
      shift_inactive_hint: 'Este turno está desativado. Reative antes de programá-lo.',
      delete: 'Excluir período',
      confirm_delete: 'Confirmar exclusão',
      delete_warning: 'Excluir este período impede o registro de presença nessas datas. A ação falha se já houver registros de presença.',
      period_roster: 'Roster do período',
      edit_period: 'Editar período',
      roster_hint:
        'Os operadores padrão vêm do turno atribuído a cada operador. Exclua quem não estará neste período (férias, ausência) ou adicione operadores fora do turno (cobertura temporária).',
      default_operators: 'Padrão',
      no_defaults: 'Não há operadores atribuídos a este turno por padrão.',
      added_operators: 'Adicionados a este período',
      no_added: 'Sem adicionados.',
      add_operator: 'Adicionar operador',
      included: 'Incluído',
      excluded: 'Excluído',
      errors: {
        shift_required: 'Selecione um turno',
        start_required: 'Selecione uma data de início',
        end_required: 'Selecione uma data de fim',
        end_before_start: 'A data final deve ser posterior ou igual à inicial.',
      },
    },
  },
  work_orders: {
    work_order_details: {
      work_orders: 'Maquilas',
      work_order_details: 'Detalhes da solicitação de maquila',
      work_order_number: 'Nº de maquila',
      solicitant: 'Solicitante',
      work_order_status: 'Estado da maquila',
      on_date: 'Em',
      comments_to_the_brand: 'Comentários para a marca',
      next_status: 'Ao salvar os dados, o estado da maquila será atualizado para',
      processing_work_order: 'Processando maquila',
      product_origin: 'Origem do material necessário',
      rem_order: 'Retirada de inventário',
      no_rem_order: 'Esta maquila não possui pedido de retirada de inventário',
      work_order: 'Solicitação de maquila',
      work_order_type: 'Tipo de processo',
      notes: 'Notas',
      instruction: 'Instrução',
      activity: 'Atividade',
      replenishment: 'Entrada de produto maquilado',
      replenishment_id: 'Recibo de inventário de produto maquilado',
      replenishment_note: 'A partir deste recibo de inventário, você pode acompanhar o progresso da entrada do produto maquilado em seu inventário',
      resolve_order: 'Resolver solicitação',
      notification_message: {
        success_update_message: 'Estado da maquila atualizado com sucesso',
        error_update_message: 'Erro ao atualizar estado da maquila',
      },
      work_order_statuses: {
        REQUESTED: 'Solicitada',
        IN_VALIDATION: 'Em validação',
        SCHEDULED: 'Próxima a iniciar',
        IN_PROGRESS: 'Em progresso',
        COMPLETED: 'Completada',
        REJECTED: 'Rejeitada',
        CANCELED: 'Cancelada',
      },
      work_order_types: {
        LABELING_PLASTISEAL: 'De etiquetagem ou plastificação',
        PRODUCT_VALIDATION: 'De validação de produto',
        KIT_ASSEMBLY_SHRINKWRAP: 'De montagem de kits e/ou aplicação de termoencolhimento',
        PACKAGING: 'De embalagem',
        PRODUCT_SEGREGATION: 'De segregação de produto',
      },
      work_order_product_origin: {
        ALL_INVENTORY_AT_WAREHOUSE: 'Todo o material está armazenado no meu inventário na Cubbo disponível para venda',
        MATERIAL_IN_TRANSIT_TO_WAREHOUSE: 'O material está a caminho do armazém',
        PARTIAL_MATERIAL_INVENTORY_IN_TRANSIT_TO_WAREHOUSE: 'Parte do material está armazenado na Cubbo e parte está a caminho do armazém',
      },
      work_order_card: {
        update_work_order_status: 'Atualizar status da maquila',
        save_button: 'Salvar atualização',
        start_progress_button: 'Iniciar progresso',
        complete_work_order_button: 'Concluir maquila',
        reject_work_order_button: 'Rejeitar maquila',
        complete_the_information_requested: 'Complete as informações quando desejar iniciar a validação operacional da maquila',
        validate_order: 'A solicitação possui tudo o que é necessário para passar pela validação operacional?',
        confirm_validation: 'Sim, aceitar solicitação',
        reject_validation: 'Não, rejeitar solicitação',
        complete_the_information_in_validation: 'Complete as informações assim que a validação da maquila for concluída',
        necessary_pieces: 'Todos as peças necessárias estão disponíveis para processamento da maquila?',
        estimated_operator_quantity: 'Quantas pessoas se estima que serão designadas para processar a maquila?',
        estimated_labor_days_quantity: 'Dias estimados de processamento',
        scheduled_order: 'Esta solicitação foi agendada para próxima a iniciar',
        complete_the_information_in_progress: 'Complete as informações assim que a maquila for concluída',
        confirm_operator_quantity: 'Confirme o total de pessoas usadas na maquila',
        estimated_labor_days_quantity: 'Confirme os dias estimados de processamento',
        completed_work_order: 'Esta maquila foi concluída',
        rejected_work_order: 'Esta maquila foi rejeitada',
        canceled_work_order: 'Esta maquila foi cancelada',
        files_placeholder: 'Clique aqui ou arraste seus arquivos PDF, Excel ou imagens',
      },
    },
    work_order_list: {
      header: {
        work_order_id: 'Nº MAQUILA',
        customer: 'CLIENTE',
        work_order_type: 'TIPO',
        status: 'ESTADO',
        created_at: 'DATA DE SOLICITAÇÃO',
      },
      filters: {
        work_order_id: 'Nº maquila',
        status: 'Estado',
        work_order_type: 'Tipo de maquila',
      },
      footer: {
        no_work_orders: 'Não há maquilas para mostrar',
        work_order: 'maquilas',
      },
      queued: 'Em fila',
      view_work_order: 'Ver maquila',
      on_date: 'Em',
    },
  },
  shipping_packages: {
    title: 'Caixas',
    add_package: 'Criar caixa',
    edit_package: 'Editar caixa',
    delete_package: 'Desativar caixa',
    confirm_delete: 'Tem certeza de que deseja desativar esta caixa?',
    delete_warning: 'A caixa será desativada.',
    package_deleted: 'Caixa desativada com sucesso',
    package_created: 'Caixa criada com sucesso',
    package_updated: 'Caixa atualizada com sucesso',
    package_restored: 'Caixa reativada com sucesso',
    restore_package: 'Reativar caixa',
    confirm_restore: 'Tem certeza de que deseja reativar esta caixa?',
    restore_warning: 'A caixa será reativada.',
    empty_table: 'Não há caixas para mostrar',
    footer_text: 'caixas',
    form: {
      name: 'Nome',
      name_placeholder: 'Nome da caixa',
      length: 'Comprimento (cm)',
      width: 'Largura (cm)',
      height: 'Altura (cm)',
      calculating: 'Calculando...',
      bar_code: 'Código de barras',
      bar_code_placeholder: 'Código de barras opcional',
      package_type: 'Tipo de pacote',
      volume_liters: 'Volume (litros)',
      cost: 'Custo',
      weight_kg: 'Peso (kg)',
      volumetric_weight: 'Peso volumétrico',
      store: 'Loja',
      store_placeholder: 'Buscar loja...',
      store_selected: 'Loja selecionada',
      save: 'Salvar',
      cancel: 'Cancelar',
      create: 'Criar',
      update: 'Atualizar',
      weight_will_be_overwritten: 'O peso volumétrico será atualizado ao salvar',
    },
    headers: {
      name: 'Nome',
      dimensions: 'Dimensões (cm)',
      length: 'Comprimento',
      width: 'Largura',
      height: 'Altura',
      package_type: 'Tipo',
      store: 'Loja',
      bar_code: 'Código de barras',
      volume_liters: 'Volume (L)',
      weight_kg: 'Peso (kg)',
      volumetric_weight: 'Peso volumétrico',
      cost: 'Custo',
      actions: 'Ações',
    },
    package_types: {
      parcel_bag: 'Bolsa de encomenda',
      jiffy_envelope: 'Jiffy',
      cubbo_box: 'Caixa Cubbo',
      packageless: 'Sem embalagem',
      customer_box: 'Caixa do cliente',
    },
    filters: {
      package_type: 'Tipo de pacote',
      store: 'Loja',
      name: 'Nome da caixa',
      store_name: 'Nome da loja',
      bar_code: 'Código de barras',
      global_packages_only: 'Apenas caixas globais',
      active: 'Estado',
      active_only: 'Ativas',
      inactive_only: 'Inativas',
      all: 'Todas',
    },
    store_allowed: {
      title: 'Caixas por marca',
      store_label: 'Marca',
      store_placeholder: 'Busque uma marca pelo nome',
      searching: 'Buscando…',
      no_results: 'Nenhuma marca encontrada',
      search_error: 'Não foi possível buscar marcas',
      change_store: 'Trocar marca',
      select_prompt: 'Escolha uma marca para configurar suas caixas neste armazém.',
      explanation: '{{store}} só poderá embalar nas caixas marcadas. Sem nenhuma marcada pode usar todas.',
      own_tag: 'própria da marca',
      inactive_tag: 'inativa',
      empty: 'Não há caixas disponíveis para esta marca neste armazém.',
      save: 'Salvar',
      save_success: 'Caixas da marca atualizadas',
      save_error: 'Não foi possível salvar as caixas da marca',
      not_a_candidate: 'A lista foi atualizada; revise as caixas e salve novamente.',
      not_in_warehouse: 'Esta marca não opera neste armazém.',
      load_error: 'Não foi possível carregar as caixas da marca',
      retry: 'Tentar novamente',
    },
    errors: {
      fetch_error: 'Erro ao carregar as caixas',
      create_error: 'Erro ao criar a caixa',
      update_error: 'Erro ao atualizar a caixa',
      delete_error: 'Erro ao desativar a caixa',
      restore_error: 'Erro ao reativar a caixa',
      required_fields: 'Por favor, preencha todos os campos obrigatórios',
      no_access: 'Você não tem acesso a esta página',
    },
    history: {
      title: 'Histórico de alterações',
      view_history: 'Ver histórico',
      no_history: 'Não há histórico disponível',
      action: 'Ação',
      changes: 'Alterações',
      user: 'Usuário',
      date: 'Data',
      action_create: 'Criação',
      action_update: 'Atualização',
      action_destroy: 'Desativação',
      action_restore: 'Reativação',
      field_name: 'Nome',
      field_length_cm: 'Comprimento (cm)',
      field_width_cm: 'Largura (cm)',
      field_height_cm: 'Altura (cm)',
      field_package_type: 'Tipo de pacote',
      field_volume_liters: 'Volume (litros)',
      field_cost: 'Custo',
      field_bar_code: 'Código de barras',
      field_weight_kg: 'Peso (kg)',
      field_volumetric_weight: 'Peso volumétrico',
      field_store_id: 'Loja',
      field_active: 'Estado',
      refresh: 'Atualizar',
    },
  },
  replenishment_labels: {
    dialog_title: 'Imprimir ID de recibo de inventário',
    label_title: 'Identificador de recibo de inventário',
    label_instructions: 'Imprima e cole esta etiqueta no pacote retornado para identificar o retorno ao realizar o armazenamento.',
    store: 'Loja',
    warehouse: 'Armazém',
    replenishment_id: 'ID de recibo',
  },
  replenishment: {
    expected_quantity: 'peças pendentes de receber',
    error_unexpected_stock_start: 'O máximo de peças a receber por produto é a quantidade esperada. ',
    error_unexpected_stock_middle: 'Ajuste a quantidade a ser recebida, limitando as peças pendentes a receber',
    error_unexpected_stock_end: ' e separe as peças sobrantes para processá-las em outro recibo.',
  },
  generate_shipment: {
    generate_label: 'Gerar Etiqueta',
    store: 'Loja',
    order: 'Pedido',
    tote: 'Tote',
    go_to_next_order: 'Ir ao pedido seguinte para esse produto',
    picking_incomplete: 'O picking deste pedido não foi completado',
    no_multiple_packages: 'O método de envio selecionado não permite multi-pacote',
    cod_not_allowed: 'O método de envio selecionado não permite pagamento contra reembolso',
    print_label: 'Imprimir Etiqueta',
    print_bundle: 'Imprimir documentos de embalagem',
    print_bundle_with_skipped: 'Imprimir documentos de embalagem ({{count}} não puderam ser preparados)',
    missing_information: 'Falta informação no pedido',
    cannot_generate_more_labels: 'Não é possível gerar mais guias para este pedido, por favor avise ao time de operações para realizar esta ação',
    label_being_generated: 'A etiqueta ainda está sendo gerada. Aguarde alguns instantes e clique novamente em "Gerar etiqueta" para finalizar o pedido.',
    order_shipped_print_below: 'O pedido já foi enviado e a etiqueta está pronta. Imprima na seção de etiquetas emitidas abaixo.',
    coverage_reassignment_notice:
      'Esta transportadora foi trocada automaticamente pelo processo de recálculo de coberturas depois de detectar que a transportadora original {{from}} não tinha cobertura para o CEP atribuído.',
    shortcut_blocked_use_button: 'Não é possível gerar a etiqueta com o atalho Ctrl+G neste momento. Use o botão do rodapé, que indica o motivo.',
    no_more_orders:
      'Não há mais pedidos pendentes de embalagem para esta SKU neste tote. Retorne ao módulo de geração de etiquetas e escaneie outro tote ou produto.',
    imei_duplicate: 'IMEI duplicado',
    unit_code_duplicate: 'unit_code já escaneado nesta conferência',
    unit_code_not_in_order: 'unit_code não pertence a este pedido',
    enter_unit_code: 'Escaneie o unit_code',
    unit_code_missing_for_stock_unit: 'unit_code ausente para uma unidade reservada — escalar para o supervisor',
    surplus_product: 'Há um excedente deste produto.',
    product_not_in_order: 'Este produto não pertence ao pedido ou já foi revisado.',
    error_codes: {
      difal_invoice_exists: 'Este pedido possui documentos fiscais de DIFAL. Não é possível modificar pelo WMS.',
      store_edit_restriction: 'Este pedido pertence a uma loja com restrições de edição. Não é possível gerar etiqueta pelo WMS.',
      order_not_modifiable: 'Este pedido não pode ser modificado.',
      order_locked_by_process: 'A etiqueta já está sendo gerada, tente novamente em alguns segundos.',
      order_already_packed: 'Este pedido já foi despachado.',
      order_not_authorized: 'Você não tem permissão para gerar etiqueta neste pedido.',
      invoice_generation_in_progress: 'A nota fiscal está em processo de geração. Aguarde um momento e tente novamente.',
      carrier_no_coverage:
        'A transportadora não tem cobertura para este destino e não há método alternativo disponível. O pedido foi marcado para revisão — reporte ao lastmile e continue com o próximo.',
      packing_incomplete: 'Ainda há peças sem embalar. Bipe-as e coloque-as em uma caixa antes de gerar a etiqueta.',
      boxes_still_open: 'Ainda há caixas abertas. Feche todas antes de gerar a etiqueta.',
      missing_pieces_detail: 'Faltam: {{pieces}}.',
    },
    edit_restriction: {
      title: 'Não é possível editar este pedido',
      default_message: 'Este pedido não pode ser editado.',
    },
    restriction_reasons: {
      order_not_editable: 'Se você acredita que é necessário editar o pedido, por favor entre em contato com tech para avaliar a situação.',
      order_difal_invoice_exists: 'Este pedido possui documentos fiscais de DIFAL e não pode ser editado.',
      store_edit_restriction: 'Pedidos desta loja só podem ser editados por membros da loja.',
    },
    shipping_address: {
      order_details: 'Detalhes do pedido',
      see_details: 'Ver detalhes',
      hide_details: 'Ocultar detalhes',
      name: 'Nome',
      surname: 'Sobrenome',
      phone: 'Telefone',
      email: 'E-mail',
      address: 'Endereço',
      address_2: 'Apartamento, local, colonia, etc. (opcional)',
      country: 'País',
      city: 'Cidade',
      province: 'Estado / Província',
      zip_code: 'CEP',
      copy_address: 'Copiar endereço completo',
      address_copied: 'Endereço copiado!',
      number: 'Número',
      references: 'Referências (opcional)',
    },
    product_list: {
      required_products: 'Produtos requeridos',
      scan_all_items: 'Escaneie todos os itens do tote',
      order_complete: 'O pedido está completo!',
      sku: 'SKU',
      upc: 'UPC',
      quantity: 'Itens requeridos',
      processed_quantity: 'Itens revisados',
      actions: 'Estado de revisão',
      no_data: 'Sem dados',
      complete: 'Completo',
      pending: 'Pendente',
      product_search: {
        placeholder: 'Escaneie a etiqueta de um produto',
        placeholder_with_unit_code: 'Escaneie a etiqueta do produto ou seu código único',
      },
      products_total: {
        item: 'produto',
        complete_singular: 'Foram revisados',
        complete_plural: 'Foi revisado',
        pending_singular: 'pendente de revisão',
        pending_plural: 'pendentes de revisão',
      },
      see_products: 'Ver produtos',
      hide_products: 'Ocultar produtos',
    },
    missing_picking_pieces: {
      title: 'Faltaram peças no picking?',
      scan_all_products: 'Escaneie todos os produtos do tote. ',
      missing_items: 'Se após finalizar ainda houverem peças faltantes, envie o pedido à revisão.',
      action: 'Enviar pedido à revisão',
      action_disabled_tooltip:
        'Esta ação não está disponível agora. Verifique se o endereço está completo, se não há uma solicitação em andamento e se o pedido continua em embalagem e sem revisão pendente',
      action_to_error: 'Enviar pedido para falta de informação',
      action_to_error_disabled_tooltip: 'Disponível apenas quando há falta de informação no endereço',
      send_to_review_title_confirmation: 'Enviar pedido do tote {{tote}} para revisão',
      send_to_missing_info_title_confirmation: 'Enviar pedido do tote {{tote}} para falta de informação',
      send_to_review_question: 'Tem certeza de que deseja enviar o pedido deste tote para revisão?',
      send_to_missing_info_question: 'Tem certeza de que deseja enviar o pedido deste tote para falta de informação?',
      missing_info_last_confirmation_title: 'Enviar pedido para falta de informação',
      missing_info_last_confirmation_description: 'Deseja enviar este pedido para falta de informação?',
      in_review_last_confirmation_title: 'Enviar pedido para revisão',
      // Shown instead of the server's internal 422 string when put_in_review refuses
      // because units are already PACKED (BUGS-8501 tracks the refusal itself).
      review_blocked_pieces_packed:
        'Não foi possível enviar o pedido para revisão porque já existem peças embaladas. Reabra as caixas e desescaneie as peças antes de tentar novamente.',
      missing_info_blocked_pieces_packed:
        'Não foi possível enviar o pedido para falta de informação porque já existem peças embaladas. Reabra as caixas e desescaneie as peças antes de tentar novamente.',
      // Shown when the request failed with no server message at all (queda de rede,
      // timeout, um 500 com corpo HTML): não nomear uma causa que não ouvimos.
      request_failed_retry: 'Não foi possível concluir a ação. Verifique sua conexão e tente novamente; se continuar falhando, reporte para a Tecnologia.',
      // Shown when the server DID refuse, with an internal diagnostic we cannot attribute
      // to a cause (six refusals share one prefix). Names no cause on purpose: dizer ao
      // operador "já existem peças embaladas" em um pedido já despachado é uma causa falsa
      // e uma recuperação que não funciona.
      request_refused_report:
        'Não foi possível concluir a ação. O servidor a recusou por um motivo que não podemos exibir aqui: reporte para a Tecnologia com o número do pedido.',
      in_review_last_confirmation_description: 'Deseja enviar este pedido para revisão?',
    },
    fragile_notification: {
      title: 'Adicione material de proteção',
      description: 'Esse pedido contém produto frágil',
      fragile_label: 'Etiqueta Frágil',
    },
    recommended_package: {
      title: 'Pacote recomendado',
      text_1: 'Somente se o pedido não contém a ',
      text_2: 'caixa do cliente, ',
      text_3: 'utilize:',
    },
    shipping_package_data: {
      title: 'Pacote utilizado',
      description: 'Registre como o pacote será enviado',
      package: 'Pacote',
      select_similar_package: 'Selecione um pacote com medidas semelhantes',
      shipping_method: 'Método de envio',
      search_placeholder: 'Escaneie um código ou selecione um pacote',
      no_allowed_packages_for_store: 'Não há caixas permitidas para esta marca neste armazém. Avise ops para revisar "Caixas por marca".',
    },
    footer: {
      cancel: 'Cancelar',
      generate_label: 'Gerar Etiqueta',
      invalidate_previous_labels: 'Invalidar Etiquetas Anteriores e Gerar Etiqueta',
      finish_order: 'Finalizar pedido',
      generate_shipping_labels: 'Gerar etiquetas de envio',
      generate_label_confirm: 'Deseja gerar esta etiqueta?',
      generating_label: 'Gerando etiqueta…',
      labels_invalidated: 'Se invalidarão todas as etiquetas anteriores e serão geradas novas etiquetas. Confirma Proceder?',
    },
    view: {
      tote_or_unit_code_not_found: 'Tote ou código único não encontrado. Confira o código ou avise seu supervisor.',
      unit_code_no_open_replenishment: 'Este código único não tem um recebimento aberto. Avise seu supervisor.',
      unit_code_on_multiple_orders: 'Este código único está em mais de um pedido. Avise seu supervisor.',
      unit_code_product_has_expiration: 'Este produto não pode ser embalado com o código único. Avise seu supervisor.',
      unit_code_unavailable: 'Este código único está bloqueado ou já foi atribuído. Avise seu supervisor.',
      unit_code_format: 'Este código único não tem o formato esperado. Verifique o código ou avise seu supervisor.',
      unexpected_error: 'Ocorreu um erro inesperado.',
      order_in_review: 'Este pedido está em revisão e não pode ser embalado. Deixe o tote como está e avise seu supervisor.',
      order_in_review_with_number: 'O pedido #{{order_number}} está em revisão e não pode ser embalado. Deixe o tote como está e avise seu supervisor.',
      order_canceled_in_review: 'Este pedido foi cancelado. Leve o tote à estação de revisão para esvaziá-lo.',
      order_canceled_in_review_with_number: 'O pedido #{{order_number}} foi cancelado. Leve o tote à estação de revisão para esvaziá-lo.',
      order_canceled_in_review_with_totes: 'O pedido #{{order_number}} foi cancelado. Leve os totes {{totes}} à estação de revisão para esvaziá-los.',
      order_not_packing: 'O pedido pertencente a este tote não se encontra em status Packing',
      order_not_found: 'Não foi encontrado um pedido com esse produto.',
      generate_label_title: 'Gerar Etiqueta',
      generate_label_button: 'Gerar Etiqueta Agrupada',
      scan_tote_title: 'Escaneie o tote ou o código único e ajuste a câmera',
      scan_tote_label: 'Buscar tote ou código único',
      scan_tote_placeholder: 'Escaneie um tote ou código único',
      multiple_orders: 'Este Tote contém vários pedidos. Escaneie um produto do Tote.',
      scan_product_title: 'Este Tote contém vários pedidos. Escaneie um produto do Tote.',
      scan_product_label: 'Buscar UPC ou SKU',
      scan_product_placeholder: 'Escaneie um produto',
      tote_pending_title: 'Pendentes neste tote ({{count}})',
      tote_pending_scan_prompt: 'Escaneie o próximo produto físico do tote',
      tote_all_packed: 'Todos os pedidos deste tote estão embalados. Escaneie outro tote.',
      tote_pending_show: 'Ver produtos',
      tote_pending_hide: 'Ocultar produtos',
      tote_pending_in_review_badge: 'Em revisão',
      tote_pending_in_review_count: '{{count}} em revisão',
      missing_information: 'Falta informação no pedido',
      picking_not_completed: 'O picking deste pedido não foi completado',
      shipping_method_no_multipackage: 'O método de envio selecionado não permite multi-pacote',
      shipping_method_no_cod: 'O método de envio selecionado não permite pagamento contra reembolso',
      next_order_for_product: 'Ir ao pedido seguinte para este produto',
      invalidate_and_generate: 'Invalidar Etiquetas Anteriores e Gerar Etiqueta',
      invalidate_confirm: 'Serão invalidadas todas as etiquetas anteriores e serão geradas novas etiquetas. Confirma Proceder?',
      generate_confirm: 'Deseja gerar esta etiqueta?',
      product_not_in_order: 'Este produto não pertence ao pedido ou já foi revisado.',
      order_invoice_not_ready: 'A fatura ainda não está pronta para este pedido. Separe o pedido e tente novamente mais tarde.',
      order_notfis_not_ready: 'O NOTFIS ainda não está pronto para este pedido. Separe o pedido e tente novamente mais tarde.',
      order_boleto_not_ready: 'O boleto ainda não está pronto para este pedido. Separe o pedido e tente novamente mais tarde.',
      camera_preview_card_title: 'Sua câmera deve apontar para a mesa de empacotamento',
      camera_preview_card_subtitle: 'Se a imagem não mostrar o tote e os produtos, ajuste a câmera para garantir uma boa evidência de empacotamento.',
    },
    label_pending: {
      title: 'Preparando a etiqueta',
      subtitle: 'A transportadora já aceitou o envio. Estamos baixando o PDF, normalmente leva alguns segundos. Ela é impressa sozinha assim que chegar.',
      still_working: 'Ainda baixando. Não gere outra etiqueta: esta já foi criada na transportadora.',
      expired: 'Não conseguimos confirmar o estado da etiqueta. Tente gerá-la novamente.',
      blue_express_large_shipment: {
        title: 'Gerando as etiquetas da Blue Express',
        subtitle:
          'Este envio tem mais de 100 volumes, então a Blue Express monta as etiquetas em lotes de 100 e pode levar alguns minutos. Não feche esta tela nem gere a etiqueta de novo: cada tentativa cria um novo envio na Blue Express. Elas são impressas sozinhas assim que estiverem prontas.',
        still_working:
          'A Blue Express ainda está montando as etiquetas. Não feche esta tela nem gere a etiqueta de novo: cada tentativa cria um novo envio na Blue Express.',
      },
      multipackage_switch: {
        title: 'Trocando para um método que aceita vários volumes',
        subtitle:
          'O método deste pedido não gera uma etiqueta por volume. Estamos escolhendo outro método da marca que gere e criando as etiquetas com ele, o que pode levar alguns instantes. Não feche esta tela nem gere a etiqueta de novo: elas são impressas sozinhas assim que estiverem prontas.',
      },
    },
    camera_blocked_banner: {
      title: 'Câmera não detectada',
      default_message: 'Não foi possível iniciar a gravação de vídeo. Verifique se a câmera está conectada e com permissões habilitadas antes de gerar a guia.',
      permission_denied_message: 'O acesso à câmera foi bloqueado. Clique no botão para ver como habilitá-lo nas configurações do seu navegador.',
      retry_button: 'Tentar detectar novamente',
      permission_denied_cta: 'Ver como permitir câmera',
      detecting: 'Detectando câmera...',
    },
    camera_permission_instructions: {
      dialog_title: 'Permita o acesso à câmera',
      intro: 'Siga estes passos no Chrome para habilitar a câmera e depois recarregue a página.',
      step_1: 'Clique no ícone de cadeado ou controles do site na barra de endereço.',
      step_2: 'Procure "Câmera" e selecione "Permitir".',
      step_3: 'Recarregue a página com o botão abaixo.',
      browser_note: 'Estas instruções são para o Google Chrome.',
      reload_button: 'Fechar e recarregar a página',
      reload_warning: 'Ao recarregar, o progresso do empacotamento atual será perdido.',
      close_aria: 'Fechar',
    },
    camera_blocked_dialog: {
      title: 'Não é possível embalar sem câmera',
      description: 'Este pedido requer gravação de vídeo para poder ser embalado. Verifique se a câmera está conectada e com permissões habilitadas.',
      instruction: 'Não escaneie produtos nem continue com a embalagem até resolver o problema com a câmera.',
      retry_button: 'Tentar detectar novamente',
      detecting: 'Detectando câmera...',
    },
    camera_mini_preview_title: 'Visualização da câmera',
    camera_mini_preview_pill: {
      unavailable: 'Câmera indisponível',
      denied: 'Permita o acesso',
    },
    multi_box: {
      bulk_labels_notice: 'Com esta transportadora serão geradas todas as etiquetas. Cole cada uma na caixa correspondente.',
      panel_title: 'Pacotes do pedido',
      panel_subtitle_one: '{{count}} fechada · uma etiqueta por caixa',
      panel_subtitle_other: '{{count}} fechadas · uma etiqueta por caixa',
      shipping_method_label: 'Transportadora',
      add_box: '+ Adicionar outra caixa',
      add_box_title: 'Adicionar outra caixa',
      box_label: 'PACOTE {{n}}',
      box_closed_pill: 'Fechada',
      no_empaque_hint: 'Selecione a embalagem que será usada para enviar este pacote',
      empaque_selected_prefix: 'Embalagem selecionada:',
      empaque_used: 'Embalagem utilizada',
      pieces_packed: 'Peças embaladas',
      pieces_one: '{{count}} peça',
      pieces_other: '{{count}} peças',
      show_more: 'Ver mais',
      show_less: 'Ver menos',
      fragile_pill: 'Frágil',
      fragile_banner_title: 'Contém produto frágil',
      fragile_banner_subtitle: 'Adicione material de proteção antes de fechar',
      scan_at_least_one: 'Escaneie ao menos 1 peça',
      scan_prompt: 'Escaneie as peças que serão enviadas nesta embalagem.',
      inserts_only_prompt: 'Este pedido contém apenas enxertos (não escaneáveis). Feche a caixa para continuar.',
      close_box: 'Fechar caixa',
      close_box_in_flight_label: 'Gerando packing list…',
      close_box_in_flight_label_with_label: 'Gerando etiqueta…',
      delete_box: 'Excluir caixa',
      delete_box_disabled_has_items: 'Retire as peças antes de excluir a caixa',
      delete_box_disabled_last: 'Pelo menos uma caixa deve permanecer',
      delete_box_confirm_description: 'Esta caixa tem {{count}} peças. Ao excluí-la, elas voltarão ao tote para que você possa atribuí-las a outra caixa.',
      delete_box_confirm_yes: 'Sim, excluir',
      print_packing_list: 'Imprimir packing list',
      print_shipping_label: 'Imprimir etiqueta',
      print_invoice: 'Imprimir nota fiscal (NF-e)',
      packing_context_label: 'Você está embalando em',
      no_open_box_alert: 'Não há uma caixa aberta para incluir o produto. Crie outra caixa antes de escanear.',
      pick_empaque_first_alert: 'Selecione a embalagem do pacote antes de escanear peças.',
      session_not_ready_alert:
        'A sessão de embalagem ainda não pode iniciar: o pedido está em «{{status}}». Tentando novamente automaticamente — escaneie de novo assim que passar para packing.',
      reopen_box: 'Reabrir caixa',
      reopen_box_hint: 'Reabrir caixa para corrigir quantidades ou embalagem',
      reopen_confirm_description:
        'A caixa voltará ao estado editável; seu packing list será regenerado ao fechá-la e, se tiver etiqueta de transporte própria, esta será invalidada.',
      reopen_confirm_yes: 'Sim, reabrir',
      reopen_confirm_cancel: 'Cancelar',
      reopen_in_flight: 'Reabrindo caixa…',
      delete_in_flight: 'Excluindo caixa…',
      could_not_reopen_box: 'Não foi possível reabrir a caixa',
      reopen_not_available_yet: 'Reabrir caixa ainda não está disponível neste ambiente. Contate o suporte.',
      reopen_session_concluded: 'Não é possível reabrir: o pedido já foi enviado.',
      bulk_add_hint: 'Adicionar várias peças deste SKU',
      bulk_add_disabled: 'A função de adicionar peças sem escanear está desativada neste armazém',
      bulk_unscan_partial: 'Foram removidas {{unscanned}} de {{requested}} peças (algumas não estavam na caixa).',
      finalizing: 'Processando…',
      cannot_close_box_with_items: 'Não é possível excluir a Caixa {{n}}: tem peças dentro.',
      cannot_close_session_with_items: 'Não é possível fechar a sessão: a Caixa {{n}} tem peças. Retire-as ou feche a caixa manualmente.',
      could_not_adjust_boxes: 'Não foi possível ajustar as caixas na sessão',
      could_not_open_box: 'Não foi possível abrir a caixa',
      could_not_start_session: 'Não foi possível iniciar a sessão de embalagem',
      could_not_register_unit: 'Não foi possível registrar a peça na caixa',
      could_not_unscan: 'Não foi possível desfazer a peça',
      could_not_change_empaque: 'Não foi possível alterar a embalagem',
      could_not_close_box: 'Não foi possível fechar a caixa',
      could_not_delete_box: 'Não foi possível excluir a caixa',
      could_not_add_units: 'Não foi possível adicionar as peças',
      could_not_finalize: 'Não foi possível finalizar o pedido',
      // conclude (cenário A) refusals from the BUGS-8257 server gate. The label path
      // localizes the same packing_incomplete code through error_codes above; these are
      // the conclude wording ("antes de finalizar") and must exist in es too.
      conclude_packing_incomplete: 'Ainda há peças sem embalar. Bipe-as e coloque-as em uma caixa antes de finalizar.',
      conclude_override_not_authorized:
        'A quantidade embalada não coincide com a requerida e seu perfil não pode autorizar a exceção. Peça a um super admin para finalizar.',
      pre_close_warning_one: 'Você tem {{count}} peça no tote sem atribuir a uma caixa. Continuar mesmo assim?',
      pre_close_warning_other: 'Você tem {{count}} peças no tote sem atribuir a uma caixa. Continuar mesmo assim?',
      close_last_box_pending_title: 'Fechar a caixa',
      close_last_box_pending_one: 'Falta {{count}} peça para embalar. Você poderá continuar em outra caixa ou reabrir esta.',
      close_last_box_pending_other: 'Faltam {{count}} peças para embalar. Você poderá continuar em outra caixa ou reabrir esta.',
      close_last_box_pending_confirm: 'Fechar a caixa',
      close_last_box_pending_cancel: 'Continuar embalando',
      tote_label: 'TOTE',
      per_box_format: '{{count}} × Pacote {{n}}',
      per_tote_format: '{{count}} × TOTE',
      remove_many_pieces_hint: 'Remover várias peças deste SKU',
      remove_one_piece: 'Remover 1 peça',
      bulk_remove_submit: 'Remover',
      bulk_remove_in_flight: 'Removendo…',
      quantity_header: 'Quantidade',
      bulk_add_submit: 'Adicionar',
      // Recommended package strip; keys mirror RecommendedPackageSection/constants.js.
      package_option_titles: {
        PARCEL_BAG: 'Saco de encomenda',
        JIFFY_ENVELOPE: 'Envelope bolha',
        CUBBO_BOX: 'Caixa Cubbo',
        PACKAGELESS: 'Enviar sem embalagem',
      },
      package_selection_titles: {
        0: 'Preferida',
        1: '2ª opção',
        2: '3ª opção',
        3: '4ª opção',
        4: '5ª opção',
      },
      container_scan_in_flight: 'Esse código já está sendo processado — aguarde antes de escanear novamente',
      address_frozen_after_labels: 'As etiquetas já foram geradas — o endereço ficou congelado nas etiquetas',
      active_box_label: 'Pacote {{n}}',
      bulk_add_skipped_already_packed: '{{n}} já embaladas em outra caixa',
      bulk_add_skipped_not_picked: '{{n}} sem estoque PICKED',
      bulk_add_partial: 'Apenas {{packed}} de {{requested}} peças foram adicionadas',
      product_table: {
        title: 'Produtos do pedido',
        subtitle: 'Escaneie as peças e coloque-as dentro da caixa de envio.',
        open_box_title: 'Caixa em andamento',
        show_closed_boxes: 'Ver caixas fechadas',
        closed_boxes_summary: '{{total}} em {{boxes}} fechadas',
        closed_box_title: 'Caixa fechada',
        hide_closed_boxes: 'Ocultar caixas fechadas',
        quantity_column: 'QUANTIDADE',
        scanned_required: 'Escaneadas / Necessárias',
        packed_in_column: 'EMBALADO EM',
      },
      // Keyed by the backend error code; GenerateShipment.js spreads the whole object into
      // SCAN_ERROR_MESSAGES, so es and pt must hold the same codes.
      scan_errors: {
        box_not_open: 'A caixa ativa está fechada — selecione outra',
        unit_not_found: 'Código não pertence a este pedido — revise a etiqueta',
        unit_not_pickable: 'Esta unidade não está PICKED ou não é deste pedido',
        unit_already_packed: 'Esta unidade ou todas as suas peças já estão embaladas',
        packed_unit_not_in_box: 'Essa peça não está nesta caixa — revise a caixa correta',
        unit_tracked_not_bulkable: 'Este produto requer código por unidade — escaneie cada peça separadamente',
        invalid_quantity: 'Quantidade inválida — use um número maior que 0',
        box_has_units: 'A caixa tem peças — retire-as antes de trocar a embalagem',
        box_closed: 'A caixa já está fechada — não é possível modificá-la',
        boxes_still_open: 'Ainda há caixas abertas — feche todas antes de finalizar',
        no_closed_boxes: 'Não há caixas fechadas para finalizar',
        box_carrier_label_missing: 'Uma caixa fechada está sem a etiqueta de envio — tente novamente antes de finalizar',
        quality_check_failed: 'A quantidade embalada não coincide com a requerida',
        order_not_in_packing: 'O pedido já foi enviado — não é possível modificá-lo',
        box_not_closed: 'A caixa precisa estar fechada primeiro',
        label_generation_failed: 'A transportadora não conseguiu gerar a etiqueta — tente novamente',
        shipping_preparation_failed: 'Não foi possível aplicar o endereço — revise os dados do destinatário',
        shipping_method_invalid: 'Não é possível usar esta transportadora (pickup-only, click-and-collect ou inexistente)',
        invoice_generation_failed: 'Falha na geração da nota fiscal — tente novamente',
        carrier_label_failed: 'A transportadora não gerou a etiqueta — tente novamente',
        sale_invoice_missing: 'Falta a nota fiscal do pedido — acione o supervisor',
        invoice_contingency: 'Nota fiscal em contingência — acione o supervisor',
        invoice_processing: 'Nota fiscal ainda em processamento — tente novamente em instantes',
        imei_required: 'Este produto requer IMEI — registre-o antes de continuar',
        imei_duplicate: 'Este IMEI já foi registrado neste pedido — revise a unidade',
        imei_requires_individual_scan: 'Produtos com IMEI não podem ser adicionados em bulk — escaneie um por um',
        imei_missing: 'Uma unidade com IMEI ficou sem registro — escaneie o IMEI faltante antes de fechar a caixa',
        container_has_foreign_products: 'O contêiner traz um produto que não pertence a este pedido',
        container_product_not_picked: 'O contêiner traz um produto que não foi separado para este pedido',
        container_exceeds_picked: 'O contêiner traz mais peças do que faltam embalar',
        container_lot_not_picked: 'O lote do contêiner não é o que foi separado',
        container_lot_exceeds_picked: 'O contêiner excede as peças pendentes desse lote',
        container_requires_individual_scan: 'O contêiner traz produtos com IMEI ou código unitário — escaneie peça por peça',
        container_already_scanned: 'Esse contêiner já está neste pedido',
        container_empty: 'Esse contêiner não tem conteúdo registrado — embale as peças uma por uma',
        container_holds_blocked_stock: 'O contêiner traz peças que não podem sair (retidas, vencidas ou sem armazenar) — embale as boas uma por uma',
        container_not_found: 'Não há nenhuma caixa com esse código — embale as peças uma por uma',
        box_template_invalid_item: 'O modelo dessa caixa está cadastrado incorretamente — embale as peças uma por uma e avise o suporte',
        container_ambiguous: 'Há várias caixas com esse código e conteúdos diferentes — embale por peça',
        scan_needs_confirmation: 'Esse código é ao mesmo tempo um produto e uma caixa — embale peça por peça',
        pallet_ambiguous: 'Há vários paletes separados com esse código e conteúdos diferentes — embale caixa por caixa',
        container_not_picked_for_order: 'Esse contêiner está atribuído a outro pedido',
      },
    },
    print_titles: {
      box_packing_list: 'Packing list — Pacote {{n}}',
      box_shipping_label: 'Etiqueta — Pacote {{n}}',
      box_invoice: 'Nota fiscal (NF-e) — Pacote {{n}}',
      shipping_documents: 'Imprimir Documentos de Envio',
      extra_shipping_labels: 'Imprimir Etiquetas Extras',
    },
    label_view: {
      bundle_count: 'Impressões <bold>{{n}}</bold>',
      print_type: 'Tipo de impressão <bold>{{type}}</bold>',
      type_label: 'Etiqueta',
      type_document: 'Documento',
      bundle_prepare_failed: 'Não foi possível preparar {{failed}} de {{total}} impressões.',
      print_failed: 'Não foi possível imprimir a etiqueta neste visualizador.',
      preview_failed: 'Não foi possível pré-visualizar a etiqueta.',
      open_in_new_tab: 'Abrir a etiqueta em uma nova aba',
      opened_in_new_tab:
        'A etiqueta foi aberta em uma nova aba. Se o navegador a bloqueou, clique no link abaixo e imprima por lá (Ctrl+P / ⌘+P).',
      cancel: 'Cancelar',
      print: 'Imprimir',
    },
  },
  packing_audit: {
    banner: {
      default: 'ATENÇÃO: Este pedido está em AUDITORIA. Não gere etiqueta sem autorização.',
      critical: 'CLIENTE CRÍTICO — AUDITORIA OBRIGATÓRIA. Confira cada item com atenção redobrada!',
    },
    questions: {
      missing_items: {
        title: 'Faltaram produtos no tote?',
        quantity_prompt: 'Quantos produtos faltaram?',
      },
      extra_items: {
        title: 'Sobraram produtos no tote?',
        quantity_prompt: 'Quantos produtos sobraram?',
      },
      debris_present: {
        title: 'Havia lixo ou itens estranhos no tote?',
      },
      yes: 'Sim',
      no: 'Não',
      submit_error: 'Não foi possível enviar as respostas. Tente novamente.',
    },
    answered_confirmation: '✓ Auditoria respondida',
    label_blocked: {
      title: 'Auditoria pendente',
      message: 'As perguntas da auditoria de embalagem precisam ser respondidas antes de gerar a etiqueta. A página foi atualizada.',
    },
  },
  generate_shared_label: {
    cancel: 'Cancelar',
    generate_label: 'Gerar Guía',
    generate_label_confirm: 'Deseja gerar esta guía?',
    yes: 'Sim',
    print_invoice: 'Imprimir Fatura Comercial',
    print_invoice_brazil: 'Imprimir Fatura Brasil',
    order_details: 'Detalhes do pedido',
    on_collapsed_text: 'Ver detalhes',
    on_not_collapsed_text: 'Ocultar detalhes',
    address: 'Endereço',
    address_2: 'Apartamento, local, colonia, etc. (opcional)',
    city: 'Cidade',
    province: 'Estado / Província',
    zip_code: 'CEP',
    grouped_orders: 'Pedidos Agrupados',
    scan_all_orders: 'Escaneie todos os pedidos que serão enviados',
    scan_order_placeholder: 'Escaneie a etiqueta do pedido',
    used_package: 'Pacote utilizado',
    register_package_shipping: 'Registre como o pacote será enviado',
    package: 'Pacote',
    shipping_method: 'Método de Envio',
    select_shipping_method_error: 'Por favor selecione o método de envio',
    error_fetching_shipping_methods: 'Erro ao carregar os métodos de envio. Tente novamente.',
  },
  top_menu: {
    warehouses: 'Armazéns',
    billing: 'Billing',
  },
  sidebar: {
    cambiar_almacen: 'Trocar armazém',
    sign_out: 'Sair',
    logout_error: 'Erro ao sair',
    expand_to_logout: 'Expandir para sair',
  },
  select_warehouse: {
    subtitle: 'Selecione um armazém para continuar',
    error_loading: 'Erro ao carregar armazéns',
    no_warehouses: 'Sua conta não tem armazéns atribuídos. Entre em contato com um administrador para que sejam atribuídos.',
  },
  navegation_routes: {
    warehouses: 'Armazéns',
    billing: 'Billing',
    dashboard: 'Dashboard',
    pending: 'Pendentes',
    pick_and_pack: 'Pick & Pack',
    boxes_to_break: 'Caixas para abrir',
    shipments: 'Envios',
    generate_labels: 'Gerar Guías',
    returns: 'Retornos',
    inventory: 'Inventário',
    load: 'Remessa',
    inbound_appointments: 'Agendamentos de recebimento',
    cubbitos: 'Cubbitos',
    pending_prints: 'Impressões pendentes',
    romaneios: 'Romaneios',
    proof_video_coverage: 'Cobertura de vídeo',
    claims: 'Disputas',
    maquilas: 'Maquilas',
    operators: 'Operadores',
    natura_replenishments: 'Recebimentos Natura',
    natura_operations: 'Natura Operações',
    natura_ops_create_order: 'Criar pedido',
    natura_ops_picking: 'Reenviar confirmação de picking',
    natura_ops_nota_fiscal: 'Nota Fiscal',
    natura_ops_deposit_transfer: 'Transferência de materiais',
    natura_ops_confirmation_resend: 'Reenviar confirmação de remessa',
    natura_ops_notfis_upload: 'Upload de NOTFIS',
    shipping_packages: 'Caixas',
    lastmile_shipping_methods: 'Metodos de envio',
    dispatch_schedules: 'Horarios de despacho',
    // TODO: revisar copia PT
    automated_coverage_deactivations: 'Coberturas auto-desactivadas',
    uber_batches: 'Lotes Uber',
    configurations: 'Configurações',
    cycle_counts: 'Contagens Cíclicas',
    workforce: 'Força de trabalho',
    fulfillment_errors: 'Erros de fulfillment',
  },
  natura_operations: {
    create_order: {
      title: 'Criar pedido manualmente',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Solicite à equipe Natura o IDoc não-integrado (transação WE02/WE05, exportar como "Saída dinâmica de lista").',
      instructions_step2: 'Salve o arquivo .txt ou .csv no seu computador.',
      instructions_step3: 'Faça upload abaixo. O sistema vai parsear, mostrar um preview e criar o pedido no Cubbo.',
      instructions_step4: 'Confirme com o time que o pedido aparece em "Pendentes".',
      warning: 'Use este recurso apenas para IDocs corrompidos ou pedidos manuais.',
      file_picker_hint: 'Solte o arquivo aqui ou clique para procurar — .txt, .csv até 5MB',
      submit: 'Subir e criar pedido',
      result_success: 'Pedido {{delivery_number}} criado',
      result_partial: 'Pedido {{delivery_number}} criado com avisos',
      result_failed: 'Falha ao criar o pedido',
      result_label_customer: 'Cliente',
      result_label_items: 'Itens',
      result_label_shipping_method: 'Método de envio',
      submit_loading: 'Carregando…',
      view_pending: 'Ver em Pendentes',
    },
    nfe_status: {
      title: 'Nota Fiscal — consulta de status',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Cole até 25 números de pedido Natura abaixo (um por linha, vírgula ou espaço).',
      instructions_step2: 'Clique em "Consultar" — buscamos o status da NF-e de cada pedido na SAP da Natura.',
      instructions_step3: 'A tabela mostra o status, ação e mensagem retornada por pedido. Clique em uma linha para ver detalhes.',
      warning_wait: 'A consulta pode levar até 90 segundos para 25 pedidos. Não feche a página enquanto carrega.',
      input_count: '{{count}} pedidos · máx. {{max}}',
      input_too_many: 'Máximo de {{max}} pedidos por vez.',
      submit: 'Consultar status',
      submit_loading: 'Verificando {{count}} pedidos…',
      summary: '{{total}} verificados · {{ok}} OK · {{errored}} com erro · {{not_found}} não encontrados',
      col_order: 'Pedido',
      col_status: 'Status',
      col_action: 'Ação',
      col_description: 'Descrição',
      col_message: 'Mensagem',
      outcome_not_found_short: 'Não encontrado',
      outcome_errored_short: 'Erro',
      error_generic: 'Não foi possível concluir a consulta. Tente novamente em alguns instantes.',
      retry: 'Tentar novamente',
      row_aria_label: 'Ver detalhes da NF-e do pedido {{order_number}}',
      modal_raw_label: 'Detalhes da resposta',
      close: 'Fechar',
    },
    deposit_transfer: {
      title: 'Transferência de materiais',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Escolha a origem dos materiais: pedido REM, loja + localização, ou manual.',
      instructions_step2: 'Selecione o tipo, motivo e os depósitos de origem e destino do movimento.',
      instructions_step3: 'Gere o preview, revise os lotes e confirme para reportar o movimento à SAP da Natura.',
      warning: 'Cada confirmação reporta o movimento à SAP da Natura. Revise o preview antes de confirmar.',

      step1_heading: '1. Origem',
      step2_heading: '2. Parâmetros do movimento',
      step3_heading: '3. Preview',
      step4_heading: 'Resultado',

      mode_label: 'Modo',
      mode_rem_order: 'Pedido REM',
      mode_store_location: 'Loja + localização',
      mode_manual: 'Manual',

      rem_order_number: 'Número do pedido REM',
      store_id: 'ID da loja',
      warehouse_location: 'Localização no armazém',
      sku: 'SKU',
      lot_code: 'Lote',
      quantity: 'Quantidade',
      store_location_lost_note: 'Apenas unidades perdidas (LOST) desta localização serão transferidas.',
      statuses_label: 'Status das unidades',
      statuses_empty: 'Nenhum status disponível para filtrar.',
      statuses: {
        ACTIVE: 'Ativo',
        RESERVED: 'Reservado',
        DAMAGED: 'Avariado',
        EXPIRED: 'Vencido',
        HOLDED: 'Em espera',
        LOST: 'Perdido',
      },
      options_load_failed: 'Não foi possível carregar as opções (tipos de movimento e depósitos). Recarregue a página.',

      move_type: 'Tipo de movimento',
      move_reason: 'Motivo do movimento',
      source_deposit: 'Depósito de origem',
      destination_deposit: 'Depósito de destino',
      select_placeholder: 'Selecione…',

      generate_preview: 'Gerar preview',
      generating_preview: 'Gerando preview…',
      confirm: 'Confirmar',
      confirming: 'Confirmando…',
      cancel: 'Cancelar',
      retry: 'Tentar novamente',

      preview_summary: '{{lot_count}} lotes · {{total_units}} unidades · {{skipped_units}} ignoradas',
      preview_statuses: 'Status: {{statuses}}',
      skipped_heading: 'Itens ignorados',
      skipped_no_lot: 'Sem lote ({{quantity}} unidades): {{detail}}',
      skipped_generic: '{{reason}} ({{quantity}} unidades): {{detail}}',

      finalize_checkbox: 'Finalizar processo no Cubbo após a transferência',
      finalize_warning: 'Envia o pedido / unidades e registra a cobrança. Não pode ser desfeito automaticamente.',
      finalize_warning_discard: 'Descarta as unidades perdidas movimentadas (remove do estoque). Não pode ser desfeito automaticamente.',

      cap_message: 'Mais de {{limit}} lotes ({{given}}). Reduza a seleção ou use o modo Manual.',
      empty_message: 'Nenhum lote para transferir.',
      no_transferable_lots: 'Nenhum lote transferível no preview (sem lot_id). Não há nada para confirmar.',
      error_generic: 'Não foi possível concluir a operação. Tente novamente em alguns instantes.',
      processing_in_background: 'Enviando os movimentos à SAP da Natura… {{percentage}}% concluído. Pode deixar esta tela aberta.',
      result_unreadable: 'Os movimentos foram enviados e estão sendo processados, mas esta tela não conseguiu ler o resultado. Não repita a operação.',

      col_sku: 'SKU',
      col_lot: 'Lote',
      col_quantity: 'Qtd',
      col_source_location: 'Localização',
      col_status: 'Status',
      col_message: 'Mensagem',
      col_finalize: 'Finalização',

      result_summary: '{{total}} processados · {{ok}} OK · {{errored}} com erro · {{finalized}} finalizados · {{units_discarded}} descartadas',
      outcome_ok: 'OK',
      outcome_errored: 'Erro',
      finalize_finalized: 'Finalizado',
      finalize_discarded: 'Descartado ({{count}})',
      finalize_skipped: 'Ignorado ({{reason}})',
      finalize_errored: 'Erro na finalização',
      finalize_none: '—',
    },
    // Usado pelos componentes compartilhados de Operações Natura (CopyButton, JsonBlock).
    shared: {
      copy: 'Copiar',
      copied: 'Copiado',
      copy_failed: 'Não foi possível copiar',
      empty_body: 'Sem conteúdo.',
    },
    picking: {
      title: 'Reenviar confirmação de picking (WP09)',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Informe o número da remessa da Natura (10 dígitos) ou o id interno do pedido e gere o payload. Gerar não envia nada.',
      instructions_step2: 'Compare cada linha com o que foi realmente separado e embarcado. Linha certa: deixe como está.',
      instructions_step3:
        'Linha com SKU ou lote errado, mas cuja peça foi embarcada: use Corrigir e edite o campo errado. Corrigir troca a linha, não a elimina.',
      instructions_step4:
        'Só marque para remoção a linha cuja peça não foi embarcada. Remover uma linha que foi embarcada confirma menos do que saiu, e a nota sai a menos.',
      instructions_step5:
        'Reenvie e anexe o bloco de evidência ao chamado da Natura. Se o mesmo erro voltar depois do ajuste da Natura, é caso de escalar — nem todo erro de faturamento se resolve por reenvio.',
      warning: 'O reenvio envia de fato o WP09 para a SAP da Natura. Gerar o payload não envia nada.',

      mode_label: 'Buscar o pedido por',
      mode_order_number: 'Número da remessa (Natura)',
      mode_order_id: 'Id interno do pedido (Cubbo)',
      field_label_order_number: 'Número da remessa',
      field_label_order_id: 'Id do pedido',
      field_placeholder_order_number: '9001234567',
      field_placeholder_order_id: '1234567',
      field_hint_order_number: 'O número que aparece no chamado da Natura. Zeros à esquerda são ignorados.',
      field_hint_order_id: 'O id do pedido no Cubbo.',

      generate_preview: 'Gerar payload',
      generating_preview: 'Gerando…',
      resend: 'Reenviar à Natura',
      resend_without_lines: 'Reenviar sem {{lines}} linha(s)',
      resending: 'Reenviando…',
      cancel: 'Cancelar',
      retry: 'Tentar novamente',

      lines_heading: 'Linhas do payload',
      lines_explanation: 'Uma entrada por linha e lote. Remover uma linha remove todos os lotes reportados nela — é o que a Natura recebe.',
      lines_summary: '{{remaining}} de {{total}} linha(s) serão enviadas.',
      correct_line: 'Corrigir',
      column_sku: 'SKU',
      added_heading: 'Linhas corrigidas',
      added_explanation: 'Estas linhas serão enviadas no lugar das que você removeu. O número da linha vem do payload e não muda.',
      added_sku_aria: 'SKU da linha {{line}} (lote de origem {{source}})',
      added_batch_aria: 'Lote da linha {{line}} (lote de origem {{source}})',
      added_quantity_aria: 'Quantidade da linha {{line}} (lote de origem {{source}})',
      added_discard: 'Descartar',
      added_lot_caution:
        'O lote precisa ter sido informado à Natura no WP10 para esse SKU e depósito. Caso contrário a nota é rejeitada depois, mesmo com o WP09 respondendo 200.',
      resend_with_corrections: 'Reenviar com {{lines}} linha(s) corrigida(s)',
      resend_with_corrections_and_removals: 'Reenviar com {{corrections}} linha(s) corrigida(s) e {{lines}} removida(s)',
      unpaired_badge: 'sem remoção',
      unpaired_heading: 'Estas linhas foram adicionadas sem remover a original: {{lines}}',
      unpaired_explanation: 'Marque a linha correspondente para remoção. Sem isso a Natura receberia a mesma linha duas vezes, e o envio é recusado.',
      rejection_free_line_not_supported:
        'A linha corrigida não foi removida neste mesmo reenvio, então seria confirmada duas vezes. Marque a linha correspondente para remoção e reenvie.',
      rejection_invalid_added_entry: 'Uma das linhas corrigidas está incompleta ou inválida.',
      rejection_unknown_sku: 'O SKU informado não existe nesta loja, então não tem código de material para enviar.',
      prior_sends_warning: 'Este pedido já teve {{count}} confirmação(ões) de picking enviada(s) à Natura.',
      prior_sends_last: 'Último envio em {{at}}.',
      prior_sends_explanation: 'Reenviar pode gerar uma segunda baixa no SAP para a mesma remessa. Confirme com a Natura se a primeira não chegou.',
      column_remove: 'Remover',
      column_deliv_item: 'Linha',
      column_material: 'SKU',
      column_batch: 'Lote',
      column_quantity: 'Qtd',
      column_flags: 'Indicadores',
      remove_line_aria: 'Remover a linha {{line}} do reenvio',
      lot_count: '{{lots}} lotes',

      error_generic: 'Não foi possível concluir a operação.',
      delivery_unknown: 'Não sabemos se chegou na SAP.',
      delivery_unknown_explanation: 'A requisição saiu do Cubbo, mas não recebemos resposta a tempo.',
      unknown_delivery_detail: 'Consulte a Natura antes de reenviar — um novo envio pode duplicar a confirmação.',
      delivery_delivered: 'Chegou na SAP.',
      delivery_delivered_explanation: 'A Natura recebeu e respondeu à requisição.',
      delivery_not_delivered: 'Não chegou na SAP.',
      delivery_not_delivered_explanation: 'Nada foi enviado, então é seguro tentar de novo.',

      outcome_accepted: 'A Natura aceitou a confirmação de picking.',
      outcome_natura_refused: 'A Natura recebeu a confirmação e a recusou.',
      outcome_natura_no_response: 'A Natura não respondeu.',
      outcome_natura_auth_failed: 'Falha de autenticação com a Natura — nada foi enviado.',

      rejection_order_not_found: 'Nenhum pedido encontrado nas lojas Natura às quais você tem acesso.',
      rejection_missing_identifier: 'Informe o número da remessa ou o id do pedido.',
      rejection_not_natura_order: 'Este pedido não é de uma integração Natura, então não tem payload de WP09.',
      rejection_qa_store_skipped: 'Esta é uma loja de QA da Natura. O payload pode ser consultado, mas o reenvio está bloqueado.',
      rejection_lock_unavailable: 'Não foi possível garantir que não há outro reenvio em andamento, então nada foi enviado.',
      rejection_circuit_open: 'A integração da Natura está temporariamente suspensa após falhas repetidas. Nada foi enviado; tente em alguns minutos.',
      rejection_ambiguous_order_number: 'Este número de remessa corresponde a mais de um pedido. Escolha qual.',
      rejection_resend_in_progress: 'Já existe um reenvio em andamento para este pedido.',
      rejection_payload_build_failed: 'Não foi possível montar o payload deste pedido.',
      rejection_integration_unusable: 'A integração da Natura desta loja não está utilizável.',
      rejection_payload_changed: 'O payload mudou desde a última consulta. Gere o payload novamente antes de reenviar.',
      rejection_unknown_deliv_items: 'Alguma das linhas marcadas não está mais no payload. Gere o payload novamente.',
      rejection_empty_payload: 'Remover todas as linhas não deixa nada para confirmar.',
      retry_after: 'Tente novamente em até {{seconds}} segundos.',
      qa_store_notice: 'Esta é uma loja de QA da Natura. O payload pode ser consultado, mas o reenvio está bloqueado.',

      copy_for_ticket: 'Copiar tudo para o chamado',
      request_heading: 'Payload enviado',
      response_heading: 'Resposta da Natura',
      response_empty: 'A Natura não devolveu corpo na resposta.',

      field_order_id: 'Id do pedido',
      field_order_number: 'Número da remessa',
      field_status: 'Status do pedido',
      field_store: 'Loja',
      field_path: 'Endpoint',
      field_delivery: 'Chegou na SAP',
      field_removed_lines: 'Linhas removidas',
      no_lines_removed: 'nenhuma',
      lot_unknown_flag: '(lote não informado no WP10)',
      use_this_one: 'Usar este',

      check_nfe_status: 'Consultar status NF-e',
      checking_nfe_status: 'Consultando…',
      nfe_status_heading: 'Status da NF-e na Natura (WP21)',
      nfe_status_unavailable: 'Não foi possível consultar o status da NF-e.',
      nfe_status_code: 'Código',
      nfe_status_description: 'Descrição',
      nfe_status_action: 'Ação',
      nfe_status_message: 'Mensagem da Natura',
    },
    notfis_upload: {
      title: 'Upload de NOTFIS',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Use esta página quando a Natura confirmar que enviou o NOTFIS mas o pedido no Cubbo continua sem os dados de transporte.',
      instructions_step2: 'Peça à Natura o arquivo NOTFIS do pedido. Serve tanto o .gz que a transportadora envia quanto o arquivo de texto já descompactado.',
      instructions_step3: 'Suba o arquivo abaixo. O sistema lê o arquivo na hora e diz a qual pedido ele foi aplicado.',
      instructions_step4: 'Leia o resultado antes de sair da página: ele diz se o NOTFIS entrou e, quando não entrou, o que fazer.',
      file_picker_hint: 'Solte o arquivo aqui ou clique para procurar — .gz ou texto, até 4MB',
      submit: 'Subir NOTFIS',
      submit_loading: 'Processando…',
      result_label_file: 'Arquivo guardado como',
      result_label_layout: 'Tipo',
      result_compressed: 'compactado pelo sistema',
      layout_transport: 'Remessa',
      layout_return: 'Devolução',
      outcome_applied: '✓ NOTFIS aplicado ao pedido {{order_number}}',
      outcome_order_not_found: 'Nenhum pedido encontrado para este NOTFIS',
      outcome_not_applied: 'Arquivo guardado, mas nada foi aplicado',
      outcome_processing_error: 'Arquivo guardado, mas a leitura falhou',
      next_applied: 'Confira os dados de transporte no pedido. Nada mais a fazer aqui.',
      next_order_not_found:
        'O número de remessa deste arquivo não existe no Cubbo. Confirme com a Natura qual é o pedido antes de subir de novo — subir o mesmo arquivo outra vez dá o mesmo resultado.',
      next_not_applied:
        'O tipo de pedido dentro do arquivo não é tratado pelo sistema. O arquivo continua na fila e será relido automaticamente; avise a engenharia com o nome do arquivo se nada mudar.',
      next_processing_error:
        'O arquivo continua na fila e será relido automaticamente em alguns minutos. Se o erro repetir, avise a engenharia com o nome do arquivo e a mensagem acima.',
      error_no_file: 'Escolha um arquivo antes de subir.',
      error_empty_file: 'O arquivo está vazio.',
      error_file_too_large: 'O arquivo passa de 4MB.',
      error_invalid_file_name: 'Nome de arquivo inválido.',
      error_invalid_gzip: 'O arquivo .gz está corrompido ou não é um .gz. Peça o arquivo de novo à Natura.',
      error_uncompressed_too_large: 'O conteúdo do arquivo passa de 4MB descompactado. Confirme que é o NOTFIS do pedido, e não outro arquivo.',
      error_not_a_notfis:
        'Este arquivo não é um NOTFIS completo — falta a linha que identifica o pedido ou o número da remessa. Confirme com a Natura que enviaram o arquivo certo.',
      error_unsupported_order_type: 'O tipo de pedido dentro deste arquivo não é tratado pelo sistema. Encaminhe o arquivo para a engenharia.',
      error_already_pending: 'Já existe um arquivo com este nome na fila, ainda não processado. Espere alguns minutos ou renomeie o arquivo antes de subir.',
      error_upload_failed: 'Não foi possível guardar o arquivo. Tente de novo; se repetir, avise a engenharia.',
    },
    confirmation_resend: {
      title: 'Reenviar confirmação de remessa',
      instructions_heading: 'Como usar esta página',
      instructions_step1: 'Informe o número da remessa que a Natura diz não ter recebido, ou o ID da remessa no Cubbo.',
      instructions_step2: 'Clique em "Gerar payload" — montamos o que seria enviado, sem chamar a SAP da Natura.',
      instructions_step3:
        'Revise o payload. Se precisar da resposta da Natura como evidência, clique em "Reenviar à Natura" e copie os dois blocos para o chamado.',
      warning: 'O reenvio não altera a remessa: nenhum ajuste de estoque, nenhuma confirmação de recebimento e nenhum backorder são disparados.',

      mode_label: 'Buscar por',
      mode_external_reference: 'Número da Natura',
      mode_replenishment_id: 'ID do Cubbo',
      field_label_external_reference: 'Número da remessa na Natura',
      field_placeholder_external_reference: '0081234567',
      field_hint_external_reference: 'O número que aparece no chamado da Natura. Zeros à esquerda são opcionais.',
      field_label_replenishment_id: 'ID da remessa no Cubbo',
      field_placeholder_replenishment_id: '41522',
      field_hint_replenishment_id: 'O ID interno. Use quando o número da Natura aparecer em mais de uma remessa.',

      generate_preview: 'Gerar payload',
      generating_preview: 'Montando payload…',
      resend: 'Reenviar à Natura',
      resending: 'Reenviando…',
      resend_again: 'Reenviar novamente',
      cancel: 'Cancelar',
      retry: 'Tentar novamente',
      error_generic: 'Não foi possível concluir a operação. Tente novamente em alguns instantes.',
      unknown_delivery_detail:
        'A requisição saiu do Cubbo, mas não recebemos resposta a tempo. Consulte a Natura antes de reenviar — o reenvio abaixo continua disponível.',
      qa_store_notice: 'Esta é uma loja de QA da Natura. O payload pode ser consultado, mas o reenvio está bloqueado.',

      copy_for_ticket: 'Copiar tudo para o chamado',

      request_heading: 'Payload enviado',
      response_heading: 'Resposta da Natura',
      response_empty: 'A Natura não devolveu corpo na resposta.',

      field_replenishment_id: 'ID da remessa',
      field_external_reference: 'Número da remessa',
      field_store: 'Loja',
      field_confirmed_at: 'Confirmada em',
      field_path: 'Endpoint',
      field_delivery: 'Entrega à SAP',
      never_confirmed: 'Nunca confirmada',

      delivery_delivered: 'Chegou na SAP.',
      delivery_delivered_explanation: 'A Natura recebeu e processou a requisição — o que veio de volta é a resposta dela.',
      delivery_not_delivered: 'Não chegou na SAP.',
      delivery_not_delivered_explanation: 'A requisição não saiu do Cubbo, então pode ser reenviada sem risco.',
      delivery_unknown: 'Não sabemos se chegou na SAP.',
      delivery_unknown_explanation: 'Não houve resposta dentro do tempo limite. Confirme com a Natura antes de concluir o chamado.',

      outcome_accepted: 'A Natura aceitou a confirmação',
      outcome_natura_refused: 'A Natura recusou a confirmação',
      outcome_natura_no_response: 'A Natura não respondeu',
      outcome_natura_auth_failed: 'Falha de autenticação com a Natura',

      rejection_replenishment_not_found: 'Nenhuma remessa encontrada com esse identificador nas lojas Natura que você acessa.',
      rejection_missing_identifier: 'Informe o número ou o ID da remessa.',
      rejection_no_channel_integration: 'Esta loja não tem integração Natura configurada.',
      rejection_qa_store_skipped: 'Esta é uma loja de QA da Natura, então nada foi enviado.',
      rejection_not_completed: 'A remessa ainda não está concluída (COMPLETED), então não há confirmação a reenviar.',
      rejection_return_replenishment_unsupported: 'Remessas de devolução seguem outro fluxo e não têm confirmação WP15 para reenviar.',
      rejection_lock_unavailable:
        'Não foi possível garantir que não há outro reenvio em andamento, então nada foi enviado. Tente novamente em alguns instantes.',
      rejection_circuit_open: 'A integração da Natura está temporariamente suspensa após falhas repetidas. Nada foi enviado; tente em alguns minutos.',
      rejection_ambiguous_external_reference: 'Esse número corresponde a mais de uma remessa. Escolha abaixo qual delas.',
      rejection_resend_in_progress: 'Já existe um reenvio em andamento para esta remessa.',
      rejection_payload_build_failed: 'Não foi possível montar o payload desta remessa.',
      rejection_integration_unusable: 'A integração Natura desta loja está inativa ou sem as credenciais do WP15.',

      retry_after: 'Tente novamente em até {{seconds}} segundos.',
      use_this_one: 'Usar esta',
    },
    coming_soon: 'Em breve',
  },
  table_paginator: {
    page_by_page: 'por página',
    page: 'página',
    of: 'de',
    total_elements: 'elementos totais',
    previous: 'Anterior',
    next: 'Próximo',
  },
  list_warehouses: {
    warehouses: 'Armazéns',
    empty_table_text: 'Não há armazéns para mostrar.',
    headers: {
      warehouse: 'Armazém',
      address: 'Endereço',
      status: 'Estado',
      country: 'País',
      created_at: 'Criado',
    },
  },
  home: {
    pending_orders: 'Pedidos Pendentes',
    pending: 'Pendentes',
    processing_orders: 'Pedidos em Processamento',
    processing: 'Processamento',
    waiting_pick_up_orders: 'Pedidos Esperando Recoleção',
    waiting_pick_up: 'Esperando Recoleção',
    no_stock_orders: 'Pedidos Sem Estoque',
    no_stock: 'Sem Estoque',
    missing_info_orders: 'Pedidos com Falta de Informação',
    missing_info: 'Falta de Informação',
  },
  pickability: {
    status: {
      FULLY_PICKABLE: 'Sim',
      PARTIALLY_PICKABLE: 'Sim, incompleto',
      NOTHING_PICKABLE: 'Não',
    },
    go_to_break: 'Ir para Caixas para abrir',
    breakdown: {
      pickable: 'Separável',
      blocked: 'Para abrir',
      missing: 'Sem estoque',
    },
  },
  list_orders: {
    pending_orders: 'Pedidos Pendentes',
    empty_table_text: 'Não há pedidos para mostrar.',
    assign_orders: 'Atribuir Pedidos',
    store_search_placeholder: 'Buscar: -A, B',
    area_search_placeholder: 'Buscar: -A, B',
    order_number_search_placeholder: 'Buscar pedido',
    city_search_placeholder: 'Buscar comuna',
    state_search_placeholder: 'Buscar região',
    headers: {
      store: 'Loja',
      area: 'ÁREA',
      products: 'Produtos',
      pickability: 'É separável?',
      max_packing_time: 'Embalar antes de',
      order_number: 'Nº DO PEDIDO',
      city: 'Comuna',
      state: 'Região',
      channel_name: 'Canal',
      shipping_type: 'Tipo de envio',
      shipping_method: 'MÉTODO DE ENVIO',
      same_day: 'Mesmo dia',
      standard: 'Padrão',
      store_search_help_1: 'Para buscar mais de uma loja use "," Ex: Levis, Dossier',
      store_search_help_2: 'Para omitir algumas lojas use "-" EX: -Levis, -Dossier',
      area_search_help_1: 'Para buscar mais de uma área, use "," Ex: A, B',
      area_search_help_2: 'Para omitir algumas áreas, use "-" Ex: -A, -B',
      order_number_search_help: 'Para buscar múltiplos pedidos use "," Ex: ORD-001, ORD-002',
      city_search_help: 'Para buscar múltiplas comunas use "," Ex: Providencia, Las Condes',
      state_search_help_1: 'Para buscar múltiplas regiões use "," Ex: Metropolitana, Valparaíso',
      state_search_help_2: 'Para omitir algumas regiões use "-" Ex: -Metropolitana, -Valparaíso',
    },
    actions: {
      see_order: 'Ver pedido',
      generate_shipment: 'Gerar Etiqueta',
      pick_pieces: 'Pickear itens',
    },
    rem_packing_time: {
      to_be_agreed: 'A combinar',
      set: 'Definir',
      dialog_title: 'Definir prazo de embalagem — {{order_number}}',
      dialog_description: 'Remoção acima de 2000 peças: defina o prazo acordado com a marca. Esta data só pode ser definida uma vez.',
      confirm: 'Salvar',
      cancel: 'Cancelar',
      saving: 'Salvando...',
      error: 'Não foi possível salvar o prazo. Verifique se ele ainda não foi definido e se você gerencia este armazém.',
      error_invalid_date: 'Data inválida ou no passado.',
    },
  },
  list_processing_orders: {
    orders: 'Pedidos',
    title: 'Pedidos em Processamento',
    generate_shipments: 'Gerar Etiquetas',
    generate_shared_shipment: 'Gerar Etiqueta Agrupada',
    fulfill_partially: 'Enviar Parcialmente',
    reassign_picker: 'Reatribuir Picker',
    reassign_picker_in_review_tooltip: 'Este pedido está em revisão. Desfaça a revisão antes de reatribuir o picker.',
    reassign_picker_tooltip: 'Selecione apenas pedidos em estado de Picking ou em Processamento',
    empty_table_text: 'Não há pedidos para mostrar.',
    pick_all_success: 'Pedido pickeado com sucesso',
    store_search_placeholder: 'Buscar: -A, B',
    area_search_placeholder: 'Buscar: -A, B',
    partial_fulfillment: {
      title: 'Enviar Parcialmente',
      confirm_title_single: 'Enviar Parcialmente 1 Pedido',
      confirm_title_multiple: 'Enviar Parcialmente {{count}} Pedidos',
      confirm_description_single: 'Tem certeza de que quer enviar esse pedido parcialmente?',
      confirm_description_multiple: 'Tem certeza de que deseja enviar parcialmente {{count}} pedidos?',
      confirm_label: 'Confirmar',
      cancel_label: 'Cancelar',
      close_label: 'Fechar',
      success_title: 'Envio Parcial Processado',
      success_description: 'Foram enviados parcialmente {{total}} pedidos com sucesso.',
      loading_title: 'Processando Envio Parcial',
      loading_description: 'Aguarde enquanto processamos o envio parcial dos pedidos...',
      completion_title: 'Envio Parcial Processado',
      completion_description: 'Agora você precisa mover os itens para a área de Disgrace.',
      items_to_move: 'Itens para mover:',
      move_to_disgrace_title: 'Mover para a área de Disgrace',
      move_to_disgrace_description: 'Excedente separado: retire-o do tote e coloque na área de Disgrace.',
      not_found_lost_title: 'Não encontradas — registradas como perdidas',
      not_found_lost_description: 'O sistema já as registrou como perdidas. Não há nada para mover.',
      original_location: 'Localização original:',
      new_location: 'Nova localização:',
      error_title: 'Erro ao Enviar Parcialmente',
      error_description: 'Ocorreu um erro ao processar o envio parcial dos pedidos. Por favor, tente novamente.',
      failures_title: 'Envio Parcial com Erros',
      failures_description: 'O envio parcial foi concluído com {{failures}} erros de {{total}} pedidos.',
      bulk_button: 'Enviar Parcialmente',
      banner_message: 'Esse pedido será enviado parcialmente. Certifique-se de remover os itens que não serão enviados.',
      error_missing_stock_title: 'Faltam peças atribuídas ao pedido',
      error_missing_stock_description:
        'Faltam peças atribuídas a este pedido e não é possível continuar por aqui. Use Reverter Picking na handheld, na tela do tote, para devolvê-lo ao início.',
      error_fiscal_block_title: 'Nota fiscal aprovada',
      error_fiscal_block_description:
        'Este pedido já possui uma nota fiscal (NF-e) aprovada. É necessário regenerar a nota fiscal antes de poder enviá-lo parcialmente.',
      error_would_cut_container_title: 'O envio parcial dividiria um contêiner',
      error_would_cut_container_description:
        'Para enviar este pedido parcialmente seria preciso tirar peças de um contêiner e deixar o resto dentro, e isso não é possível no armazém. Use Reverter Picking na handheld, na tela do tote, para devolver o pedido completo ao início junto com suas caixas e paletes.',
      error_containers_not_supported_title: 'Este pedido tem peças em caixas ou paletes',
      error_containers_not_supported_description:
        'Este pedido tem peças dentro de caixas ou paletes, e o envio parcial por esta tela não consegue lidar com caixas nem paletes. Use Reverter Picking na handheld, na tela do tote, para devolver o pedido completo ao início junto com suas caixas e paletes.',
      dialog_error_title: 'Algo deu errado',
      dialog_error_description: 'Ocorreu um erro ao processar o envio parcial.',
      dialog_cancel_label: 'Cancelar',
      dialog_retry_label: 'Reintentar',
      dialog_completion_title: 'Envio Parcial Processado',
      dialog_completion_description_cancel: 'O pedido será cancelado. Mova todos os itens para a área de Disgrace.',
      dialog_completion_description_ready: 'O pedido está pronto para packing',
      dialog_ok_label: 'OK',
    },
    headers: {
      store: 'Loja',
      order_number: 'Nº DE PEDIDO',
      max_packing_time: 'Embalar antes de',
      channel_name: 'Canal',
      tote: 'TOTE',
      assigned_to: 'Picker',
      status: 'Estado',
      shipping_method: 'MÉTODO DE ENVIO',
      requires_partial_fulfillment: 'Envio parcial obrigatório',
      pickability: 'É separável?',
      has_unassigned_pickable: 'Estoque para separar',
      store_search_help_1: 'Para buscar mais de uma loja use "," Ex: Levis, Dossier',
      store_search_help_2: 'Para omitir algumas lojas use "-" EX: -Levis, -Dossier',
      area_search_help_1: 'Para buscar mais de uma área, use "," Ex: A, B',
      area_search_help_2: 'Para omitir algumas áreas, use "-" Ex: -A, -B',
    },
    requires_partial_fulfillment: {
      yes: 'Sim',
      no: 'Não',
      tooltip: 'Este pedido requer ser enviado parcialmente',
    },
    has_unassigned_pickable: {
      filter: 'Com estoque para separar',
      tag: 'Sim',
    },
    actions: {
      generate_shipment: 'Gerar Etiqueta',
      pick_pieces: 'Pickear itens',
      fulfill_partially: 'Enviar Parcialmente',
      undo_in_review: 'Voltar para Picking',
      undo_in_review_loading: 'Voltando para Picking...',
    },
    undo_in_review: {
      error_title: 'Erro ao Voltar para Picking',
      error_no_picking_order: 'Dados do pedido incompletos. Por favor, tente novamente.',
      error_generic: 'Ocorreu um erro ao voltar o pedido para picking. Por favor, tente novamente.',
      error_not_in_review: 'O pedido não está em revisão',
      error_forbidden: 'Você não tem permissão para tirar este pedido da revisão.',
      error_missing_stock:
        'Faltam peças atribuídas a este pedido e não é possível continuar por aqui. Use Reverter Picking na handheld, na tela do tote, para devolvê-lo ao início. Se o pedido tiver caixas ou paletes, reporte ao Tech: não há saída automática.',
      error_requires_partial_fulfillment: 'Este pedido deve ser enviado parcialmente e não pode sair da revisão.',
      error_picker_required: 'Selecione um picker para tirar o pedido da revisão.',
      error_picker_not_found: 'O picker selecionado não existe mais. Atualize a lista e tente novamente.',
      error_picker_not_in_warehouse: 'O picker selecionado não pertence ao armazém deste pedido. Escolha outro.',
      error_picker_cannot_pick: 'O picker selecionado não tem permissão para fazer picking. Escolha outro.',
      dialog_title: 'Voltar para Picking',
      choose_picker_hint: 'Selecione o picker que retoma este pedido.',
      choose_pickers_hint: 'Selecione um ou mais pickers que retomam este pedido.',
      selected_summary: 'Selecionados: {{names}}',
      operators_count_one: '{{count}} operador neste armazém',
      operators_count_other: '{{count}} operadores neste armazém',
      no_pickers: 'Não há pickers disponíveis neste armazém.',
      pickers_error: 'Não foi possível carregar a lista de pickers. Tente novamente.',
      tasks_error: 'Não foi possível carregar as tarefas pendentes. Tente novamente.',
      continue: 'Continuar',
      confirm: 'Voltar para Picking',
      back: 'Voltar',
      distribute_hint: 'Distribua as tarefas pendentes. O que não distribuir fica com {{name}}.',
      default_picker_option: 'Padrão ({{name}})',
      pending_count_one: '{{count}} pendente',
      pending_count_other: '{{count}} pendentes',
      no_pending: 'Não há tarefas pendentes para distribuir.',
      picker_for_location: 'Picker para {{location}}',
      error_has_holded_stock:
        'O pedido não pode ser removido da revisão porque tem estoque bloqueado. Para processá-lo, a marca deve desbloquear o estoque, ou você pode enviá-lo parcialmente. Para ver o detalhe do estoque, consulte a seção de pedidos em revisão na handheld.',
      error_has_holded_stock_no_partial:
        'O pedido não pode ser removido da revisão porque tem estoque bloqueado. Para processá-lo, a marca deve desbloquear o estoque. Para ver o detalhe do estoque, consulte a seção de pedidos em revisão na handheld.',
      error_has_expired_stock: 'O pedido não pode ser removido da revisão porque tem estoque expirado. Para processá-lo, envie-o parcialmente.',
      error_has_expired_stock_no_partial:
        'O pedido não pode ser removido da revisão porque tem estoque expirado, e sua loja não tem o envio parcial habilitado. Reporte ao Tech.',
      error_order_interrupted: 'Este pedido foi cancelado, não pode ser removido da revisão. O tote deve ser esvaziado na estação de revisão.',
      error_in_packing_status: 'O pedido está em packing, por favor entre em contato com a equipe tech para revisar este pedido',
      error_ok_label: 'OK',
    },
  },
  list_orders_shipped: {
    title: 'Pedidos Enviados',
    reassignment_of_orders: 'Reatribuir Pedidos',
    empty_table_text: 'Não há pedidos para mostrar.',
    actions: {
      print_shipping_label: 'Imprimir etiqueta de envio',
      regenerate_shipping_label: 'Regenerar etiqueta de envio',
      print_packing_list: 'Imprimir packing list',
    },
    headers: {
      order_number: 'Nº DO PEDIDO',
      shipping_method: 'MÉTODO DE ENVIO',
      shipping_type: 'Tipo de envio',
      status: 'Estado',
      shipping_status: 'Estado de envio',
      incident: 'Incidente',
    },
  },
  list_returns: {
    returns: 'Retornos',
    empty_table_text: 'Não há retornos para mostrar.',
    require_monitoring: 'Requerem monitoramento',
    statuses: {
      arrived_at_warehouse: 'Chegou ao armazém',
      awaiting_return: 'Aguardando retorno',
    },
    scan_package_title: 'Escaneie o pacote para identificar',
    scan_package_placeholder: 'Escaneie a guia de retorno, a ordem de packing list ou RMA ou a chave',
    headers: {
      store: 'Loja',
      returned_order_number: 'Nº DO PEDIDO RETORNADO',
      created_order_number: 'Nº DO NOVO PEDIDO',
      type: 'Tipo',
      status: 'Estado',
      shipping_number: 'Etiqueta de retorno',
      created_at: 'Data de criação',
    },
  },
  list_locations: {
    locations: 'Localizações',
    locations_by_product: 'Localizações por produto',
    location_to_export_description: 'Com localização igual ou parecida a ',
    sku_to_export_description: 'Com SKU igual ou parecido a ',
    upc_to_export_description: 'Com UPC igual ou parecido a ',
    store_to_export_description: 'Com nome de loja igual ou parecido a ',
    location_type_to_export_description: 'Com tipo de localização ',
    product_name_to_export_description: 'Com nome de produto igual ou parecido a ',
    export_all_products_description: 'Serão exportados todos os produtos do armazém. Se desejar, use os filtros para obter um relatório específico.',
    headers: {
      product_image_path: 'Imagem',
      location_code: 'Localização',
      store: 'Loja',
      location_type: 'Tipo',
      product_name: 'Nome do Produto',
      sku: 'SKU',
      upc: 'UPC',
      stock_total_count: 'Quantidade',
      stock_by_lot: 'Lotes',
    },
    containers_cell: {
      box_one: 'caixa',
      box_other: 'caixas',
      pallet_one: 'palete',
      pallet_other: 'paletes',
      in: 'em',
      view_detail: 'Ver detalhe',
    },
    containers_panel: {
      title: 'Contêineres na localização',
      empty: 'Não há contêineres nesta localização.',
      pallet: 'Palete',
      box: 'Caixa',
      loose: '(avulsa)',
      code: 'código',
      no_barcode: 'Sem código',
      content: 'Conteúdo',
      lot: 'Lote',
      piece_one: 'peça',
      piece_other: 'peças',
      box_one: 'caixa',
      box_other: 'caixas',
      pallet_one: 'palete',
      pallet_other: 'paletes',
    },
    lot_columns: {
      lot: 'Lote',
      qty: 'Qtd.',
      expires: 'Vence',
    },
    no_lot: 'Sem lote',
    empty_table_text: 'Não há produtos para mostrar.',
    empty_table_text_lot_code: 'Não há estoque do lote indicado.',
    export_inventory_title: 'Exportar inventário',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    inventory: 'Inventário',
    inventory_history: 'Histórico de inventário',
    download: 'Download',
    export: 'Exportar',
    view_locations: 'Ver Localizações',
    delete_lost_stock: 'Eliminar Estoque Perdido',
    found_stock_button: 'Sobras',
    found_stock_pending_one: '{{count}} declaração de sobras pendente',
    found_stock_pending_other: '{{count}} declarações de sobras pendentes',
  },
  simulate_putaway: {
    button_label: 'Putaway para Localizações',
    title: 'Putaway para Localizações',
    description:
      'Carregue um arquivo CSV com SKU, código de localização e quantidade para executar o putaway de um replenishment para localizações específicas. Opcionalmente, pode incluir código de lote e data de validade.',
    instructions_title: 'Instruções',
    instruction_1: 'Colunas obrigatórias: sku, warehouse_location_code, quantity',
    instruction_2: 'Colunas opcionais: lot_code, expiration_date (formato YYYY-MM-DD ou DD/MM/YY)',
    instruction_3: 'A quantidade deve ser um número inteiro maior que 0',
    instruction_4: 'O código de localização deve corresponder a uma localização existente no armazém',
    instruction_5: 'Também são aceitas colunas em espanhol: CUBBO, SKU, Lote, Vencimiento, Suma de Cant.',
    download_template: 'Baixar modelo CSV',
    replenishment_id_label: 'ID do Replenishment',
    replenishment_id_placeholder: 'Ex: 1234',
    file_label: 'Arquivo CSV',
    file_placeholder: 'Arraste ou clique para enviar um arquivo CSV',
    file_help: 'Apenas arquivos .csv (máximo 10MB)',
    warnings_title: 'Avisos no arquivo',
    preview_title: '{{count}} linhas válidas encontradas',
    column_location: 'Localização',
    column_quantity: 'Quantidade',
    column_lot_code: 'Lote',
    column_expiration_date: 'Validade',
    progress_label: 'Processando putaway...',
    task_errors_title: 'Erros no putaway',
    buttons: {
      cancel: 'Cancelar',
      close: 'Fechar',
      confirm: 'Executar Putaway ({{count}} linhas)',
      processing: 'Processando...',
    },
    validation: {
      missing_columns: 'Colunas faltantes no CSV: {{columns}}',
      missing_sku: 'Linha {{row}}: SKU é obrigatório',
      missing_location: 'Linha {{row}}: Código de localização é obrigatório',
      invalid_quantity: 'Linha {{row}}: Quantidade deve ser um número maior que 0',
      invalid_expiration_date: 'Linha {{row}}: Data de validade tem formato inválido (usar YYYY-MM-DD ou DD/MM/YY)',
      lot_without_expiration: 'Linha {{row}}: Lote "{{lot_code}}" não tem data de validade — será obrigatória se o lote for novo',
      skipped_empty_lots: '{{count}} linhas sem código de lote — serão processadas sem lote',
      parse_error: 'Erro ao ler o arquivo: {{message}}',
    },
    success_title: 'Putaway Concluído',
    success_description: '{{count}} registros foram processados corretamente.',
    error_title: 'Erro no Putaway',
    error_generic: 'Ocorreu um erro ao processar a solicitação.',
    error_conflict: 'Já existe uma tarefa de putaway em andamento para este replenishment.',
    error_not_found: 'Não foi encontrado o replenishment com o ID fornecido.',
    error_types: {
      quantity_mismatch: 'Quantidade não corresponde',
      missing_product: 'Produto ausente no arquivo',
      product_not_in_replenishment: 'Produto não pertence ao replenishment',
      sku_not_found: 'SKU não encontrado',
      location_not_found: 'Localização não encontrada',
      invalid_location_type: 'Tipo de localização não permitido',
      missing_field: 'Campo obrigatório ausente',
      invalid_field: 'Campo inválido',
      invalid_status: 'Estado do replenishment não válido',
      invalid_state: 'O replenishment já possui stock units criados',
      replenishment_not_found: 'Replenishment não encontrado',
      execution_error: 'Erro durante a execução',
      unexpected_error: 'Erro inesperado',
      job_failed: 'O processo falhou inesperadamente',
    },
  },
  location_modals: {
    create_location_modal: {
      title: 'Criar Localizações do Armazém',
      description: 'Configure os parâmetros para criar novas localizações no armazém',
      success_title: 'Localizações Criadas com Sucesso',
      success_description: 'As localizações foram criadas corretamente no armazém.',
      fields: {
        location_type: 'Tipo de Localização',
        location_type_explanation: 'Isso dita a funcionalidade da localização dentro do armazém',
        volume_category: 'Categoria de Volume',
        volume_category_explanation: 'Isso dita a maneira como os clientes serão cobrados',
        area: 'Área',
        row: 'Fila',
        bay_min: 'Baía Mínima',
        bay_max: 'Baía Máxima',
        height_min: 'Altura Mínima',
        height_max: 'Altura Máxima',
        max_sku_capacity: 'Capacidade Máxima SKU',
        picking_priority: 'Prioridade de Picking',
      },
      placeholders: {
        area: 'Ex: A, AA',
        row: 'Ex: 01, 02',
        bay_min: '1',
        bay_max: '10',
        height_min: 'A',
        height_max: 'G',
        max_sku_capacity: 'Ex: 100',
        picking_priority: 'Ex: 1',
      },
      buttons: {
        cancel: 'Cancelar',
        create: 'Criar Localizações',
        creating: 'Criando...',
      },
      validation: {
        required_fields: 'Por favor complete todos os campos obrigatórios',
        warehouse_specific: 'Para este armazém, a capacidade máxima SKU e prioridade de picking são obrigatórias',
        creation_error: 'Erro ao criar as localizações',
      },
      preview: {
        title: 'Pré-visualização dos códigos de localização:',
        from: 'De',
        to: 'até',
        format: 'Formato: Área-Fila-Baía-Altura',
        warning: 'Nota: Se tentares criar localizações que já existem, serão omitidas automaticamente.',
      },
    },
    bulk_edit_location_modal: {
      title: 'Editar Localizações do Armazém',
      description: 'Edite as localizações existentes no armazém em lote',
      success_title: 'Localizações Editadas com Sucesso',
      success_description: 'As localizações foram atualizadas corretamente no armazém.',
      fields: {
        location_type: 'Tipo de Localização',
        volume_category: 'Categoria de Volume',
        area: 'Área',
        row: 'Fila',
        bay_min: 'Baía Mínima',
        bay_max: 'Baía Máxima',
        height_min: 'Altura Mínima',
        height_max: 'Altura Máxima',
        max_sku_capacity: 'Capacidade Máxima SKU',
        picking_priority: 'Prioridade de Picking',
      },
      placeholders: {
        area: 'Ex: A, AA',
        row: 'Ex: 01, 02',
        bay_min: '1',
        bay_max: '10',
        height_min: 'A',
        height_max: 'G',
        max_sku_capacity: 'Ex: 100',
        picking_priority: 'Ex: 1',
      },
      buttons: {
        cancel: 'Cancelar',
        edit: 'Editar Localizações',
        editing: 'Editando...',
      },
      validation: {
        required_fields: 'Por favor complete todos os campos obrigatórios',
        warehouse_specific: 'Para este armazém, a capacidade máxima SKU e prioridade de picking são obrigatórias',
        edit_error: 'Erro ao editar as localizações',
      },
      loading: 'Carregando opções...',
      preview: {
        title: 'Pré-visualização dos códigos de localização:',
        from: 'De',
        to: 'até',
        format: 'Formato: Área-Fila-Baía-Altura',
      },
    },
    view_warehouse_locations: {
      title: 'Localizações do Armazém',
      warehouse_prefix: 'Armazém',
      buttons: {
        create_locations: 'Criar Localizações',
        edit_locations: 'Editar Localizações',
      },
      table: {
        label: 'Localizações',
        empty_text: 'Não há localizações para mostrar.',
        headers: {
          location_type: 'Tipo de Localização',
          volume_category: 'Categoria de Volume',
          unique_code: 'Código de Localização',
          max_sku_capacity: 'Capacidade Máxima SKU',
          picking_priority: 'Prioridade de Picking',
        },
      },
    },
  },
  list_claims: {
    title: 'Disputas',
    headers: {
      order_number: 'Nº DO PEDIDO',
      store_name: 'LOJA',
      status: 'ESTADO',
      accepted_value: 'VALOR ACEITO',
      area: 'ÁREA',
      category: 'CATEGORIA',
      created_at: 'DATA DE CRIAÇÃO',
    },
    empty_table_text: 'Não há disputas para mostrar.',
  },
  list_operators: {
    title: 'Gestão de Operadores',
    new_operator: 'Novo Operador',
    name: 'Nome',
    surname: 'Sobrenome',
    email: 'E-mail',
    password: 'Senha',
    copy_email: 'Copiar e-mail',
    generate_password: 'Gerar Senha',
    sso_no_password: 'Este e-mail entra com o Google, sem senha. Os papéis e armazéns atribuídos aqui se aplicam à conta Google dele.',
    user_exists: 'Já existe um usuário com este e-mail. Peça a um administrador que edite os papéis e armazéns dele.',
    sso_required: 'Este e-mail ainda não pode ser cadastrado aqui: a pessoa precisa entrar com o Google primeiro.',
    account_outside_domain: 'Esta conta pertence à equipe da Cubbo. Somente um administrador da Cubbo pode criá-la ou alterá-la.',
    copy_password: 'Copiar Senha',
    create_operator: 'Criar Operador',
    operators: 'Operadores',
    warehouses: 'Armazéns',
    warehouses_column: 'Armazéns',
    all_warehouses: 'Todos',
    select_warehouses: 'Selecionar armazéns',
    warehouses_required: 'Você deve selecionar pelo menos um armazém.',
    search_by_name: 'Buscar por nome, sobrenome ou e-mail',
    search_by_role: 'Buscar por cargo',
    roles: 'Cargos',
    wh_admin_elevated_notice:
      'O Administrador de armazém tem acesso total a todas as áreas. Apenas um administrador de armazém (ou superior) pode atribuir esta função.',
    customer_app_access: 'Habilitar acesso ao OMS',
    disable_customer_app_access: 'Desabilitar acesso ao OMS',
    wh_admin_oms_access: 'Habilitar acesso ao OMS',
    disable_wh_admin_oms_access: 'Desabilitar acesso ao OMS',
    show_active_only: 'Mostrar somente usuários ativos',
    empty_table_text: 'Não há operadores para mostrar.',
    has_oms_access: 'Acesso ao OMS',
    notifications: {
      copied: 'Copiado!',
      operator_created: 'Operador criado!',
      operator_creation_failed: 'Erro ao criar o operador.',
      operator_roles_updated_success: 'Cargos atualizados com sucesso!',
      operator_updated_success: 'Operador atualizado com sucesso!',
      operator_deleted_success: 'Operador deletado com sucesso!',
      operator_roles_updated_failed: 'Houve um erro ao modificar os cargos, por favor tente novamente.',
      operator_warehouses_updated_success: 'Armazéns atualizados com sucesso!',
      operator_warehouses_updated_failed: 'Houve um erro ao modificar os armazéns, por favor tente novamente.',
      customer_app_enabled_success: 'Acesso ao OMS alterado com sucesso!',
      customer_app_enabled_failed: 'Houve um erro ao alterar acesso ao OMS, por favor tente novamente.',
      operator_status_update_failed: 'Houve um erro ao alterar o status do usuário, por favor tente novamente.',
      operator_edit_refused: 'Você não tem permissão para alterar este usuário.',
      password_reset_success: 'A senha foi atualizada com sucesso!',
      password_reset_error: 'Erro ao redefinir a senha.',
    },
    password_rules: {
      length: 'A senha deve ter pelo menos {{count}} caracteres',
      lengthAtLeast: 'Pelo menos {{count}} caracteres de comprimento',
      containsAtLeast: 'Conter pelo menos {{min}} dos seguintes {{total}} tipos de caracteres:',
      items: {
        lowerCase: 'letras minúsculas (a-z)',
        upperCase: 'letras maiúsculas (A-Z)',
        numbers: 'números (0-9)',
        specialCharacters: 'caracteres especiais (ex. !@#$%^&*)',
      },
    },
    disable_user: 'Desabilitar usuário',
    enable_user: 'Habilitar usuário',
    reset_password: 'Redefinir Senha',
    detail: {
      roles: 'Cargos atribuídos',
      warehouses: 'Armazéns associados',
      status_active: 'Ativo',
      status_disabled: 'Desabilitado',
      no_warehouses: 'Sem armazéns atribuídos',
    },
  },
  replenishments: {
    inbound_appointments: {
      statuses: {
        unknown: 'Sem status',
        booked: 'Agendada',
        checked_in: 'Recebida',
        canceled: 'Cancelada',
        no_show: 'Não chegou',
        superseded: 'Reagendada',
      },
      classes: {
        standard: 'Programada',
        express: 'Express',
        extemporaneous: 'Extemporânea',
      },
      unload: {
        title: 'Descarga',
        started_label: 'Início da descarga',
        ended_label: 'Fim da descarga',
        include_end: 'Registrar também o fim da descarga',
        now: 'Agora',
        save: 'Salvar descarga',
        saved: 'Descarga registrada ✓',
      },
      extemporaneous: {
        button: 'Registrar chegada extemporânea',
        confirm_title: 'Registrar chegada extemporânea',
        confirm_description:
          'A chegada deste recebimento será registrada com a data de hoje, sem faixa e sem reserva de capacidade. Esta ação não pode ser desfeita daqui.',
        confirm: 'Registrar',
        cancel: 'Cancelar',
        success: 'Chegada extemporânea registrada',
      },
      overrides: {
        title: 'Capacidade de recebimento',
        from: 'De',
        to: 'Até',
        create: 'Criar ajuste',
        all_day: 'Dia todo',
        superseded: 'Substituída',
        blocked_pill: 'Bloqueado',
        no_overrides: 'Não há ajustes neste período',
        headers: {
          date: 'Data',
          franja: 'Faixa',
          dock: 'Docas',
          man_hours: 'Horas-homem',
          units_delta: 'Δ peças',
          blocked: 'Bloqueado',
          reason: 'Motivo',
          created_at: 'Criado',
        },
        load_error: 'Não foi possível carregar os ajustes',
        franjas_load_error: 'Não foi possível carregar as faixas de recebimento',
        retry: 'Tentar novamente',
        form: {
          title: 'Criar ajuste de capacidade',
          date: 'Data',
          franja: 'Faixa',
          dock: 'Ajuste de docas',
          man_hours: 'Ajuste de horas-homem',
          man_hours_day_only: 'Horas-homem só se aplicam ao dia todo',
          units_delta: 'Peças extras (±)',
          units_delta_franja_only: 'As peças extras exigem uma faixa',
          capacity_preview: 'Capacidade atual: {{current}} → com ajuste: {{result}}',
          blocked: 'Bloquear o dia (feriado, manutenção…)',
          blocked_confirm_title: 'Bloquear dia de recebimento',
          blocked_confirm_description:
            'A capacidade de recebimento será bloqueada para a data selecionada. Na v1 os ajustes não podem ser editados nem excluídos pela interface: o bloqueio ficará ativo até uma correção manual. Continuar?',
          blocked_confirm: 'Bloquear',
          reason: 'Motivo',
          cancel: 'Cancelar',
          create: 'Criar',
        },
        notifications: {
          created: 'Ajuste criado',
        },
      },
      board: {
        title: 'Agendamentos de recebimento',
        date_label: 'Data',
        status_label: 'Status',
        class_label: 'Tipo',
        all: 'Todos',
        extemporaneous_group: 'Extemporâneos',
        no_appointments: 'Sem chegadas nesta faixa',
        no_appointments_day: 'Não há agendamentos para esta data',
        store: 'Loja',
        replenishment: 'Recebimento',
        units: '{{units}} peças',
        units_boxes: '{{units}} peças · {{boxes}} caixas',
        checked_in_at: 'Check-in: {{time}}',
        load_error: 'Não foi possível carregar os agendamentos',
        franjas_load_error: 'Não foi possível carregar as faixas de recebimento',
        retry: 'Tentar novamente',
        no_appointments_filtered: 'Sem resultados para estes filtros',
        arrivals_filter: 'Chegadas',
        arrivals_count_one: '{{count}} chegada',
        arrivals_count_other: '{{count}} chegadas',
        capacity_full: 'cheio',
        capacity_reserved: 'reservado',
        capacity_blocked: 'Bloqueada',
        capacity_error: 'Não foi possível carregar a capacidade por faixa',
        early: {
          title: 'Recebidos antecipadamente',
          summary_one: '{{count}} agendamento · {{units}} peças',
          summary_other: '{{count}} agendamentos · {{units}} peças',
          received_on: 'Recebido em {{date}} às {{time}}',
        },
        week: {
          toggle_week: 'Semana',
          toggle_day: 'Dia',
          franja_header: 'Faixa',
          today: 'hoje',
          extemporaneous_row: 'Extemporâneas',
          total_row: 'Total de caminhões',
          early_row: 'Recebidos antecipadamente',
          load_error: 'Não foi possível carregar a visão semanal',
          stale_error: 'Não foi possível atualizar a visão semanal',
          header_label: 'Ver {{day}}',
          cell_label: 'Ver {{day}} · {{franja}}',
          empty: 'Não há faixas nem chegadas nesta semana',
        },
      },
      errors: {
        generic: 'Ocorreu um erro. Tente novamente.',
        forbidden: 'Você não tem permissão para esta ação',
        inbound_scheduling_disabled: 'O agendamento nativo não está habilitado neste armazém',
        replenishment_not_bookable: 'O status do recebimento não permite esta ação',
        already_booked: 'Este recebimento já tem um agendamento ativo',
        appointment_not_active: 'O agendamento não está mais ativo',
        invalid_unload_window: 'Janela de descarga inválida: o fim deve ser posterior ao início e ambos dentro de ±2 dias da data do agendamento',
        invalid_override: 'Ajuste inválido: horas-homem só se aplicam ao dia todo e peças extras exigem faixa',
      },
    },
    show_replenishment: {
      title: 'Agendamento de Recibo',
      products: 'Produtos',
      sell_ahead: 'Pré-venda',
      not_sell_ahead: 'Não-pré-venda',
      open_receipt: 'Voltar a abrir remessa',
      complete_receipt: 'Completar Remessa',
      modify_lots: 'Modificar lotes do último produto escaneado',
      edit_lots: 'Editar lotes',
      finish_check_in: 'Terminar check-in',
      receipt_correction: 'Correcção de remessa',
      name: 'Nome',
      skus: 'SKUs',
      upc: 'UPC',
      new_quantity: 'Novo número de peças em recebimento',
      cancel: 'Cancelar',
      correct: 'Corrigir',
      continue: 'Continuar',
      no_pieces_in_receipt: 'Não há nenhuma peça em remessa',
      attention: 'Atención',
      accept: 'Aceitar',
      scan_product: 'Escanea o produto para identificar',
      products_with_lots: 'produtos com lotes registrados',
      filter_no_lots: 'Produtos sem lote registrado',
      receipt_stage_complete: 'Etapa de Recebimento Completa mas ainda há peças por localizar em Put Away.',
      segregated_check: 'O produto vem corretamente separado.',
      labeled_check: 'O produto vem corretamente etiquetado.',
      inventory_receipt: 'Recibo de inventário',
      no_lot: 'Não tem lote',
      no_lot_required: 'Não requer lote',
      replenishment_completed: 'Remessa concluída',
      receipt_completed: 'Remessa concluída',
      quality_check: 'Controle de qualidade',
      received_pieces: 'Peças recebidas',
      damaged_dialog_1: 'Mova ',
      damaged_dialog_2: ' peças para a localização: D-1-1-1 e clique em continuar',
      complete_dialog_1: 'Há ',
      complete_dialog_2: ' produtos com peças em remessa. Aceita completar a remessa e que essas peças sejam eliminadas?',
      how_many_boxes: 'Quantos bultos/caixas vêm neste recibo?',
      attended_appointment: 'Cumpriu com agendamento.',
      mark_as_received: 'Marcar como recebido',
      receive: 'Receber',
      damaged: 'Danificado',
      product_exists_but_not_in_receipt: 'Este produto existe na loja, mas não está no recibo',
      add_to_receipt: 'Adicionar ao recibo',
      start_check_in: 'Iniciar check-in',
      count_pieces_by_sku_or_upc: 'Conta peças por SKU ou UPC',
      start: 'Iniciar',
      searching: 'Buscando...',
      product_not_found: 'O SKU buscado não existe',
      select_lot: 'Este produto tem mais de um lote, selecione um para continuar',
      store_not_configured: 'Esta loja não foi configurada para poder iniciar o recibo. Por favor, contacte o representante de vendas da loja.',
      notifications: {
        quality_check_saved: 'Quality check guardado',
        duplicate_product_added: 'Este produto já foi adicionado ao recibo anteriormente',
      },
      columns: {
        lot: 'Lote',
        name: 'Nome',
        sku: 'SKU',
        upc: 'UPC',
        counted: 'Contadas',
        actions: 'Ações',
        expected_quantity: 'Esperadas',
        processed_quantity: 'Processadas',
        in_reception: 'Em recebimento',
      },
      how_many_boxes_in_receipt: 'Quantas caixas chegaram?',
    },
    show_replenishment_boxes: {
      in_putaway: 'Etapa de Recebimento Concluída, mas ainda há peças para localizar no Put Away.',
      completed: 'Etapa de Recebimento Concluída',
      start_check_in_title: 'Iniciar check-in',
      start_chcek_in_button: 'Iniciar',
      complete_receive_button: 'Não há mais peças para contar',
      complete_putaway_button: 'Finalizamos o putaway',
      reopen_button: 'Voltar para contar peças',
      last_movements: 'Últimos produtos que escaneei',
      complete_replenishment_dialog: {
        received_less_than_expected_title: 'Diferenças detectadas',
        received_less_than_expected_description: 'Para alguns produtos, foram contadas menos peças do que o esperado',
        received_less_than_expected_confirm_question: 'Tem certeza de que não há mais peças para contar?',
        confirm_button: 'Confirmar',
        cancel_button: 'Voltar e revisar',
      },
      receive_options: {
        title: 'O que você vai contar agora?',
        options: {
          complete_boxes: 'Caixas completas',
          uncomplete_boxes: 'Caixas parciais',
        },
        receiving_title: 'Você está contando',
        scan_input_title: 'Escaneie o código da caixa',
        scan_input_placeholder: 'Escaneie',
        scan_input_receing: 'Recebendo caixa...',
      },
      scan_quantity_barcode_dialog: {
        title: 'Peças contidas na caixa',
        description: 'Escaneie o código da caixa com a quantidade do produto ou digite a quantidade',
        scan_input_placeholder: 'Escaneie o código ou digite a quantidade',
        confirm_button: 'Inserir',
      },
      supplier_invoice: {
        chip_label: 'Nota fiscal: {{number}}',
        chip_empty: 'Adicionar nota fiscal',
        change: 'Alterar',
        add: 'Adicionar',
        dialog_title: 'Nota fiscal do fornecedor',
        dialog_description: 'As caixas recebidas serão associadas a esta nota fiscal até que você a altere.',
        input_placeholder: 'ex.: F-505',
        save: 'Salvar',
        remove: 'Remover nota fiscal',
        cancel: 'Cancelar',
        column_header: 'Notas fiscais',
        active_label: 'Nota fiscal em processo',
        tooltip_active: 'As peças recebidas serão associadas a esta nota fiscal. Toque para alterá-la.',
        tooltip_empty: 'Nenhuma nota fiscal atribuída: as peças recebidas não ficarão associadas a uma nota. Toque para adicionar.',
        correction_per_invoice: 'Peças em recepção por nota fiscal',
        correction_total: 'Total em recepção',
        required_before_scan: 'Informe a nota fiscal antes de escanear. Toque em "Adicionar nota fiscal" para adicioná-la.',
        has_invoice_question: 'Este recebimento vem com nota fiscal do fornecedor?',
        has_invoice_help: 'Se marcada, será obrigatório informar a nota fiscal para receber.',
        receive_requires_invoice: 'Adicione uma nota fiscal para receber',
        pieces_received: '{{count}} peças recebidas',
      },
      supplier_invoice_files: {
        documents_button: 'Documentos',
        title: 'Documentos do recebimento',
        description: 'Anexe documentos do recebimento, como a nota fiscal do fornecedor. Ficam visíveis para todos que recebem este abastecimento.',
        upload: 'Enviar documentos',
        uploading: 'Enviando…',
        drop_placeholder: 'Toque aqui ou arraste seus documentos.',
        delete: 'Excluir',
        upload_error: 'Não foi possível enviar o documento. Tente novamente.',
        delete_error: 'Não foi possível excluir o documento. Tente novamente.',
      },
      received_boxes_table: {
        columns: {
          product_name: 'Nome',
          scanned_box: 'Caixa escaneada',
          lot: 'Lote | Expiração',
          sku: 'SKU | UPC',
          expected: 'Peças esperadas',
          received: 'Peças recebidas',
          received_boxes: 'Total de caixas recebidas',
          received_pieces: 'Total de peças recebidas',
          pieces_status: 'Estado das Peças',
          in_putaway: 'Em Putaway',
          actions: '',
        },
        complete_boxes_plural: '{{quantity}} caixas completas',
        uncomplete_boxes_plural: '{{quantity}} caixas parciais',
        not_damaged_pieces_plural: '{{quantity}} bom estado',
        damaged_pieces_plural: '{{quantity}} danificadas',
        fix_DAMAGED_button: 'Corrigir danificadas',
        fix_PUTAWAY_button: 'Corrigir quantidade',
        send_to_damage_button: 'Danificada.',
        empty_table: 'Sem conteúdo',
        empty_movements: 'Nenhum movimento registrado ainda',
        cannot_edit_damaged: 'Não é possível corrigir danificadas porque não há peças recebidas',
        cannot_edit_quantity: 'Não é possível corrigir a quantidade porque não há peças recebidas',
        cannot_send_to_damage: 'Não é possível enviar para danificado porque não há peças recebidas',
        damaged_pieces_dialog: {
          title: 'Quantas peças deste produto deseja marcar como danificadas?',
          description: 'Separe as peças para colocá-las em uma posição de danificado no armazém',
          confirm_button: 'Confirmar',
          cancel_button: 'Cancelar',
        },
        fix_quantity: {
          PUTAWAY_title: 'Correção de peças aguardando putaway',
          DAMAGED_title: 'Correção de peças danificadas',
          product_name: 'Nome do produto',
          sku: 'SKU | UPC',
          lot: 'Lote | Expiração',
          PUTAWAY_description: 'Quantidade atualizada de peças aguardando putaway',
          DAMAGED_description: 'Quantidade atualizada de peças danificadas',
          confirm_button: 'Atualizar',
          cancel_button: 'Cancelar',
        },
        filters: {
          sku: {
            title: 'SKU',
          },
          upc: {
            title: 'UPC',
          },
          lot_unique_code: {
            title: 'Código do lote',
          },
          box_barcode: {
            title: 'Código de barras da caixa',
          },
          pending_to_receive: {
            title: 'Com peças pendentes de recebimento',
          },
          pending_to_putaway: {
            title: 'Com peças pendentes de putaway',
          },
        },
      },
      errors: {
        send_pieces_to_damage: "Ocorreu um erro ao enviar para danificado, foi relatado o seguinte erro: '{{error_data}}'",
        adjust_putaway_pieces: "Ocorreu um erro ao ajustar peças no putaway, foi relatado o seguinte erro: '{{error_data}}'",
        invalid_barcode:
          "O código que você escaneou '{{barcode}}' não corresponde ao código de barras de uma caixa da loja. Tente novamente e, se o erro persistir, peça ajuda ao time de tech para validar o formato do código",
        receive_error: "Não foi possível receber a caixa, foi relatado o seguinte erro: '{{error_data}}'",
        quality_check_error: "Ocorreu um erro na verificação de qualidade, foi relatado o seguinte erro: '{{error_data}}'",
        start_error: "Ocorreu um erro ao iniciar o recebimento, foi relatado o seguinte erro: '{{error_data}}'",
        complete_receive_error: "Ocorreu um erro ao completar o recebimento de peças, foi relatado o seguinte erro: '{{error_data}}'",
        complete_putaway_error: "Ocorreu um erro ao completar o putaway, foi relatado o seguinte erro: '{{error_data}}'",
        reopen_error: 'Não foi possível reabrir o recebimento: {{error}}',
        generic: 'ocorreu um erro inesperado',
        receive_damaged_error: "Ocorreu um erro ao enviar as peças para danificado, foi relatado o seguinte erro: '{{error_data}}'",
      },
      error_codes: {
        lot_not_found:
          "Esta caixa não pode ser recebida, pois o lote do produto não está registrado na loja. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
        sku_not_found:
          "Esta caixa não pode ser recebida, pois o SKU do produto não está registrado na loja. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
        no_expected_product_quantity:
          "Este produto não era esperado neste recebimento, portanto não pode ser inserido. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
        unexpected_product_count:
          "Já foram recebidas todas as unidades esperadas deste produto. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
      },
      receive_progress_bar: {
        title: 'Progresso geral do recebimento',
        remaining_pieces: 'Faltam {{quantity}} peças para receber',
        received_boxes: '{{complete_boxes}} caixas completas e {{uncomplete_boxes}} caixas parciais',
        update_quantity: 'Corrigir quantidades recebidas',
        show_breakdown: 'Ver detalhamento das peças',
        general_quantity: '{{received_pieces}} de {{expected_pieces}} peças contadas',
      },
      putaway_progress_bar: {
        title: 'Progresso geral do putaway',
        remaining_pieces: 'Faltam {{quantity}} peças recebidas para completar o putaway',
        update_quantity: 'Corrigir quantidades recebidas',
        show_breakdown: 'Ver detalhamento das peças',
        general_quantity: '{{putaway_pieces}} de {{check_in_pieces}} peças recebidas com putaway concluído',
      },
      breakdown: {
        title: 'Detalhes das peças do recebimento',
      },
    },
    inventory_receipt: 'Recibo de inventário',
  },
  list_active_replenishments: {
    replenishment: 'Remessa',
    replenishments: 'Remessas',
    empty_table_text: 'Não há remessas de inventário para mostrar.',
    receive: 'Receber',
    reverse_logistics_replenishments: 'Remessas de Logística Reversa',
    bulk_reverse_logistics_replenishments: 'Remessas de Logística Reversa em Bulk',
    bulk_empty_table_text: 'Não há remessas de logística reversa em bulk para mostrar.',
    headers: {
      id: 'Id',
      store: 'Loja',
      notes: 'Notas',
      status: 'Estado',
      created_at: 'Data de criação',
      has_containers: 'Contêineres',
      sell_ahead: 'Pré-venda',
      has_expirations: 'Tem expirações',
      actions: 'Ações',
      products: 'Produtos',
      received_quantity: 'Quantidade recebida',
      pending_transfer: 'Pendente de transferir',
      scanned_label: 'Etiqueta escaneada',
      scanned_label_placeholder: 'Buscar por guia ou pedido',
    },
    bulk_status: {
      pending: 'Pendente',
      completed: 'Concluído',
    },
    bulk_id: 'Bulk ID',
    replenishment_id: 'Remessa ID',
    bulk_return_label: 'Retorno em Bulk',
    bulk_replenishment_products: 'Produtos da remessa em bulk',
    bulk_replenishment_products_description: 'Total de produtos de todos os retornos nesta remessa em bulk',
    view_session: 'Ver detalhe',
    reprint_label: 'Reimprimir etiqueta',
  },
  csv_grid: {
    upload: 'Enviar CSV',
    paste: 'Colar CSV',
    paste_placeholder: 'Cole aqui seu CSV (inclua a linha de cabecalhos)',
    paste_apply: 'Carregar',
    download_template: 'Baixar modelo',
    add_row: 'Adicionar linha',
    remove_row: 'Remover linha',
    errors: {
      required: 'Obrigatorio',
      not_a_number: 'Deve ser um numero',
      too_small: 'Valor muito baixo',
      csv_only: 'Somente arquivos .csv sao aceitos',
      parse_failed: 'Nao foi possivel ler o arquivo',
      parse_issues: 'O CSV tem {{count}} linhas com formato invalido. Revise e envie novamente.',
      not_positive: 'Deve ser maior que 0',
      min_cost: 'Minimo 0.01',
      need_cost_or_enabled: 'Informe um preco ou habilite/desabilite a cobertura',
      need_cost: 'Informe um preco',
      duplicate_tier: 'Ja existe uma linha com este peso para esta zona',
      duplicate_id: 'Este id está repetido em outra linha',
      empty: 'Nenhuma linha com dados encontrada',
    },
  },
  common: {
    yes: 'Sim',
    no: 'Não',
    accept: 'Aceitar',
    cancel: 'Cancelar',
    warning: 'Atenção!',
    beta_badge: 'Beta',
    beta_badge_tooltip: 'Funcionalidade em beta — pode mudar ou ter limitações temporárias.',
    order: 'Pedido',
    orders: 'Pedidos',
    shipments: 'Envios',
    returns: 'Retornos',
    inventory: 'Inventário',
    claims: 'Disputas',
    maquilas: 'Maquilas',
    operators: 'Operadores',
    warehouse: 'Armazém',
    locations: 'Localizações',
    previous: 'Anterior',
    next: 'Seguinte',
    loading: 'Carregando...',
    error: 'Erro',
    internal_carrier_tooltip: 'Transportadora interna: {{carrier}}',
    client_carrier_tooltip: 'Mostrado aos clientes como: {{carrier}}',
    show_more: 'mais',
    show_less: 'Ver menos',
  },
  configurations: {
    manage_operators: 'Operadores',
    manage_boxes: 'Gerenciar Caixas',
    manage_store_boxes: 'Caixas por marca',
    manage_container_templates: 'Gerenciar Contêineres',
    manage_barcode_pool: 'Gerenciar pool',
    manage_sales_channels: 'Canais de venda',
    campaigns: 'Campanhas',
    manage_receiving_capacity_overrides: 'Capacidade de recebimento',
    receiving: 'Recepção',
    packing: 'Embalagem',
    dispatch_recipients: 'Destinatários do romaneio',
  },
  dispatch_recipients: {
    title: 'Destinatários do romaneio',
    explainer:
      'Ao finalizar uma expedição, o romaneio assinado é enviado por e-mail para quem estiver aqui: os dessa transportadora e os de "Todas as transportadoras". Sem destinatários, o romaneio não é enviado.',
    all_carriers: 'Todas as transportadoras',
    all_carriers_hint: 'Recebem o romaneio de cada expedição do CD.',
    carrier_hint: 'Recebem o romaneio das expedições desta transportadora.',
    empty_group: 'Ninguém recebe estes romaneios ainda.',
    count_one: '{{count}} destinatário',
    count_other: '{{count}} destinatários',
    confirm_remove: '{{name}} ({{email}}) deixará de receber estes romaneios.',
    actions: {
      add: 'Adicionar destinatário',
      edit: 'Editar',
      remove: 'Remover',
      history: 'Histórico',
      retry: 'Tentar novamente',
    },
    form: {
      create_title: 'Adicionar destinatário',
      edit_title: 'Editar destinatário',
      carrier: 'Transportadora',
      name: 'Nome',
      name_placeholder: 'Nome e sobrenome, ou área',
      email: 'E-mail',
      cancel: 'Cancelar',
      create: 'Adicionar',
      save: 'Salvar',
    },
    notifications: {
      created: 'Destinatário adicionado',
      updated: 'Destinatário atualizado',
      removed: 'Destinatário removido',
    },
    history: {
      title: 'Histórico de destinatários',
      empty: 'Ainda não há alterações.',
      action_create: 'Adicionado',
      action_update: 'Editado',
      action_delete: 'Removido',
      load_error: 'Não foi possível carregar o histórico.',
    },
    errors: {
      required: 'Este campo é obrigatório.',
      fields: {
        name: 'Revise o nome.',
        email: 'Revise o e-mail: não é um endereço válido.',
        carrier_name: 'Escolha uma transportadora deste CD.',
      },
      no_access: 'Você não tem acesso a esta seção.',
      load: 'Não foi possível carregar os destinatários.',
      RECIPIENT_DUPLICATED: 'Esse e-mail já recebe os romaneios desta transportadora.',
      RECIPIENT_INVALID: 'Revise o nome, o e-mail e a transportadora.',
      NOT_FOUND: 'Alguém já removeu esse destinatário: a lista foi atualizada.',
      FORBIDDEN: 'Você não tem permissão para alterar os destinatários.',
      generic: 'Não foi possível salvar. Tente novamente.',
    },
  },
  packing_config: {
    title: 'Embalagem',
    load_error: 'Não foi possível carregar a configuração de embalagem',
    retry: 'Tentar novamente',
    not_available: 'A configuração de embalagem ainda não está disponível para este armazém.',
    empty: 'Você não tem configurações de embalagem que possa alterar neste armazém.',
    audit: {
      title: 'Auditoria de embalagem',
      explainer:
        'Porcentagem de pedidos auditados na atribuição de tote neste armazém. Vale para as novas atribuições; as auditorias já pendentes precisam ser respondidas mesmo assim. Pedidos de clientes críticos e entregas ZVPJ da Natura são auditados sempre, exceto em 0%.',
      warehouse_label: 'Porcentagem do armazém',
      save: 'Salvar',
      discard: 'Descartar',
      saving: 'Salvando...',
      stamp: 'Última alteração: {{name}} · {{date}}',
      unset: 'Não configurado: a auditoria está desativada (0%).',
      counters: { following: 'Seguem o armazém', exceptions: 'Com exceção', excluded: 'Excluídas (0%)' },
      exceptions_title: 'Exceções por loja',
      exceptions_hint: 'Estas lojas usam a própria porcentagem em vez da do armazém.',
      add_exception: '+ Adicionar exceção',
      exceptions_empty: 'Nenhuma loja tem exceção: todas usam a porcentagem do armazém.',
      exceptions_load_error: 'Não foi possível carregar as exceções.',
      columns: { store: 'Loja', audit: 'Auditoria', updated: 'Última alteração' },
      excluded_pill: 'Excluída (0%)',
      edit: 'Editar',
      remove: 'Remover',
      saved: 'Porcentagem do armazém atualizada',
      exception_added: 'Exceção adicionada',
      exception_updated: 'Exceção atualizada',
      exception_removed: 'Exceção removida: a loja volta a usar a porcentagem do armazém',
      confirm: {
        title: 'Alterar a auditoria de {{warehouse}} para {{value}}%?',
        description: 'As novas atribuições de tote serão auditadas em {{value}}% (antes {{previous}}%) nas lojas que seguem o armazém ({{following}}).',
        description_off:
          'A auditoria ficará totalmente desativada, inclusive as obrigatórias (clientes críticos, entregas ZVPJ da Natura), nas lojas que seguem o armazém ({{following}}; antes {{previous}}%).',
        own_value: 'Mantêm a própria porcentagem: {{parts}}.',
        own_exceptions: 'com exceção ({{n}})',
        own_excluded: 'excluídas ({{n}})',
        pending_note: 'As auditorias já pendentes precisam ser respondidas mesmo assim.',
        confirm: 'Alterar porcentagem',
        cancel: 'Cancelar',
        loading: 'Salvando',
        this_warehouse: 'este armazém',
      },
      remove_confirm: {
        title: 'Remover a exceção de {{store}}?',
        description: 'A loja passará a usar a porcentagem do armazém ({{value}}%).',
        warehouse_off: 'O armazém está em 0%: a loja não receberá nenhuma auditoria, nem mesmo as obrigatórias (clientes críticos, entregas ZVPJ da Natura).',
        confirm: 'Remover exceção',
        cancel: 'Cancelar',
        loading: 'Removendo',
      },
      modal: {
        add_title: 'Adicionar exceção',
        edit_title: 'Editar exceção',
        subtitle: 'Uma exceção substitui a porcentagem do armazém ({{value}}%) para uma loja.',
        store_label: 'Loja',
        store_placeholder: 'Busque pelo nome (mín. 2 letras)',
        no_results: 'Sem resultados (lojas que já têm exceção não aparecem).',
        search_error: 'Não foi possível buscar lojas. Tente de novo.',
        searching: 'Buscando lojas…',
        change_store: 'Trocar',
        value_label: 'Porcentagem para esta loja',
        preset_exclude: 'Excluir (0%)',
        excluded_hint: 'A loja não receberá nenhuma auditoria, nem mesmo as obrigatórias (clientes críticos, entregas ZVPJ da Natura).',
        cancel: 'Cancelar',
        close: 'Fechar',
        save: 'Salvar',
      },
      errors: {
        required: 'Informe uma porcentagem',
        integer: 'Somente números inteiros de 0 a 100',
        max: 'O máximo é 100%',
        forbidden: 'Você não tem permissão para alterar esta configuração neste armazém.',
        invalid_value: 'A porcentagem deve estar entre 0 e 100.',
        store_not_in_warehouse: 'Esta loja não pertence a este armazém.',
        store_spans_multiple_warehouses:
          'Esta loja opera em mais de um armazém. A porcentagem valeria em todos eles, então só a equipe de tecnologia pode alterá-la.',
        concurrent_update: 'Outra pessoa salvou ao mesmo tempo. Recarregue e tente de novo.',
        not_found: 'A loja ou o armazém não existe mais.',
        generic: 'Não foi possível salvar. Tente de novo.',
        remove_generic: 'Não foi possível remover a exceção. Tente de novo.',
      },
    },
  },
  receiving_config: {
    title: 'Recepção',
    tabs: { settings: 'Configuração', overrides: 'Capacidade de recebimento', history: 'Histórico' },
    load_error: 'Não foi possível carregar a configuração de recepção',
    retry: 'Tentar novamente',
    launch_flags: {
      enabled: 'Agendamentos ativos',
      show_promises: 'Promessas visíveis',
      express_enabled: 'Express ativo',
      off_suffix: '(desligado)',
      managed_by_engineering: 'Gerenciado pela engenharia',
    },
    unprovisioned_banner: 'Este armazém ainda não tem configuração de recepção. Preencha os campos obrigatórios e salve.',
    settings: {
      title: 'Parâmetros',
      fields: {
        dock_count: 'Docas',
        units_per_door_franja: 'Peças por doca e faixa',
        daily_processing_man_hours: 'Horas-homem diárias de processamento',
        express_buffer_door_franjas: 'Docas-faixa reservadas para express',
        no_show_grace_minutes: 'Minutos de tolerância para no-show',
        reschedule_cutoff_hours: 'Horas limite para reagendar',
        checkin_units_per_hour_default: 'Peças por hora no check-in (padrão)',
      },
      required: 'Obrigatório',
      suggestion: 'Sugerido: {{value}}',
      apply_suggestion: 'aplicar',
      no_suggestion: 'sem dados ainda',
      errors: {
        dock_count_range: 'Deve estar entre 1 e 50',
        non_negative: 'Deve ser 0 ou maior',
        positive: 'Deve ser maior que 0',
        man_hours_max: 'Máximo 9999.99',
        buffer_exceeds_docks: 'Não pode superar o número de docas',
      },
    },
    franjas: {
      title: 'Faixas',
      add: 'Adicionar faixa',
      headers: { label: 'Nome', weekdays: 'Dias', window: 'Horário', status: 'Status' },
      active: 'Ativa',
      retired: 'Retirada',
      edit: 'Editar',
      retire: 'Retirar',
      reactivate: 'Reativar',
      empty: 'Não há faixas configuradas',
      weekdays_short: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      weekdays_full: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
      modal: {
        title_new: 'Nova faixa',
        title_edit: 'Editar faixa',
        label: 'Nome',
        weekdays: 'Dias da semana',
        starts_at: 'Início',
        ends_at: 'Fim',
        cancel: 'Cancelar',
        save: 'Aceitar',
        errors: {
          label_required: 'O nome é obrigatório',
          label_too_long: 'Máximo 100 caracteres',
          weekdays_required: 'Selecione ao menos um dia',
          end_after_start: 'O fim deve ser posterior ao início',
          overlap_warning: 'Sobrepõe a faixa "{{label}}" em um dia compartilhado; a API rejeitará o salvamento.',
        },
      },
    },
    save: {
      button: 'Salvar',
      discard: 'Descartar alterações',
      unsaved_prompt: 'Você tem alterações não salvas. Sair mesmo assim?',
      modal: {
        title: 'Confirmar alterações',
        reason: 'Motivo da alteração',
        reason_help: 'Fica registrado no histórico. Não inclua dados de clientes.',
        reason_required: 'O motivo é obrigatório (mínimo 3 caracteres)',
        cancel: 'Cancelar',
        confirm: 'Salvar alterações',
      },
      saved: 'Configuração salva',
      reverted: 'Alteração revertida',
    },
    warnings: {
      title: 'Salvo com avisos',
      overbooked_intro: 'Estas datas já têm mais peças reservadas do que a nova capacidade:',
      overbooked_headers: { date: 'Data', franja: 'Faixa', reserved: 'Reservadas', capacity: 'Capacidade' },
      affected_count: '{{count}} agendamentos já reservados tiveram suas condições alteradas (tolerância, limite de reagendamento ou início de faixa).',
      view_board: 'Ver agendamentos',
      revert: 'Reverter',
      revert_confirm_title: 'Reverter a última alteração',
      revert_confirm_description: 'A configuração anterior à alteração #{{id}} será restaurada.',
      dismiss: 'Fechar',
    },
    errors: {
      generic: 'Não foi possível salvar a configuração',
      invalid_param: 'Solicitação inválida: {{message}}',
      invalid_config: 'Configuração inválida: {{message}}',
      settings_required_for_first_save: 'Para o primeiro salvamento são obrigatórios: {{fields}}',
      concurrent_update_title: 'Outra pessoa salvou alterações',
      concurrent_update_description: 'A configuração mudou enquanto você editava. Recarregue para continuar.',
      reload: 'Recarregar',
      conflicts_title: 'A faixa tem agendamentos reservados',
      conflicts_intro: 'Reagende ou cancele estes agendamentos antes de modificar a faixa:',
      conflicts_headers: { appointment: 'Agendamento', date: 'Data', franja: 'Faixa' },
      conflicts_close: 'Entendi',
    },
    history: {
      empty: 'Ainda não há alterações registradas',
      load_more: 'Carregar mais',
      system: 'Sistema (rake)',
      forced: 'Forçado',
      no_changes: 'Sem alterações efetivas',
      settings: 'Parâmetros',
      franjas_changed: 'Faixas modificadas',
      franjas_added: 'Faixas adicionadas',
      franjas_retired: 'Faixas retiradas',
      franjas_reactivated: 'Faixas reativadas',
      load_error: 'Não foi possível carregar o histórico',
    },
  },
  campaigns: {
    title: 'Campanhas',
    subtitle: 'Campanhas gerais por país. Todas as marcas do país as veem em Métricas.',
    country_label: 'País',
    countries: { MX: 'México', BR: 'Brasil', CL: 'Chile' },
    yearly_group: 'Todo ano',
    headers: { name: 'Nome', starts_on: 'Início', ends_on: 'Fim', recurrence: 'Repete', updated_at: 'Atualizada', actions: 'Ações' },
    recurrence: { none: 'Não se repete', monthly: 'Todo mês', yearly: 'Todo ano' },
    actions: { create: 'Nova campanha', edit: 'Editar', duplicate: 'Duplicar para o ano seguinte', delete: 'Excluir' },
    empty: 'A Cubbo não tem campanhas para {{country}}',
    errors: {
      no_access: 'Você não tem acesso a esta seção',
      load: 'Não foi possível carregar as campanhas',
      retry: 'Tentar de novo',
      end_before_start: 'O fim deve ser igual ou posterior ao início',
      generic: 'Não foi possível salvar a campanha',
      delete_generic: 'Não foi possível excluir a campanha',
      forbidden: 'Você não tem permissão para alterar as campanhas da Cubbo',
      gone: 'Esta campanha não existe mais; atualizamos a lista',
    },
    form: {
      create_title: 'Nova campanha',
      edit_title: 'Editar campanha',
      duplicate_title: 'Duplicar para o ano seguinte',
      duplicate_hint: 'Datas deslocadas um ano a partir de "{{name}}". Ajuste os dias exatos.',
      country: 'País',
      name: 'Nome',
      name_placeholder: 'Ex. Black Friday',
      starts_on: 'Início',
      ends_on: 'Fim',
      recurrence: 'Repete',
      save: 'Salvar',
      saving: 'Salvando...',
      cancel: 'Cancelar',
    },
    confirm_delete: {
      title: 'Excluir campanha',
      description: '"{{name}}" ({{starts_on}} – {{ends_on}}) será excluída para {{country}}. As marcas deixarão de ver esta faixa em Métricas.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    notifications: { created: 'Campanha criada', updated: 'Campanha atualizada', deleted: 'Campanha excluída' },
  },
  sales_channels: {
    title: 'Canais de venda destino',
    no_channels: 'Não há canais de venda configurados',
    status_active: 'Ativo',
    status_inactive: 'Desabilitado',
    scope_types: {
      stores: 'Lojas',
      warehouses: 'Armazéns',
    },
    filters: {
      search: 'Buscar por nome',
      status_label: 'Status',
      status_active: 'Ativos',
      status_disabled: 'Desabilitados',
      status_all: 'Todos',
    },
    headers: {
      name: 'Nome',
      scope: 'Alcance',
      links: 'Vínculos',
      status: 'Estado',
      actions: 'Ações',
    },
    actions: {
      create: 'Criar canal',
      edit: 'Editar',
      history: 'Histórico',
      disable: 'Desabilitar',
      restore: 'Reabilitar',
      confirm_disable: 'Desabilitar este canal de venda? Deixará de ser oferecido em novos pedidos; os pedidos que já o possuem não são afetados.',
      confirm_restore: 'Reabilitar este canal de venda?',
    },
    form: {
      create_title: 'Criar canal de venda',
      edit_title: 'Editar canal de venda',
      name: 'Nome',
      scope_type: 'Alcance',
      stores: 'Lojas',
      warehouses: 'Armazéns',
      links_placeholder: 'Buscar e adicionar',
      cancel: 'Cancelar',
      create: 'Criar',
      save: 'Salvar',
    },
    history: {
      title: 'Histórico',
      refresh: 'Atualizar',
      no_history: 'Sem histórico',
      action: 'Ação',
      changes: 'Alterações',
      user: 'Usuário',
      date: 'Data',
      added: 'Adicionados',
      removed: 'Removidos',
      action_create: 'Criação',
      action_name_update: 'Alteração de nome',
      action_links_update: 'Alteração de vínculos',
      action_discard: 'Desabilitado',
      action_undiscard: 'Reabilitado',
    },
    notifications: {
      created: 'Canal criado',
      updated: 'Canal atualizado',
      disabled: 'Canal desabilitado',
      restored: 'Canal reabilitado',
      error: 'Ocorreu um erro',
    },
    errors: {
      no_access: 'Você não tem acesso a esta seção',
      name_taken: 'Já existe um canal ativo com esse nome',
    },
  },
  container_templates: {
    title: 'Contêineres',
    select_store: 'Selecione uma loja',
    no_templates: 'Não há templates configurados para esta loja',
    create_template: 'Criar Template',
    edit_template: 'Editar Contêiner',
    save_template: 'Salvar',
    cancel: 'Cancelar',
    print_label: 'Imprimir Etiqueta',
    delete_template: 'Excluir Template',
    confirm_delete: 'Tem certeza de que deseja excluir este template?',
    headers: {
      grouping_code: 'Código',
      name: 'Nome',
      container_type: 'Tipo',
      items_count: 'Items',
      active: 'Ativo',
      actions: 'Ações',
    },
    container_types: {
      GROUP_CONTAINER: 'Palete',
      PRODUCT_CONTAINER: 'Caixa',
    },
    editor: {
      grouping_code: 'Código de agrupação',
      grouping_code_placeholder: 'Ex: PALETE-MIX-001',
      name: 'Nome',
      name_placeholder: 'Nome descritivo do template',
      container_type: 'Tipo de contêiner',
      active: 'Ativo',
      add_item: 'Adicionar',
      add_product: 'Produto',
      add_sub_container: 'Sub-contêiner',
      product: 'Produto',
      product_search_placeholder: 'Buscar por nome, SKU ou código de barras',
      no_products_found: 'Nenhum produto encontrado',
      quantity: 'Quantidade',
      units_per_container: 'Peças por contêiner',
      lot: 'Lote',
      no_lot: 'Sem lote',
      template: 'Template',
      select_template: 'Selecionar template',
      done: 'Pronto',
      remove: 'Excluir',
      total_pieces: 'Total: {{count}} peças',
      total_bar: 'Total de peças no contêiner: {{count}} peças',
      pieces_each: '{{count}} pçs cada',
      pieces_short: 'pçs',
      boxes_count_one: '× {{count}} caixa',
      boxes_count_other: '× {{count}} caixas',
      validation: {
        grouping_code_required: 'O código de agrupação é obrigatório',
        container_type_required: 'O tipo de contêiner é obrigatório',
        at_least_one_item: 'Deve ter pelo menos um item',
        incomplete_item: 'O elemento #{{position}} está incompleto',
      },
    },
    notifications: {
      created: 'Template criado com sucesso',
      updated: 'Template atualizado com sucesso',
      deleted: 'Template excluído com sucesso',
      error_create: 'Erro ao criar o template',
      error_update: 'Erro ao atualizar o template',
      error_delete: 'Erro ao excluir o template',
      missing_store: 'Selecione uma loja primeiro',
    },
  },
  barcode_pool: {
    title: 'Pool de etiquetas',
    subtitle: 'Etiquetas pré-impressas reutilizáveis (Cubbo) para pallets e caixas. Geram-se vazias e se reclamam ao escaneá-las em uma recepção.',
    empty: 'Não há etiquetas com estes filtros.',
    total: '{{count}} etiquetas',
    selected: '{{count}} selecionadas',
    container_types: {
      GROUP_CONTAINER: 'Pallet',
      PRODUCT_CONTAINER: 'Caixa',
    },
    statuses: {
      available: 'Disponível',
      in_use: 'Em uso',
    },
    filters: {
      container_type: 'Tipo',
      status: 'Status',
      all: 'Todas',
      show_store_scoped: 'Ver de um cliente específico',
      select_store: 'Selecione cliente',
      select_store_hint: 'Selecione um cliente para ver suas etiquetas pré-impressas.',
    },
    columns: {
      barcode: 'Barcode',
      type: 'Tipo',
      status: 'Status',
      created_at: 'Criada',
      container: 'Contêiner',
    },
    actions: {
      generate_batch: 'Gerar lote',
      print_selection: 'Imprimir seleção ({{count}})',
      print_one: 'Imprimir',
    },
    generate_dialog: {
      title: 'Gerar lote de etiquetas',
      subtitle: 'Selecione o tipo e a quantidade. As etiquetas geram-se vazias e ficam disponíveis no pool.',
      quantity: 'Quantidade',
      cancel: 'Cancelar',
      confirm: 'Gerar',
      generating: 'Gerando…',
      store_scoped_warning: 'Estas etiquetas ficarão atribuídas ao cliente {{store}} (não reutilizáveis por outros).',
    },
    notifications: {
      generated: '{{count}} etiquetas geradas',
      generate_error: 'Não foi possível gerar o lote',
      print_error: 'Não foi possível baixar o PDF',
      too_many: 'Não é possível imprimir mais de {{max}} etiquetas de uma vez',
    },
  },
  missing_stock: {
    section_title: 'Por que este pedido não tem estoque?',
    missing_one: 'Falta {{count}} peça',
    missing_other: 'Faltam {{count}} peças',
    blocked_one: '{{count}} peça reservada não pode ser enviada',
    blocked_other: '{{count}} peças reservadas não podem ser enviadas',
    in_transit_one: '{{count}} peça a caminho',
    in_transit_other: '{{count}} peças a caminho',
    assignable_hint: 'O motor já tem estoque atribuível para este pedido: reprocesse-o pelo OMS.',
    lot: 'Lote',
    rule: 'Regra',
    expiration_date: 'Vencimento',
    sellable_until: 'Vendável até',
    units: 'Peças',
    locations: 'Endereços',
    no_lot: 'Sem lote',
    no_location: 'Sem endereço',
    other_warehouse_locations: 'Outro armazém',
    unknown_reason: 'Motivo não reconhecido por esta versão do WMS.',
    load_error: 'Não foi possível carregar o diagnóstico. Recarregue a página para tentar novamente.',
    reasons: {
      freshness: 'Há estoque, mas dentro da janela de validade mínima do produto ou em lotes vencidos.',
      held_lot: 'Há estoque, mas em um lote retido.',
      damaged: 'Há estoque, mas avariado.',
      incoming: 'Há estoque em pré-venda a caminho.',
      in_transit: 'O estoque reservado ainda não foi recebido.',
      no_stock: 'Não há estoque disponível neste armazém.',
      assignable: 'Há estoque atribuível.',
      requested_unit: 'O pedido aguarda uma unidade específica que ainda não está disponível.',
      needs_unit_code: 'Produto personalizado sem unidade indicada no pedido.',
      unknown_product: 'O SKU não existe no catálogo da loja.',
    },
    buckets: {
      reserved_by_other_orders: 'Reservado por outros pedidos',
      other_warehouse: 'Em outro armazém',
      incoming: 'Pré-venda a caminho',
      in_reception: 'Em recebimento',
      damaged: 'Avariado',
      unsellable_location: 'Em endereço não vendável',
      held_lot: 'Lote retido',
      expired_lot: 'Lote vencido',
      freshness_window: 'Dentro da janela de validade mínima',
      not_for_channel: 'Não habilitado para o canal',
      unconfirmed_replenishment: 'Recebimento não confirmado',
      containers_not_allowed: 'Em caixa/palete (o pedido não pode usar)',
      assignable: 'Atribuível agora',
      other_engine_rule: 'Outra regra do motor',
    },
  },
  stock_allocation: {
    section_title: 'Alocação de estoque',
    pallets: 'pallets',
    boxes: 'caixas',
    loose_pieces: 'peças avulsas',
    totes: 'totes',
    standalone_boxes: 'Caixas avulsas',
    pieces: 'peças',
    box: 'Caixa',
    piece: 'Peça',
    lot: 'Lote',
    picking_progress: 'Progresso de picking',
    empty: 'Sem alocação de estoque',
    error: 'Não foi possível carregar a alocação de estoque',
    statuses: {
      SEALED: 'Selado',
      ACTIVE: 'Ativo',
      RESERVED: 'Reservado',
      PICKED: 'Pickeado',
      in_use: 'Em uso',
    },
  },
  picking_tasks: {
    badge_b2b: 'B2B',
    summary_title: 'Tarefas de Picking',
    columns: {
      store: 'Loja',
      order_number: 'Núm. Pedido',
      location: 'Localização',
      pick_type: 'Tipo',
      progress: 'Progresso',
      quantity: 'Quantidade',
      sku: 'SKU',
      status: 'Status',
      picker: 'Picker',
    },
    pick_types: {
      PALLET: 'Palete',
      BOX: 'Caixa',
      PIECE: 'Peça',
    },
    statuses: {
      PENDING: 'Pendente',
      ASSIGNED: 'Atribuído',
      IN_PROGRESS: 'Em progresso',
      COMPLETED: 'Concluído',
      SKIPPED: 'Omitido',
      CANCELED: 'Cancelado',
    },
    actions: {
      view_tasks: 'Ver progresso',
      reassign_picker: 'Reatribuir',
      reassign_picker_title: 'Reatribuir Picker',
      reassign_confirm: 'Reatribuir',
      reassign_success: 'Picker reatribuído com sucesso',
      reassign_error: 'Erro ao reatribuir picker',
      search_operator_placeholder: 'Buscar Operador',
      current: 'atual',
    },
    assign_pickers_error: 'Erro ao criar tarefas de picking. A ordem foi atribuída mas as tarefas não puderam ser divididas.',
    empty: 'Não há tarefas de picking para esta ordem',
    sku_summary: {
      location_one: 'localização',
      location_other: 'localizações',
    },
    assign_summary: {
      orders: 'pedidos selecionados',
      pieces: 'peças',
      picker_short: 'operador',
      pickers_short: 'pickers',
      too_many_pickers_warning:
        'Vai dividir {{pieces}} peças entre {{selected}} pickers. Recomendamos no máximo {{recommended}} para este volume — confirme que deseja atribuir tantos pickers a este picking.',
      all_blocked_from_picking:
        'Todos os pedidos selecionados têm peças dentro de caixas ou paletes para abrir. O time de inventário precisa abri-las antes de atribuí-los ao picking.',
      blocked_title: 'Não há nada para atribuir',
      go_to_break: 'Ir para Caixas para abrir',
      excluded_title: 'Pedidos excluídos',
      excluded_blocked_from_picking: 'São excluídos da atribuição porque têm peças dentro de caixas ou paletes para abrir:',
    },
    multi_picker: {
      title: 'Atribuir Tasks a Pickers',
      suggested_distribution: 'Distribuição sugerida (balanceada por carga)',
      restore_distribution: 'Restaurar distribuição',
      confirm: 'Confirmar Atribuição',
      unassigned: 'Pendente de atribuição',
      load_summary: 'Carga',
      unassign: 'Devolver ao pool',
      unassign_success: 'Task devolvida ao pool com sucesso',
      unassign_error: 'Erro ao devolver task ao pool',
      confirm_success: 'Tasks atribuídas com sucesso',
      confirm_error: 'Erro ao atribuir tasks',
      picker_queue: 'Fila do picker',
      queue_reorder: 'Reordenar fila',
      queue_save: 'Salvar ordem',
      queue_save_success: 'Fila atualizada',
      queue_save_error: 'Erro ao atualizar a fila',
      queue_empty: 'Este picker não tem tarefas na fila.',
      queue_unauthorized: 'Você não tem permissão para ver a fila deste picker.',
      queue_error: 'Não foi possível carregar a fila do picker.',
      select_pickers: 'Selecionar pickers',
      multi_picker_help: 'Selecione 2 ou mais pickers para distribuir as tarefas entre eles',
      picking_status_title: 'Progresso por picker',
      completed_short: 'Concluída com falta',
      no_pickers_selected: 'Selecione pelo menos um picker',
      cancel: 'Cancelar',
      close: 'Fechar',
      pieces_short: 'pçs',
      tasks_short: 'tarefas',
      total: 'Total',
      retry: 'Tentar novamente',
      upc: 'UPC',
      product_name: 'Produto',
      toggle_sku_detail: 'Ver detalhe de SKU e UPC',
      no_product_detail: 'Sem detalhe de produtos para esta localização',
      preview_error: 'Não foi possível calcular a distribuição',
      stale_distribution: 'A distribuição mudou porque o estoque se moveu. Revise a nova sugestão.',
      already_exists: 'Este pedido já tem uma atribuição. Atualizando…',
      split_across_pickers:
        'A distribuição dividia uma mesma localização, ou um mesmo SKU do mesmo tipo de picking, entre vários pickers. Recalculamos uma atribuição válida — revise a nova sugestão.',
      copy_hint: 'Clique para copiar',
      copied: 'copiado',
      distribution_title: 'Distribuição de tarefas',
      distribution_summary:
        'Revise a distribuição sugerida de tarefas de picking entre os <b>{{users}}</b> selecionados para processar as <b>{{pieces}}</b> {{ordersArticle}} <b>{{orders}}</b>. A carga foi distribuída equilibrando as peças entre os pickers; cada localização fica com um só picker.',
      summary_users_one: '{{count}} usuário',
      summary_users_other: '{{count}} usuários',
      summary_users_many: '{{count}} usuários',
      summary_pieces_one: '{{formatted}} peça',
      summary_pieces_other: '{{formatted}} peças',
      summary_pieces_many: '{{formatted}} peças',
      summary_orders_article_one: 'do',
      summary_orders_article_other: 'dos',
      summary_orders_article_many: 'dos',
      summary_orders_one: '{{count}} pedido',
      summary_orders_other: '{{count}} pedidos',
      summary_orders_many: '{{count}} pedidos',
      excluded_title_one: '{{count}} pedido excluído da distribuição. O restante será distribuído:',
      excluded_title_other: '{{count}} pedidos excluídos da distribuição. O restante será distribuído:',
      excluded_title_many: '{{count}} pedidos excluídos da distribuição. O restante será distribuído:',
      search_placeholder: 'Buscar por SKU, pedido ou localização',
      all_pick_types: 'Todos os tipos de picking',
      view_by_picker: 'Por picker',
      view_by_location: 'Por localizações',
      view_by_order: 'Por pedido',
      collapse_all: 'Recolher todos',
      expand_all: 'Expandir todos',
      distribution_error_title: 'Não conseguimos calcular a distribuição',
      distribution_error_see_details: 'Revise o detalhe de cada pedido a seguir.',
      distribution_error_mixed_types:
        'Costuma acontecer quando a seleção mistura tipos de pedido que não podem ser distribuídos juntos entre vários pickers. Volte e deixe um só tipo de pedido, ou atribua-os a um só picker.',
      distribution_error_not_pending:
        "Um ou mais pedidos já não estão no status 'Pendente' (é possível que já tenham sido atribuídos). Volte, atualize a lista de pedidos e tente novamente.",
      picker_summary: '{{locations}} localizações · {{pieces}} peças · {{skus}} SKUs · {{orders}} pedidos',
      remove_picker: 'Remover picker (suas localizações passam para pendente de atribuição)',
      no_locations: 'Sem localizações atribuídas',
      pick_type_header: 'Tipo de picking',
      drag_to_reassign: 'Arraste para reatribuir a outro picker',
      unassign_location: 'Desatribuir (mover para pendente de atribuição)',
      locations_pieces: '{{locations}} localizações · {{pieces}} peças',
      auto_assign: 'Atribuir automaticamente',
      drag_to_assign: 'Arraste para um picker para atribuir',
      locations_pieces_short: '{{locations}} localizações · {{pieces}} pçs',
      order_split_notice: 'Este pedido foi dividido entre {{n}} pickers.',
    },
    order_errors: {
      missing_stock: 'Há produtos deste pedido que não foram atribuídos. Contate o suporte técnico. ',
      excessive_stock: 'Há um excesso de produtos atribuídos ao pedido. Contate o suporte técnico. ',
      expired_stock: 'Há produtos vencidos atribuídos ao pedido. Contate o suporte técnico. ',
      holded_stock: 'Há produtos em hold atribuídos ao pedido. Contate o suporte técnico. ',
      invalid_order_status: "Este pedido não está no status 'Pendente'. É possível que já tenha sido atribuído. ",
      sxkm_order: 'Este pedido é do cliente SXKM. Não deve passar por picking. ',
      not_apt_for_single_item_picking: 'Este pedido não cumpre os requisitos para ser agrupado. ',
      single_item_picking_conflict:
        'Este pedido tem conflitos de SKU ou UPC com o pedido #{{orders}}. Não é possível agrupar o pedido nesta sessão de picking. ',
      single_item_picking_conflict_no_order:
        'Este pedido tem conflitos de SKU ou UPC com outro pedido. Não é possível agrupar o pedido nesta sessão de picking. ',
      single_item_picking_store_conflict:
        'Este pedido não pode ir no mesmo tote que o pedido #{{orders}}: um deles leva enxerto e são de lojas diferentes, ou são da mesma loja com enxertos diferentes. Pedidos com enxerto só são agrupados com pedidos da mesma loja e com os mesmos enxertos. Se esse pedido não aparece nesta lista, ele pode já estar atribuído ao picker. ',
      single_item_picking_store_conflict_no_order:
        'Este pedido não pode ir no mesmo tote que outro pedido: um deles leva enxerto e são de lojas diferentes, ou são da mesma loja com enxertos diferentes. Pedidos com enxerto só são agrupados com pedidos da mesma loja e com os mesmos enxertos. Se esse pedido não aparece nesta lista, ele pode já estar atribuído ao picker. ',
      already_has_picking_order: 'Este pedido já foi atribuído a um picker. ',
      pending_container_break: 'Este pedido tem peças dentro de uma caixa ou palete que o time de inventário precisa abrir antes do picking. ',
      panel_title_one: 'Não foi possível processar {{count}} pedido:',
      panel_title_other: 'Não foi possível processar {{count}} pedidos:',
      panel_title_many: 'Não foi possível processar {{count}} pedidos:',
      invalid_order_status_with_status:
        "Este pedido não está no status 'Pendente'; está em '{{status}}' e não pode ser atribuído.",
      order_status_label: 'Status do pedido:',
      code_label: 'Código:',
      code_title: 'Código de erro para reportar ao suporte',
    },
    assign_columns: {
      store: 'Loja',
      order_number: 'Número do pedido',
      channel_name: 'Canal de venda',
      pieces: 'Peças',
      groupable: 'Agrupável',
      groupable_help:
        'Um pedido pode ser agrupado quando é possível fazer o picking dele junto com outros no mesmo tote. Os pedidos não agrupáveis vão para um tote individual.',
      groupable_count: '{{n}} pedidos',
      yes: 'Sim',
      no: 'Não',
      insert_tooltip: 'Leva enxerto: {{names}}. Só é agrupado com pedidos da mesma loja e com os mesmos enxertos.',
      insert_fallback: 'material da loja',
      insert_badge: 'Enxerto',
      picker_name: 'Nome do picker',
      email: 'E-mail',
      queued_orders: 'Pedidos atribuídos na fila',
      in_progress_orders: 'Pedidos em andamento',
      grouping_split: 'Não agrupado | Agrupados',
      picking_orders_split: '{{nonGrouped}} Não agrupado | {{grouped}} Agrupado',
    },
    assign_dialog: {
      title: 'Atribuição de pickers',
      intro_one: 'Selecione o(s) picker(s) que vão trabalhar no <bold>{{count}} pedido</bold> a ser atribuído.',
      intro_other: 'Selecione o(s) picker(s) que vão trabalhar nos <bold>{{count}} pedidos</bold> a serem atribuídos.',
      intro_many: 'Selecione o(s) picker(s) que vão trabalhar nos <bold>{{count}} pedidos</bold> a serem atribuídos.',
      search_placeholder: 'Buscar operador (nome ou e-mail)',
      selected_pickers_one: '{{count}} picker selecionado',
      selected_pickers_other: '{{count}} pickers selecionados',
      selected_pickers_many: '{{count}} pickers selecionados',
      deselect_all: 'Desmarcar todos',
      operators_count: '{{n}} Operadores',
      summary_title: 'Resumo da atribuição',
      orders_to_assign: 'Pedidos a atribuir',
      individual: 'Individuais',
      groupable: 'Agrupáveis',
      total_pieces: 'Total de peças',
      route_areas: 'Áreas do percurso',
      order_type: 'Tipo de pedido',
      pickers_detail: 'Detalhe dos pickers',
      queued_orders_one: 'com {{count}} pedido na fila',
      queued_orders_other: 'com {{count}} pedidos na fila',
      queued_orders_many: 'com {{count}} pedidos na fila',
      choose_operator: 'Escolha um operador',
      continue: 'Continuar',
      back: 'Voltar',
      group_title: 'Agrupar pedidos',
      group_help: 'Edite a seleção de pedidos que serão agrupados, se necessário.',
      group_orders_heading: 'Pedidos que serão atribuídos',
      group_eligible:
        'Dos <bold>{{total}} pedidos</bold> selecionados, <bold>{{eligible}}</bold> podem ser agrupados. Selecione quais deles devem ir para o mesmo tote.',
      shared_tote: '<bold>{{n}} pedidos</bold> agrupáveis, serão atribuídos ao mesmo tote compartilhado.',
      show_all: 'Ver todos os pedidos',
      show_only_groupable: 'Ver só pedidos agrupáveis',
      not_groupable_tooltip: 'Este pedido não é agrupável, por isso não pode ser selecionado. O picking dele será feito em um tote individual.',
      insert_blocker_tooltip:
        'Um pedido com enxerto só é agrupado com pedidos da mesma loja e com os mesmos enxertos, e este não pode ir no mesmo tote que #{{orderNumber}} ({{store}}). Remova esse pedido do grupo ou o picking dele será feito em um tote individual.',
      other_store: 'outra loja',
      resolve_conflicts_one: 'Resolva {{count}} conflito',
      resolve_conflicts_other: 'Resolva {{count}} conflitos',
      resolve_conflicts_many: 'Resolva {{count}} conflitos',
      confirm_orders_one: 'Confirmar {{count}} pedido',
      confirm_orders: 'Confirmar {{count}} pedidos',
      loading: 'Carregando...',
    },
  },
  picking_tasks_to_break: {
    title: 'Caixas para abrir',
    refresh: 'Atualizar',
    forbidden: 'Você não tem permissão para ver esta tela.',
    empty_table_text: 'Não há nada para abrir neste armazém.',
    footer_products: 'produtos',
    footer_orders: 'pedidos',
    summary: '{{products}} produtos, {{orders}} pedidos bloqueados',
    pivot: {
      by_product: 'Por produto',
      by_order: 'Por pedido',
    },
    status: {
      breakable: 'Pode abrir',
      not_breakable: 'Sem estoque para abrir — requer reabastecimento',
    },
    filters: {
      sku_upc: 'SKU / UPC',
    },
    headers: {
      product: 'Produto',
      pieces_to_release: 'Peças a liberar',
      affected_orders: 'Pedidos afetados',
      oldest_order: 'Aguardando desde',
      locations: 'Localizações',
      locations_reserved: 'Localizações com estoque reservado não separável',
      status: 'Estado',
      order_number: 'Número do Pedido',
      store: 'Loja',
      total_pieces: 'Peças',
      products_count: 'Produtos',
    },
    detail: {
      orders_title: 'Pedidos afetados',
      products_title: 'Produtos necessários',
      pieces: 'Peças',
      pieces_short: '{{count}} pç',
      pieces_short_plural: '{{count}} pçs',
      boxes_title: 'Ver caixas',
      no_barcode: 'Sem código',
      product_summary: '{{pieces}} peças a liberar · {{orders}} pedidos afetados',
      order_summary: '{{pieces}} peças · {{products}} produtos',
    },
  },
  delete_lost_stock: {
    title: 'Eliminar Estoque Perdido',
    warning_message:
      'Esta ação é irreversível. Uma vez eliminados os stock units, não podem ser recuperados. Certifique-se de verificar os dados antes de continuar.',

    // Steps
    step1_title: 'Selecionar Localização LOST',
    step2_title: 'Selecionar Produtos e Quantidades',
    step2_description: 'Produtos disponíveis na localização {{location}}:',
    step2_placeholder: 'Selecione uma localização na etapa 1 para ver os produtos disponíveis.',
    refetch: 'Atualizar',

    // Labels
    labels: {
      select_location: 'Localização LOST',
      product: 'Produto',
      lot: 'Lote',
      location: 'Localização',
      store: 'Loja',
      quantity_to_delete: 'Quantidade a eliminar',
      available: 'Disponível',
      to_delete: 'A eliminar',
      expires: 'Expira',
    },

    // Units
    units: 'unidades',
    no_lot: 'Sem lote',
    no_image: 'Sem imagem',
    unknown_store: 'Loja desconhecida',
    total_in_location: 'Total na localização',
    total_stores: 'Total de lojas',
    filtered_total: 'Total filtrado',

    // Search
    search_by_sku: 'Buscar por SKU ou UPC',
    search_placeholder: 'Escanear ou inserir SKU/UPC...',
    search_button: 'Buscar',
    search_results: "{{count}} resultado(s) para '{{term}}'",
    no_search_results: 'Não foram encontrados produtos com o SKU/UPC buscado.',
    clear_search: 'Limpar busca',

    // Empty states
    no_lost_locations: 'Não há localizações LOST com estoque disponível.',
    no_stock_items: 'Não há produtos nesta localização.',

    // Confirmation
    confirm_title: 'Confirmar Eliminação',
    confirm_description: 'Você está prestes a eliminar estoque com os seguintes dados:',
    confirm_warning: 'Esta ação é irreversível. Deseja continuar?',
    confirm_button: 'Sim, Eliminar',
    cancel_button: 'Cancelar',
    loading: 'Eliminando...',

    // Success/Error
    success_title: 'Estoque Eliminado',
    success_message: "Foram eliminados {{count}} stock unit(s) da localização '{{location}}'",
    success_message_store: "Foram eliminados {{count}} stock unit(s) da loja '{{store}}' na localização '{{location}}'",
    error_title: 'Erro',

    // Store delete
    delete_all_store: 'Eliminar tudo',
    confirm_store_title: 'Eliminar Todo o Estoque da Loja',
    confirm_store_description:
      "Está prestes a eliminar todo o estoque da loja '{{store}}' na localização '{{location}}'. Serão eliminadas {{count}} unidade(s).",

    // Permissions
    no_permission_title: 'Acesso Negado',
    no_permission_message: 'Você não tem permissões para eliminar estoque perdido. Contacte o administrador se precisar de acesso.',
    go_back: 'Voltar ao Inventário',
    view_history: 'Ver Histórico',

    // Errors
    errors: {
      product_not_found: 'O produto não foi encontrado.',
      warehouse_not_found: 'O armazém não foi encontrado.',
      lot_not_found: 'O lote não foi encontrado.',
      lot_does_not_belong_to_product: 'O lote não pertence ao produto selecionado.',
      location_not_found: 'A localização especificada não existe ou não é do tipo LOST na área LF.',
      no_stock_units_found: 'Não há estoque para eliminar com os critérios especificados.',
      quantity_exceeds_available: 'A quantidade solicitada excede o estoque disponível.',
      store_not_found: 'A loja não foi encontrada.',
      invalid_parameter: 'Parâmetros inválidos. Verifique os dados inseridos.',
      internal_error: 'Erro interno. Por favor tente novamente mais tarde.',
      loading_locations: 'Erro ao carregar as localizações.',
      loading_stock: 'Erro ao carregar o estoque da localização.',
      no_quantity_selected: 'Deve inserir uma quantidade a eliminar.',
    },
  },

  lastmile_management: {
    days: {
      0: 'Domingo',
      1: 'Segunda',
      2: 'Terca',
      3: 'Quarta',
      4: 'Quinta',
      5: 'Sexta',
      6: 'Sabado',
    },
    days_short: {
      0: 'Dom',
      1: 'Seg',
      2: 'Ter',
      3: 'Qua',
      4: 'Qui',
      5: 'Sex',
      6: 'Sab',
    },
    boolean_yes: 'Sim',
    boolean_no: 'Nao',
    shipping_methods: {
      title: 'Metodos de envio',
      subtitle: 'Gerencie coberturas, custos e dias nao uteis por transportadora.',
      empty_table: 'Nao ha metodos de envio para mostrar.',
      footer_text: 'metodos de envio',
      edit_method: 'Editar metodo de envio',
      search_placeholder: 'Buscar por metodo ou transportadora',
      all_carriers: 'Todas as transportadoras',
      non_working_days_empty: 'Nenhum',
      methods_active: 'Metodos ativos',
      column_title: 'Titulo',
      column_type: 'Tipo',
      no_results: 'Nenhum metodo corresponde a sua busca.',
      count_method: 'metodo',
      count_methods: 'metodos',
      status_active: 'Ativo',
      status_inactive: 'Inativo',
      non_working_pill_prefix: 'Nao opera',
      non_working_pill_none: 'Opera todos os dias',
      status_filter: {
        all: 'Todos',
        active: 'Ativos',
        inactive: 'Inativos',
      },
      headers: {
        shipping_name: 'Nome',
        carrier_name: 'Transportadora',
        shipping_type: 'Tipo de envio',
        delivery_type: 'Tipo de entrega',
        country: 'Pais',
        is_active: 'Ativo',
        is_cod: 'Contra entrega',
        extended_zone: 'Zona estendida',
        po_box_dropoff: 'PO Box',
        provides_pod: 'POD',
        enable_multipackage: 'Multipacote',
        contract_provider: 'Provedor',
        non_working_days: 'Dias nao uteis',
        actions: 'Acoes',
      },
      filters: {
        shipping_name: 'Nome de envio',
        carrier_name: 'Transportadora',
        shipping_type: 'Tipo de envio',
        delivery_type: 'Tipo de entrega',
        is_active: 'Somente ativos',
        inactive_only: 'Somente inativos',
      },
      form: {
        is_active: 'Ativo',
        non_working_days: 'Dias nao uteis',
        non_working_days_help: 'Selecione os dias em que este metodo nao opera',
        cancel: 'Cancelar',
        save: 'Salvar',
      },
      notifications: {
        update_success: 'Metodo de envio atualizado com sucesso',
        update_error: 'Erro ao atualizar o metodo de envio',
      },
      errors: {
        fetch_error: 'Erro ao carregar os metodos de envio',
        no_access: 'Voce nao tem acesso a esta secao',
      },
      actions: {
        activate: 'Ativar',
        deactivate: 'Desativar',
        confirm_activate: 'Tem certeza de que deseja ativar este metodo de envio?',
        confirm_deactivate: 'Tem certeza de que deseja desativar este metodo de envio?',
        manage_coverages: 'Gerenciar coberturas',
        coverages_external_disabled: 'A cobertura deste metodo e gerenciada pela transportadora ou marketplace e nao pode ser editada no Cubbo.',
      },
      history: {
        title: 'Historico de alteracoes',
        no_history: 'Nao ha historico de alteracoes para mostrar.',
        action: 'Acao',
        changes: 'Alteracoes',
        user: 'Usuario',
        date: 'Data',
        refresh: 'Atualizar',
        action_create: 'Criado',
        action_update: 'Atualizado',
        action_costs_update: 'Custos atualizados',
        action_costs_create: 'Custos criados',
        action_zone_sync: 'Zona editada',
        action_coverages_update: 'Coberturas atualizadas',
        action_coverages_create: 'Coberturas criadas',
        field_is_active: 'Ativo',
        field_non_working_days: 'Dias nao uteis',
        field_extended_zone: 'Zona estendida',
        field_po_box_dropoff: 'PO Box',
        field_provides_pod: 'POD',
        field_enable_multipackage: 'Multipacote',
        field_carrier_name: 'Transportadora',
        field_shipping_name: 'Nome',
        field_cost: 'Custo',
        field_max_compound_weight: 'Peso máx. (kg)',
        field_coverage_enabled: 'Cobertura',
        field_xdock: 'Cross-dock',
        field_enabled: 'Ativa',
        field_delivery_sla_in_hours: 'SLA (horas)',
        field_delivery_sla_offset: 'Ajuste de SLA',
        field_zone: 'Zona',
        show_all: 'Ver todos ({{count}})',
        show_less: 'Ver menos',
        showing_of_total: 'Mostrando {{shown}} de {{total}} alterações',
      },
    },
    shipping_costs: {
      loading: 'Carregando…',
      load_error: 'Nao foi possivel carregar o status das zonas. Tente novamente.',
      tabs: {
        tarifas: 'Zonas',
        xdock: 'Xdock',
        status: 'Tarifas por zona',
        missing_cost: 'Zonas sem custo',
        missing_xdock: 'Zonas sem xdock',
        update: 'Atualizar custos',
        create: 'Criar zonas',
      },
      banners: {
        action_title_one: '{{count}} zona requer uma ação',
        action_title_other: '{{count}} zonas requerem uma ação',
        breakdown: '{{cost}} sem custo · {{xdock}} sem xdock',
        view: 'Ver zonas',
        clear: 'Ver todas',
      },
      actions: {
        create_costs: 'Criar custos',
        update_costs: 'Atualizar custos',
        create_single: 'Criar custo',
        update_single: 'Atualizar custo',
        bulk: 'Carregar csv',
        template: 'Baixar modelo',
      },
      modal: {
        create: 'Criar custos em bloco',
        update: 'Atualizar custos em bloco',
        create_single: 'Criar custo',
        update_single: 'Atualizar custo',
      },
      single_form: {
        zone: 'Zona',
        zone_placeholder: 'Nome da zona (ex. ZONA_1)',
        zone_select_placeholder: 'Selecione uma zona',
        weight: 'Peso maximo (kg)',
        cost: 'Custo',
        currency: 'Moeda',
        xdock: 'Cross-dock (xdock)',
        xdock_placeholder: 'Selecione um cross-dock',
        tier: 'Selecione a zona a atualizar',
        tier_placeholder: 'Selecione zona e tier',
        current_cost: 'Custo atual',
        new_cost: 'Custo novo',
        save: 'Salvar',
        saving: 'Salvando…',
        required: 'Preencha os campos obrigatorios.',
        hint_xdock: 'Selecione um cross-dock para poder salvar.',
      },
      bulk_wizard: {
        create_title: 'Criar custos por .csv',
        update_title: 'Atualizar custos por .csv',
        steps: {
          upload: 'Enviar arquivo',
          preview: 'Previa e validacao',
          confirm: 'Confirmacao',
        },
        drop_title: 'Arraste seu arquivo aqui ou clique para buscar',
        drop_hint: 'Aceita arquivos .csv',
        template_question: 'Precisa do modelo?',
        template_desc: 'CSV com todas as colunas e validacoes pre-carregadas.',
        download_template: 'Baixar modelo',
        required_columns: 'Colunas do arquivo',
        optional_tag: 'opcional',
        step_indicator: 'Passo {{current}} de {{total}}',
        manual: 'Ou inserir manualmente',
        csv_only: 'So sao aceitos arquivos .csv',
        parse_error: 'Nao foi possivel ler o arquivo. Verifique o formato.',
        empty_file: 'O arquivo nao tem linhas validas.',
        wrong_columns: 'O arquivo nao tem as colunas esperadas. Use o modelo.',
        back: 'Voltar',
        continue: 'Continuar',
        cancel: 'Cancelar',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Aplicar',
        applying: 'Aplicando…',
        xdock_bindings: 'Atribua um cross-dock a cada zona nova',
        xdock_binding_placeholder: 'Cross-dock para {{zone}}',
        xdock_binding_required: 'Atribua um cross-dock a cada zona para poder validar.',
        method_status_loading: 'Carregando a configuração do método…',
        method_status_error: 'Não foi possível carregar a configuração do método. Feche e tente novamente.',
      },
      xdock_tab: {
        help: 'Cada zona Cubbo deve estar ligada a um cross-dock, senao o pedido falha ao rotear.',
        col_zone: 'Zona',
        col_xdock: 'Cross-dock',
        col_status: 'Estado',
        col_actions: 'Acoes',
        assigned: 'Atribuido',
        missing: 'Falta xdock',
        empty: 'Nao ha zonas Cubbo para este metodo.',
        assign: 'Atribuir xdock',
        edit: 'Editar',
        modal_title: 'Atribuir / editar xdock',
        crossdocks_title: 'Cross-docks',
        crossdocks_help: 'Cross-docks disponiveis no pais do metodo.',
        create_crossdock: 'Criar cross-dock',
        zones_title: 'Zonas e seu cross-dock',
        col_country: 'Pais',
        col_zipcode: 'CEP',
        col_processing: 'Tempo de processo (h)',
        col_phone: 'Telefone',
        crossdocks_empty: 'Nao ha cross-docks neste pais.',
      },
      xdock_form: {
        create_title: 'Criar cross-dock',
        edit_title: 'Editar cross-dock',
        name: 'Nome',
        address: 'Endereco de envio',
        zipcode: 'CEP',
        country: 'Pais',
        country_placeholder: 'Selecione o pais',
        processing_time: 'Tempo de processo (horas)',
        phone: 'Telefone',
        shipping_number: 'Numero de envio',
        save: 'Salvar',
        saving: 'Salvando…',
        success: 'Cross-dock salvo com sucesso.',
        error: 'Nao foi possivel salvar o cross-dock.',
        required: 'Preencha os campos obrigatorios.',
      },
      edit_zone: {
        title: 'Editar custos',
        zone: 'Zona',
        xdock: 'Cross-dock (xdock)',
        xdock_placeholder: 'Selecione um cross-dock',
        ranges_title: 'Faixas de peso e custo',
        col_from: 'A partir de',
        col_to: 'Ate peso',
        col_cost: 'Custo',
        from_zero: 'Mais de 0 kg',
        from_more: 'Mais de {{weight}} kg',
        to_placeholder: 'Sem limite',
        add_range: 'Adicionar faixa',
        add_range_disabled_hint: 'Defina o peso máximo da última faixa antes de adicionar outra.',
        disable: 'Desabilitar',
        enable: 'Habilitar',
        remove: 'Remover',
        save: 'Salvar',
        saving: 'Salvando…',
        error: 'Nao foi possivel salvar. Verifique os dados.',
        incomplete_hint: 'Preencha peso e custo (maiores que 0) em cada faixa ativa para salvar.',
        hint_xdock: 'Selecione um cross-dock para poder salvar.',
        hint_duplicate_weight: 'Há duas faixas com o mesmo peso máximo. Use pesos distintos.',
      },
      status: {
        filter_placeholder: 'Filtrar por uma ou varias zonas',
        export: 'Baixar CSV para atualizar',
        empty: 'Nenhuma zona para mostrar.',
        col_zone: 'Zona',
        col_tiers: 'Tarifa por peso',
        tier_weight: '≤ {{weight}} kg',
        col_cost: 'Custos',
        col_edit: 'Editar',
        not_configured: 'Sem configurar',
        costs_count_one: '{{count}} custo configurado',
        costs_count_other: '{{count}} custos configurados',
        no_coverage: 'Sem cobertura',
        no_coverage_hint:
          'Esta zona não tem CEPs atribuídos nas coberturas, então seu preço nunca é aplicado e não pode ser editado. Atribua cobertura à zona ou remova seu preço.',
        tier_range_first: '≤ {{max}} kg',
        tier_range: '{{min}} – {{max}} kg',
        tier_range_open: 'Mais de {{min}} kg',
        col_tier_weight: 'Faixa de peso',
        col_tier_cost: 'Custo',
        col_tier_id: 'ID',
        tier_cost: '{{currency}} {{cost}}',
        edit: 'Editar',
        edit_menu: {
          costs: 'Editar custos',
          xdock: 'Editar xdock',
        },
        tier_line: '≤ {{weight}} kg · {{cost}}',
        col_xdock: 'Zona xdock',
        col_missing: 'O que falta',
        yes: 'Sim',
        no: 'Nao',
        not_applicable: 'N/A',
        ok: 'Completa',
        notices: {
          UNUSED_COST: 'Sem uso',
          COST_UNREACHABLE: 'Preco nao utilizavel',
        },
        showing: 'Mostrando {{from}}–{{to}} de {{total}}',
        prev: 'Anterior',
        next: 'Proximo',
        missing: {
          MISSING_COST: 'Falta preco',
          MISSING_XDOCK_ZONE: 'Falta zona xdock',
        },
      },
      missing_cost: {
        help: 'Estas zonas tem cobertura mas nao tem preco, entao seus pedidos falham ao cotar. Deveriam ser 0 — crie-as o quanto antes.',
        empty: 'Tudo em ordem: nao ha zonas sem custo.',
        create_button: 'Criar tarifas ({{count}})',
        col_zone: 'Zona',
        col_type: 'Tipo',
        cubbo_needs_xdock: 'Cubbo (tambem precisara de xdock)',
        standard: 'Padrao',
      },
      missing_xdock: {
        help: 'Estas zonas Cubbo tem preco mas falta a zona xdock, entao seus pedidos falham ao rotear. Deveriam ser 0 — selecione-as e atribua um cross-dock.',
        empty: 'Tudo em ordem: nao ha zonas sem xdock.',
        select_placeholder: 'Selecione um cross-dock',
        assign_button: 'Atribuir xdock ({{count}})',
        assigning: 'Atribuindo…',
        assign_error: 'Nao foi possivel atribuir o xdock. Tente novamente.',
        col_zone: 'Zona',
        col_cost: 'Preco',
      },
      update: {
        help: 'Cole ou envie um CSV (id do shipping_cost e novo preco). Voce pode baixar o arquivo pre-preenchido na aba "Tarifas por zona". O preco e opcional se voce so quer habilitar/desabilitar a cobertura dessa linha; cada linha deve trazer ao menos um preco ou uma mudanca de cobertura.',
        col_id: 'ID do shipping_cost',
        col_cost: 'Novo preco',
        col_weight: 'Peso max. (kg)',
        col_enabled: 'Cobertura',
        enabled_unset: '— Sem mudanca',
        enabled_yes: 'Habilitar',
        enabled_no: 'Desabilitar',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Aplicar',
        applying: 'Aplicando…',
      },
      create: {
        help: 'Cadastre precos para zonas novas. O preco e o peso max. composto devem ser maiores que 0 (use um teto alto, ex. 999, para um preco fixo). Voce pode repetir a mesma zona com tetos de peso diferentes para cobrar por faixa (tiers). Para metodos Cubbo voce tambem deve indicar a qual cross-dock (xdock) cada zona pertence.',
        col_zone: 'Zona (tarif_zone)',
        col_cost: 'Preco',
        col_weight: 'Peso max. composto',
        col_currency: 'Moeda (opcional)',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Criar',
        applying: 'Criando…',
        xdock: {
          title: 'Cross-dock por zona (Cubbo)',
          help: 'Cada zona nova de Cubbo precisa de uma zona xdock; se faltar, o pedido nao consegue rotear o last-mile.',
          select_placeholder: 'Selecione um cross-dock',
        },
      },
      validation: {
        valid: 'Tudo certo. Pronto para aplicar.',
        invalid: 'Foram encontrados {{count}} erros. Corrija-os e valide novamente.',
        request_failed: 'A solicitacao falhou. Tente novamente.',
        row: 'Linha',
        message: 'Erro',
      },
    },
    coverage_manager: {
      title: 'Coberturas do metodo',
      back_to_methods: 'Voltar para metodos de envio',
      view_history: 'Ver historico',
      not_found: 'Metodo de envio nao encontrado.',
      external_notice: 'A cobertura deste metodo e gerenciada pela transportadora ou marketplace. Acoes de edicao estao desativadas.',
      inactive_notice: 'Este metodo esta desativado. As coberturas seguem editaveis, mas o metodo nao aceita envios ate ser reativado.',
      inactive_banner: 'Este método de envio está desativado. Não será elegível para ser atribuído a novos pedidos até ser reativado.',
      inactive_banner_with_date: 'Este método de envio está desativado desde {{date}}. Não será elegível para ser atribuído a novos pedidos até ser reativado.',
      external_disabled_tooltip: 'Cobertura gerenciada externamente: nao editavel no Cubbo.',
      no_permission_tooltip: 'Voce nao tem permissoes para editar coberturas.',
      actions_title: 'O que voce deseja fazer?',
      other_actions_title: 'Outras opcoes',
      field: {
        shipping_name: 'Nome',
        carrier_name: 'Transportadora',
        delivery_type: 'Tipo de entrega',
        country: 'Pais',
      },
      bulk_manage: {
        title: 'Gerenciar coberturas em massa',
        description: 'Filtre, selecione e atualize coberturas especificas. Suporta busca por zona, prefixo ou faixa, e upload/download por CSV.',
        hint: 'Recomendado para a maioria das alteracoes — permite revisar antes de aplicar.',
      },
      edit_by_range: {
        title: 'Editar por faixa de CEP',
        description: 'Atualize coberturas para uma ou varias faixas de CEP. Faca upload de um CSV ou preencha manualmente.',
        hint: 'Util para ajustes pontuais sem revisar coberturas individuais.',
      },
      edit_all: {
        title: 'Editar todas as coberturas',
        description: 'Aplique uma alteracao unica a todas as coberturas ativas do metodo (SLA, offset ou status).',
        hint: 'Util para ativar ou desativar todo o metodo de uma so vez.',
      },
      non_working_days: {
        title: 'Dias nao uteis',
        help: 'Selecione os dias em que este metodo nao opera.',
        save: 'Atualizar dias não úteis',
        update_success: 'Dias nao uteis atualizados com sucesso',
        update_error: 'Erro ao atualizar os dias nao uteis',
      },
      status_active: 'Ativo',
      status_inactive: 'Inativo',
      tabs: {
        coverages: 'Coberturas',
        non_working_days: 'Dias nao uteis',
        dispatch_schedules: 'Horarios de coleta',
        draft: 'Rascunho (atual)',
      },
      coverages_table: {
        filters: 'Filtrar',
        clear_filters: 'Limpar filtros',
        export: 'Exportar',
        exporting: 'Exportando…',
        export_in_progress: 'Exportando coberturas, aguarde um momento…',
        export_success: 'Exportado com sucesso',
        export_empty: 'Não há coberturas para exportar com esses filtros.',
        export_error: 'Não foi possível exportar as informações.',
        export_truncated:
          'Exportadas as primeiras {{rows}} coberturas. O método tem coberturas demais para exportar de uma vez — use os filtros para reduzir o resultado.',
        page_of_many: 'Página {{page}} · mais de {{cap}} coberturas',
        selection: {
          count: '{{count}} selecionados',
          update: 'Atualizar selecionados',
          deactivate: 'Desativar selecionados',
          deactivate_error: 'Não foi possível desativar as coberturas selecionadas.',
          clear: 'Limpar seleção',
        },
        filter_panel: {
          status: 'Estado',
          status_all: 'Todas',
          status_active: 'Ativa',
          status_inactive: 'Inativa',
          extended_zone: 'Zona estendida',
          extended_zone_yes: 'Sim',
          extended_zone_no: 'Não',
          zone: 'Zona',
          zone_all: 'Todas as zonas',
          cp: 'CEP',
          cp_placeholder: 'Ex: 01000',
          range: 'Intervalo de CEP',
          range_start: 'CEP inicial',
          range_end: 'CEP final',
          apply: 'Aplicar',
        },
        update_coverage: 'Atualizar cobertura',
        create_coverage: 'Criar cobertura',
        empty: 'Nao ha coberturas para mostrar.',
        load_error: 'Erro ao carregar as coberturas.',
        headers: {
          postal_code: 'CEP',
          zone: 'Zona',
          extended_zone: 'Zona estendida',
          sla_hours: 'SLA (horas)',
          sla_offset: 'SLA offset',
          status: 'Status',
        },
        boolean_yes: 'Sim',
        boolean_no: 'Nao',
      },
      create_modal: {
        title: 'Criar cobertura',
        chooser_hint: 'Como voce quer criar as coberturas?',
        back: 'Voltar',
        close: 'Fechar',
        use_existing_flow: 'Por enquanto, use o fluxo atual de criacao',
        single: {
          title: 'Criar cobertura',
          description: 'Crie uma cobertura para um CEP individual.',
          placeholder: 'Pendente de implementacao: formulario para criar um novo CEP.',
          submit: 'Criar cobertura',
          tab_single: 'Um único CEP',
          tab_range: 'Intervalo de CEP',
          section_location: 'CEP e zona',
          section_delivery: 'Tempos e custos',
          optional_hint: 'Opcionais — vazios usam o valor padrão do método',
          fix_errors: 'Corrija o seguinte e tente novamente:',
          already_exists_count: '{{count}} CEPs já existem',
          error: 'Nao foi possivel criar a cobertura. Verifique sua conexao e tente novamente.',
        },
        bulk: {
          title: 'Carregar csv',
          description: 'Envie uma planilha (CSV ou XLSX) com varias coberturas.',
          placeholder: 'Pendente de implementacao: upload de planilha.',
          drop_hint: 'Arraste um arquivo aqui ou clique para selecionar (.csv, .xlsx)',
        },
      },
      update_modal: {
        menu: {
          single: 'Atualizar cobertura',
          bulk: 'Carregar csv',
          all: 'Toda a cobertura',
        },
        tab_single: 'Um único CEP',
        tab_range: 'Intervalo de CEP',
        tab_all: 'Toda a cobertura',
        range_preview: '{{count}} CEPs serão atualizados',
        range_apply_title: 'Valores a aplicar a todo o intervalo',
        single: {
          title: 'Atualizar cobertura',
          search_label: 'CEP',
          search_placeholder: 'Ex: 01000',
          search_help: 'Busque o CEP para ver e editar sua configuração atual.',
          search_button: 'Buscar',
          searching: 'Buscando…',
          not_found: 'Não existe uma cobertura com esse CEP neste método de envio.',
          change_cp: 'Trocar CEP',
        },
        all: {
          title: 'Atualizar toda a cobertura',
          warning: 'Estas alterações serão aplicadas a todos os CEPs deste método de envio.',
        },
        selected: {
          warning: 'Estas alterações serão aplicadas aos {{count}} CEPs selecionados.',
        },
        sla_warning: 'O SLA ultrapassa 72 horas. Verifique se o valor está correto antes de atualizar.',
        bulk: {
          title: 'Atualizar via Excel',
          placeholder: 'Pendente de implementação: atualização em massa via planilha.',
          drop_hint: 'Arraste um arquivo aqui ou clique para selecionar (.csv, .xlsx)',
        },
        fields: {
          cp: 'CEP',
          sla: 'SLA',
          sla_help: 'Compromisso da transportadora para entregar.',
          sla_placeholder: 'Ex: 24',
          sla_offset: 'SLA offset',
          sla_offset_help: 'Soma à data de entrega prometida.',
          sla_offset_placeholder: 'Ex: 0',
          status: 'Estado',
          status_help: 'Ao desativar, não serão atribuídos novos pedidos.',
          status_no_change: 'Sem alteração',
          status_keep: 'Manter atual',
          status_active: 'Ativa',
          status_paused: 'Desativada',
          hours_suffix: 'horas',
          zone: 'Zona',
          zone_keep: 'Manter zona atual',
          zone_help: 'Reclassifica: a zona define a tarifa (e, na Cubbo, a rota).',
          zone_loading: 'Carregando zonas do método…',
          zone_empty: 'Este método ainda não tem zonas com tarifa nem em uso. Configure-as na aba de custos.',
          zone_load_failed: 'Não conseguimos carregar as zonas do método. Recarregue a página antes de reclassificar.',
          extended_zone: 'Zona estendida',
          extended_zone_keep: 'Manter atual',
          extended_zone_yes: 'Sim',
          extended_zone_no: 'Não',
          extended_zone_help: 'Taxa ODA/OPA somada à tarifa da zona.',
        },
        zone_section_title: 'Zona e taxa',
        zone_method_wide_note:
          'A zona não pode ser alterada para o método inteiro: a varredura deixaria todas as coberturas em uma única zona e não há histórico para reverter. Altere por CEP, por intervalo ou selecionando coberturas na lista.',
        extended_zone_method_wide_warning:
          'A zona estendida será aplicada a TODOS os CEPs do método: os que hoje a possuem ficarão iguais aos demais e não há histórico por CEP para reverter.',
        zone_rewrite_range_warning:
          'A zona ou a taxa dos {{count}} CEPs do intervalo será reescrita, inclusive os que hoje estão desativados, e não fica histórico por CEP para reverter.',
        zone_none_applies_warning:
          'NONE_APPLIES deixa as coberturas sem chave de tarifa (e, na Cubbo, sem chave de roteamento). Use apenas se for cadastrar a tarifa depois.',
        server_codes: {
          INVALID_ZONE: 'O nome da zona é inválido.',
          ZONE_HAS_NO_SHIPPING_COST: 'A zona não tem tarifa que o sistema consiga usar neste método.',
          ZONE_COST_SHADOWED_BY_DISABLED_TIER: 'Uma faixa de peso desativada mais barata bloqueia a tarifa da zona.',
          ZONE_HAS_NO_XDOCK: 'A zona não está vinculada a nenhum xdock: um pedido Cubbo Last Mile não conseguiria ser roteado.',
          ZONE_HAS_NO_XDOCK_ROUTE: 'O xdock da zona não tem rota de entrega habilitada.',
          MISSING_EXTENDED_ZONE_COST: 'Este método não tem tarifa EXTENDED_ZONE: a taxa ficaria sem preço.',
          ZONE_UPDATE_NOT_ALLOWED_METHOD_WIDE: 'A zona não pode ser alterada para o método inteiro. Faça por CEP, por intervalo ou sobre uma seleção.',
          NO_UPDATE_PARAMETERS: 'Você não enviou nenhum campo para atualizar.',
          TOO_MANY_IDS: 'Você selecionou coberturas demais. Use a atualização por intervalo.',
          COVERAGE_IDS_NOT_IN_METHOD: 'Alguma das coberturas não pertence a este método de envio.',
          INVALID_RANGE: 'O intervalo de CEP é inválido.',
        },
        require_field: 'Escolha ao menos um campo para atualizar.',
        submit: 'Atualizar cobertura',
        error: 'Não foi possível atualizar a cobertura. Verifique sua conexão e tente novamente.',
      },
      bulk_upload: {
        title: 'Carregar coberturas por .csv',
        title_update: 'Atualizar coberturas por .csv',
        steps: {
          upload: 'Enviar arquivo',
          preview: 'Pré-visualização e validação',
          confirm: 'Confirmação',
        },
        drop_title: 'Arraste seu arquivo aqui ou clique para buscar',
        drop_hint: 'Aceita arquivos .csv',
        template_question: 'Precisa do modelo?',
        template_desc: 'Excel com todas as colunas e validações pré-carregadas.',
        download_template: 'Baixar modelo',
        required_columns: 'Colunas do arquivo',
        optional_tag: 'opcional',
        // Ver o comentário em es.js: `vocab_*` é a lista única de palavras aceitas.
        hint_range_start: '(CEP ou início do intervalo)',
        hint_range_ends: '(fim do intervalo)',
        hint_percent: '(%)',
        hint_values: '({{values}})',
        // Compartilhado por `estado` e pelo `zona_extendida` do CSV de atualização.
        hint_values_keep: '({{values}} — vazio: não alterar)',
        hint_keep: '(vazio: não alterar)',
        vocab_si_no: 'sim/não',
        vocab_estado: 'ativa/desativada',
        step_indicator: 'Passo {{current}} de {{total}}',
        change: 'Trocar',
        rows_detected: '{{count}} linhas detectadas',
        preview_title: 'Pré-visualização · Primeiras {{count}} linhas',
        valid_title: '{{count}} linhas válidas, prontas para importar',
        warnings_title: '{{count}} linhas com avisos',
        warnings_desc: 'Offsets maiores que 72h.',
        errors_title: '{{count}} linhas com erros',
        errors_desc: 'Faltam campos obrigatórios ou têm formato inválido.',
        issue_missing: 'falta o dado ({{count}})',
        issue_format: 'formato inválido ({{count}})',
        issue_invalid_value: 'valor não aceito, use {{values}} ({{count}})',
        issue_too_wide: 'intervalo muito amplo, máximo {{max}} CEPs ({{count}})',
        issue_no_update_fields: 'a linha não altera nada: preencha zona, zona_extendida, sla_horas, sla_offset ou estado ({{count}})',
        unsupported_country: 'A carga por planilha ainda não suporta coberturas de {{country}}. Use as abas de CEP individual ou intervalo.',
        padded_notice: '{{count}} linhas traziam o CEP sem o zero inicial (o Excel lê como número); ele foi restaurado. Confira se não é um dígito faltando.',
        too_many_coverages: 'O arquivo criaria {{count}} coberturas e o máximo por carga é {{max}}. Divida o arquivo em várias cargas.',
        wide_range_notice:
          '{{count}} linhas cobrem intervalos amplos ({{codes}} CEPs no total). Será aplicado a todos: confira se o fim do intervalo está certo.',
        see_detail: 'Ver detalhe',
        rows_affected: 'CEP: {{list}}',
        back: 'Voltar',
        import: 'Importar {{count}} linhas',
        step2_indicator: 'Passo 2 de 3 · ignora {{count}} linhas com erros',
        csv_only: 'A pré-visualização está disponível para arquivos CSV. Baixe e use o modelo CSV.',
        parse_error: 'Não foi possível ler o arquivo. Verifique se tem cabeçalhos e ao menos uma linha de dados.',
        zone_rewrite_notice:
          '{{count}} linhas com intervalo trazem zona: TODOS os CEPs do intervalo serão reclassificados, inclusive os que hoje estão desativados. A zona define a tarifa que cobramos e pagamos.',
        extended_zone_rewrite_notice:
          '{{count}} linhas com intervalo trazem zona_extendida: será aplicada a TODOS os CEPs do intervalo, então os que hoje têm a taxa ficarão iguais aos demais.',
        status_rewrite_notice:
          '{{count}} linhas com faixa trazem estado: será aplicado a TODOS os CEPs da faixa, inclusive os que hoje estão desativados. Deixe a coluna estado vazia para alterar apenas o SLA.',
        create_status_ignored: '{{count}} linhas trazem estado desativada, mas as coberturas são sempre criadas ativas. Desative-as depois pela listagem.',
        error: 'Não foi possível concluir a importação. Verifique sua conexão e tente novamente.',
        job_failed: 'A importação falhou no servidor. Revise o arquivo e tente novamente.',
        job_partial: 'A importação foi aplicada apenas em parte ({{applied}} linhas). Revise o arquivo antes de tentar de novo.',
        job_unavailable: 'Não foi possível confirmar o resultado da importação. Verifique as coberturas na listagem antes de carregar o arquivo novamente.',
        no_rows_matched:
          'O arquivo foi processado, mas nenhum CEP correspondeu à cobertura deste método: nada foi atualizado. Verifique se os CEPs existem neste método de envio.',
        no_job: 'O servidor não confirmou a importação. Verifique as coberturas na listagem antes de tentar de novo.',
        confirm_placeholder: 'Confirmação — em breve.',
        importing: 'Importando coberturas…',
        done_title: 'Coberturas importadas',
        done_summary: '{{imported}} importadas · {{skipped}} omitidas',
        imported_by: 'Importadas por',
        file_label: 'Arquivo',
        date_label: 'Data',
        changes_applied: 'Alterações aplicadas ao método',
        close: 'Fechar',
        view_coverages: 'Ver coberturas',
        cost_column_ignored:
          'A coluna cost é ignorada: o custo é por zona e faixa de peso, e se configura na aba de custos. Este arquivo apenas cria coberturas.',
        server_errors_title: 'O servidor recusou o arquivo · {{count}} linhas com problemas',
        server_codes: {
          INVALID_VALUE: 'CEP com formato inválido para o país do método',
          DUPLICATE_VALUE_IN_PAYLOAD: 'CEP repetido dentro do arquivo',
          COVERAGE_ALREADY_EXISTS: 'O CEP já tem cobertura neste método',
          ZONE_HAS_NO_XDOCK: 'A zona não está vinculada a nenhum xdock do país',
          ZONE_HAS_NO_SHIPPING_COST: 'A zona não tem custo de envio neste método',
          INVALID_ZONE: 'O nome da zona é inválido',
          ZONE_COST_SHADOWED_BY_DISABLED_TIER: 'Uma faixa de peso desativada mais barata bloqueia a tarifa da zona',
          ZONE_HAS_NO_XDOCK_ROUTE: 'O xdock da zona não tem rota de entrega habilitada',
          MISSING_EXTENDED_ZONE_COST: 'Este método não tem tarifa EXTENDED_ZONE: a taxa ficaria sem preço',
          ZONE_UPDATE_NOT_ALLOWED_METHOD_WIDE: 'A zona não pode ser alterada para o método inteiro. Faça por CEP, por intervalo ou sobre uma seleção',
          NO_UPDATE_PARAMETERS: 'Alguma linha não traz nenhum campo para atualizar',
          INVALID_RANGE: 'Alguma linha tem um intervalo de CEP inválido',
        },
        server_code_unknown: 'Erro {{code}}',
        server_zones_affected: 'Zonas: {{list}}',
        server_rows_sample: 'CEP: {{list}}',
        server_more: '+{{count}} mais',
        server_available_zones: 'Zonas com custo configurado neste método: {{list}}',
      },
      dispatch_placeholder: 'Os horarios de coleta sao gerenciados a nivel armazem. Em breve acessiveis aqui filtrados por este metodo.',
      dispatch_link_text: 'Os horários de coleta são gerenciados a nível de armazém.',
      dispatch_link_label: 'Ir para Horários de coleta',
      draft_notice: 'Visao da tela atual. Mantida aqui como referencia enquanto migramos seu conteudo para as novas abas.',
    },
    dispatch_schedules: {
      title: 'Horarios de despacho',
      empty_table: 'Nao ha horarios de despacho para mostrar.',
      footer_text: 'horarios',
      add_schedule: 'Criar horario',
      edit_schedule: 'Editar horario',
      actions: {
        enable: 'Ativar',
        disable: 'Desativar',
        delete: 'Excluir',
        confirm_enable: 'Tem certeza de que deseja ativar este horario?',
        confirm_disable: 'Tem certeza de que deseja desativar este horario?',
        confirm_delete: 'Tem certeza de que deseja excluir este horario? Esta acao nao pode ser desfeita.',
        duplicate: 'Duplicar',
      },
      headers: {
        carrier_name: 'Transportadora',
        dispatch_day: 'Dia de despacho',
        dispatch_time: 'Hora de despacho',
        time_before_dispatch: 'Tempo antes de despacho',
        enable: 'Habilitado',
        channel_type: 'Canal de venda',
        shipping_state: 'Estado de destino',
        actions: 'Acoes',
        created_at: 'Criado',
        updated_at: 'Atualizado',
      },
      filters: {
        carrier_name: 'Transportadora',
        enable: 'Somente habilitados',
        disable: 'Somente desativados',
        dispatch_day: 'Dia de despacho',
        channel_type_id: 'Canal de venda',
        shipping_state: 'Estado de destino',
        shipping_method_id: 'Metodo de envio',
      },
      form: {
        carrier_name: 'Transportadora',
        dispatch_day: 'Dia de despacho',
        dispatch_time: 'Hora de despacho',
        time_before_dispatch: 'Tempo antes de despacho',
        enable: 'Habilitado',
        channel_type: 'Canal de venda',
        shipping_state: 'Estado de destino',
        select_channel_type: 'Selecionar canal',
        select_shipping_state: 'Selecionar estado',
        no_filter: 'Sem filtro (generico)',
        all_states: 'Todos os estados',
        all_channels: 'Todos os canais',
        cancel: 'Cancelar',
        save: 'Salvar',
        create: 'Criar',
        update: 'Atualizar',
        select_carrier: 'Selecionar transportadora',
        select_day: 'Selecionar pelo menos um dia',
        dispatch_days: 'Dias de despacho',
        select_all_days: 'Todos os dias',
        select_weekdays: 'Segunda a sexta',
        time_before_value: 'Quantidade',
        time_before_unit: 'Unidade',
        time_before_help: 'Tempo mínimo antes do horário de despacho em que os pedidos devem estar prontos para envio.',
        cutoff_preview: 'Os pedidos deverão estar prontos antes das {{time}}',
        warning_over_2h: '⚠ O tempo antes do despacho é maior que 2 horas. Tem certeza de que está correto?',
        warning_days_before: '⚠ O corte cairia em um dia anterior ao despacho. Verifique se este valor está correto.',
        schedule_type: 'Tipo de horario',
        type_carrier: 'Por transportadora',
        type_cross_carrier: 'Por canal de venda',
        type_shipping_method: 'Por metodo de envio',
        type_carrier_help: 'Aplica somente a uma transportadora especifica.',
        type_cross_carrier_help: 'Aplica a pedidos que correspondam ao canal de venda e/ou estado, independente da transportadora.',
        type_shipping_method_help: 'Aplica somente a um metodo de envio especifico.',
        cross_carrier_requirement: 'O canal de venda é obrigatório.',
        shipping_method: 'Metodo de envio',
        select_shipping_method: 'Selecionar metodo de envio',
      },
      sort: {
        by_dispatch_time: 'Ordenar por hora de despacho',
        by_cutoff_time: 'Ordenar por hora de corte',
      },
      cutoff_label: 'Corte',
      disabled_label: 'Desabilitado',
      moving: 'Movendo...',
      confirm_move: {
        title: 'Mover horário de despacho',
        description: 'Tem certeza de mover {{count}} horário(s) para o dia {{day}}?',
        confirm: 'Mover',
        cancel: 'Cancelar',
      },
      bulk: {
        select: 'Selecionar vários horários',
        exit_selection: 'Cancelar seleção',
        select_action: 'Selecione uma ação',
        select_all: 'Selecionar todos',
        deselect_all: 'Desselecionar todos',
        schedules_selected: 'horário(s) selecionado(s)',
        confirm_enable_title: 'Ativar horários',
        confirm_enable_description: 'Tem certeza de que deseja ativar {{count}} horário(s)?',
        confirm_disable_title: 'Desativar horários',
        confirm_disable_description: 'Tem certeza de que deseja desativar {{count}} horário(s)?',
        confirm_delete_title: 'Excluir horários',
        confirm_delete_description: 'Tem certeza de que deseja excluir {{count}} horário(s)? Esta ação não pode ser desfeita.',
      },
      today: 'Hoje',
      warehouse_time: 'Hora do armazém',
      cutoff_days_before_one: '{{count}} dia antes',
      cutoff_days_before_other: '{{count}} dias antes',
      duration_units: {
        hours_one: '{{count}} hora',
        hours_other: '{{count}} horas',
        minutes: '{{count}} min',
        unit_hours: 'Horas',
        unit_minutes: 'Minutos',
      },
      notifications: {
        create_success: 'Horario de despacho criado com sucesso',
        create_error: 'Erro ao criar o horario de despacho',
        update_success: 'Horario de despacho atualizado com sucesso',
        hidden_by_filter: 'O horário foi ocultado da vista pelo filtro ativo',
        update_error: 'Erro ao atualizar o horario de despacho',
        delete_success: 'Horario de despacho excluido com sucesso',
        delete_error: 'Erro ao excluir o horario de despacho',
        move_success: 'Horario de despacho movido com sucesso',
        move_error: 'Erro ao mover o horario de despacho',
        bulk_enable_success: '{{count}} horario(s) ativado(s) com sucesso',
        bulk_enable_error: 'Erro ao ativar os horarios',
        bulk_already_enabled: '{{names}} ja se encontra(m) ativado(s)',
        bulk_disable_success: '{{count}} horario(s) desativado(s) com sucesso',
        bulk_disable_error: 'Erro ao desativar os horarios',
        bulk_already_disabled: '{{names}} ja se encontra(m) desativado(s)',
        bulk_delete_success: '{{count}} horario(s) excluido(s) com sucesso',
        bulk_delete_error: 'Erro ao excluir os horarios',
        bulk_partial_error: '{{succeeded}} com sucesso, {{failed}} com falha',
      },
      errors: {
        fetch_error: 'Erro ao carregar os horarios de despacho',
        no_access: 'Voce nao tem acesso a esta secao',
        required_fields: 'Por favor complete todos os campos obrigatorios',
      },
      history: {
        title: 'Historico de alteracoes',
        no_history: 'Nao ha historico de alteracoes para mostrar.',
        action: 'Acao',
        changes: 'Alteracoes',
        user: 'Usuario',
        date: 'Data',
        refresh: 'Atualizar',
        action_create: 'Criado',
        action_update: 'Atualizado',
        action_delete: 'Excluido',
        deleted_label: 'Horario excluido',
        field_carrier_name: 'Transportadora',
        field_dispatch_day: 'Dia de despacho',
        field_dispatch_time: 'Hora de despacho',
        field_time_before_dispatch: 'Tempo antes de despacho',
        field_enable: 'Habilitado',
        field_channel_type_id: 'Canal de venda',
        field_shipping_state: 'Estado de destino',
        field_shipping_method_id: 'Metodo de envio',
      },
      generic_label: 'Generico',
      cross_carrier_label: 'Por Integração',
      shipping_method_label: 'Metodo de envio',
      grouped_view: {
        all_carriers: 'Todas as transportadoras',
        all_channels: 'Todos os canais',
        all_states: 'Todos os estados',
        all_shipping_methods: 'Todos os metodos',
        all_status: 'Todos',
        enabled_only: 'Apenas habilitados',
        disabled_only: 'Apenas desativados',
        reset_filters: 'Limpar filtros',
      },
    },
    // TODO: revisar copia PT
    automated_coverage_deactivations: {
      title: 'Coberturas auto-desactivadas',
      footerText: 'desactivaciones',
      filters: {
        onlyPending: 'Solo pendientes',
        carrier: 'Paquetería',
        allCarriers: 'Todas las paqueterías',
        dateRange: 'Rango de fechas',
        dateFrom: 'Desde',
        dateTo: 'Hasta',
      },
      columns: {
        deactivatedAt: 'Fecha',
        carrier: 'Paquetería',
        shippingMethod: 'Método',
        zipCode: 'CP',
        message: 'Mensaje de error',
        order: 'Pedido',
        status: 'Estado',
        actions: 'Acciones',
      },
      status: {
        pending: 'Por revisar',
        acknowledged: 'Revisado',
      },
      actions: {
        acknowledge: 'Marcar como revisado',
      },
      empty: {
        default: 'No hay coberturas auto-desactivadas pendientes de revisión.',
        defaultPerWarehouse: 'No hay coberturas auto-desactivadas pendientes de revisión en este almacén.',
        withFilters: 'No se encontraron resultados con los filtros aplicados.',
      },
      scopeTooltip: 'Solo se muestran desactivaciones disparadas por órdenes de este almacén.',
      errors: {
        noAccess: 'No tienes permiso para ver esta sección.',
        fetchError: 'No se pudieron cargar las desactivaciones.',
        retry: 'Reintentar',
      },
      toast: {
        acknowledgeSuccess: 'Marcado como revisado',
        acknowledgeError: 'No se pudo marcar como revisado. Intenta de nuevo.',
        notFoundError: 'La desactivación ya no existe',
      },
      drawer: {
        title: 'Detalle de desactivación',
        shipping: 'Información del envío',
        shippingType: 'Tipo',
        shippingMethodUnavailable: 'Información del método no disponible.',
        coverage: 'Cobertura desactivada',
        coverageUnavailable: 'Cobertura no disponible.',
        coverageReenabled: 'Re-habilitada manualmente',
        zone: 'Zona',
        enabled: 'Habilitada',
        extendedZone: 'Zona extendida',
        poBoxDropoff: 'PO Box',
        error: 'Error que disparó',
        errorCode: 'Código',
        responseBody: 'Response del carrier',
        copyResponse: 'Copiar',
        copied: 'Copiado',
        metadataMissing: 'Metadata no disponible. Mostrando mensaje crudo.',
        noOrder: 'Sin orden asociada',
        noError: 'Sin error asociado',
        dates: 'Fechas',
        deactivatedAt: 'Desactivado',
        acknowledgedAt: 'Revisado',
        warning: 'Si verificas que el error ocurrido no debería apagar la cobertura, avisa a tech para que ajuste la regla.',
        close: 'Cerrar',
      },
    },
  },

  deleted_lost_history: {
    title: 'Histórico de Eliminações de Estoque Perdido',
    go_back: 'Voltar a Eliminar Estoque',
    records: 'Registros',
    empty_table: 'Não há eliminações registradas para o intervalo de datas selecionado.',
    initial_message: 'Selecione um intervalo de datas e pressione Buscar para ver o histórico de eliminações.',
    total_deleted: 'Total de unidades eliminadas no período: {{count}}',
    error_loading: 'Erro ao carregar o histórico de eliminações.',
    filters: {
      date_range: 'Intervalo de datas',
      start_date: 'Data início',
      end_date: 'Data fim',
      store_name: 'Loja',
      sku: 'SKU',
      bar_code: 'UPC',
      lot: 'Lote',
      search: 'Buscar',
      clear: 'Limpar',
    },
    columns: {
      discarded_at: 'Data de Eliminação',
      store_name: 'Loja',
      sku: 'SKU',
      bar_code: 'UPC',
      lot: 'Lote',
      quantity: 'Quantidade Eliminada',
      location: 'Localização',
      discarded_by: 'Eliminado por',
    },
  },

  cycle_counts: {
    title: 'Contagens Cíclicas',
    warehouse: 'Armazém',
    assign_button: 'Atribuir',
    tabs: {
      locations: 'Localizações',
      conteos: 'Contagens',
      reviews: 'Revisões',
    },
    locations: {
      title: 'localizações',
      location_code: 'Código de Localização',
      zone: 'Área',
      location_type: 'Tipo de Localização',
      store: 'Loja',
      sku: 'SKU',
      upc: 'UPC',
      assignment_status: 'Estado de Atribuição',
      status_available: 'Disponível',
      status_assigned: 'Atribuído a {{operator}}',
      last_counted_at: 'Última contagem',
      never_counted: 'Nunca contado',
      empty_table: 'Não há localizações disponíveis.',
      filters: {
        location_code: 'Buscar por código',
        zone: 'Buscar por área',
        location_type: 'Buscar por tipo',
        store: 'Buscar por loja',
        sku: 'Buscar por SKU',
        upc: 'Buscar por UPC',
      },
    },
    conteos: {
      operator: 'Operador',
      locations_count: 'Localizações',
      progress: 'Progresso',
      status: 'Estado',
      assigned_date: 'Data de Atribuição',
      status_pending: 'Pendente',
      status_in_progress: 'Em Progresso',
      status_completed: 'Concluído',
      status_review_pending: 'Revisão Atribuída',
      status_review_submitted: 'Revisão Concluída',
      status_resolved: 'Resolvido',
      status_unassigned: 'Sem Atribuição',
      status_in_review: 'Em Revisão',
      pending_reviews: '{{count}} revisões pendentes',
      origin: 'Origem',
      origin_manual: 'Manual',
      origin_missing_stock: 'Produto Faltante',
      origin_coverage_event: 'Evento',
      origin_mixed: 'Misto',
      empty_table: 'Não há contagens cíclicas.',
      load_error: 'Não foi possível carregar as contagens. Tente novamente mais tarde.',
      filters: {
        operator: 'Buscar por operador',
        status: 'Estado',
        origin: 'Origem',
      },
    },
    reviews: {
      location: 'Localização',
      counter: 'Contador',
      divergent_products: 'SKUs com diferença',
      status: 'Estado',
      attempts: 'Tentativas',
      submitted_at: 'Enviado',
      reviewer: 'Revisor',
      unassigned_group: 'Sem atribuir',
      status_unassigned: 'Sem atribuir',
      status_pending: 'Pendente',
      status_disagreement: 'Divergência',
      empty_table: 'Não há revisões pendentes.',
      load_error: 'Não foi possível carregar as revisões. Tente novamente mais tarde.',
      assign_button: 'Atribuir revisão',
      reassign_button: 'Reatribuir revisão',
      resolve_button: 'Resolver',
      discard_button: 'Descartar',
      filters: {
        reviewer: 'Buscar por revisor',
        status: 'Estado',
      },
      mixed_status_error: 'Selecione revisões no mesmo estado.',
      truncated_notice: 'Mostrando {{shown}} de {{total}} revisões de {{reviewer}}; atribua ou descarte estas para ver o restante.',
    },
    resolve_modal: {
      title: 'Resolver revisão',
      summary:
        'Localização {{location}} — o revisor não coincidiu com o sistema ({{attempts}} tentativas). Ao resolver, a contagem fica encerrada com o resultado do revisor; os ajustes de estoque são tratados separadamente.',
      product: 'Produto',
      system_at_count: 'Sistema na contagem',
      counter: 'Contador',
      system_now: 'Sistema agora',
      reviewer: 'Revisor',
      confirm: 'Resolver',
      cancel: 'Cancelar',
      success: 'Revisão resolvida',
      error: 'Erro ao resolver a revisão',
    },
    task_panel: {
      title: 'Detalhe da Contagem',
      operator: 'Operador',
      assigned_date: 'Data de Atribuição',
      progress: 'Progresso',
      locations_counted: 'localizações contadas',
      matches: 'correspondências',
      divergences: 'divergências',
      pending: 'Pendente',
      product: 'Produto',
      counted: 'Contado',
      system: 'Sistema',
      result: 'Resultado',
      no_locations: 'Sem localizações',
      status_pending: 'Pendente',
      status_submitted: 'Aguardando Revisão',
      status_review_pending: 'Revisão Atribuída',
      status_review_submitted: 'Revisão Concluída',
      status_resolved: 'Resolvido',
      reviewer: 'Revisor',
      reviewer_counted: 'Revisor Contagem',
      review_outcome: 'Resultado da Revisão',
      outcome_confirmed: 'Confirmado',
      outcome_counter_confirmed: 'Contador Confirmado',
      outcome_disagreement: 'Desacordo',
      download_csv: 'Baixar CSV',
      selected_count: '{{count}} localizações selecionadas',
      unassign_action: 'Desatribuir',
      reassign_action: 'Reatribuir',
    },
    assign_modal: {
      title: 'Atribuir Contagem Cíclica',
      operator_name: 'Operador',
      search_operator: 'Buscar Operador',
      choose_operator: 'Escolha um operador',
      pending_counts: 'Contagens Pendentes',
      operators: 'Operadores',
      locations: 'Localizações',
      selected_count: '{{count}} localizações selecionadas',
      assign: 'Atribuir',
      cancel: 'Cancelar',
      success: 'Contagem cíclica atribuída com sucesso',
      success_with_take_over: '{{count}} localizações atribuídas, {{taken_over}} contagens pendentes assumidas',
      error: 'Erro ao atribuir contagem cíclica',
    },
    bulk_assign_button: 'Atribuição em Massa',
    bulk_assign: {
      title: 'Atribuição em Massa de Contagens',
      filters_step: {
        area_label: 'Área',
        area_placeholder: 'Selecionar área',
        row_label: 'Fileira',
        row_placeholder: 'Selecionar fileira (opcional)',
        store_label: 'Loja',
        store_placeholder: 'Selecionar loja (opcional)',
        preview_button: 'Pré-visualização',
        at_least_one_filter: 'Selecione pelo menos um filtro',
      },
      preview_step: {
        title: 'Resumo da Atribuição',
        filters_applied: 'Filtros aplicados',
        area_row_column: 'Área - Fileira',
        assignable_column: 'A atribuir',
        already_pending_column: 'Já atribuídos',
        total_assignable: '{{count}} localizações a atribuir',
        total_skipped: '{{count}} localizações omitidas (já possuem contagem pendente)',
        to_take_over: '{{count}} localizações assumirão uma contagem pendente de outro operador',
        show_skipped: 'Ver localizações omitidas',
        hide_skipped: 'Ocultar localizações omitidas',
        and_more: '... e mais',
        no_locations: 'Nenhuma localização encontrada com os filtros selecionados',
        all_already_assigned: 'Todas as localizações já possuem uma contagem pendente',
        select_operator: 'Selecionar Operador',
        back: 'Voltar',
      },
      operator_step: {
        title: 'Serão atribuídas {{count}} localizações',
        assign_button: 'Atribuir',
        back: 'Voltar',
      },
      confirm_step: {
        title: 'Confirmar distribuição',
        operator_column: 'Operador',
        count_column: 'Localizações',
        from_column: 'De',
        to_column: 'Até',
        confirm_button: 'Confirmar',
        back: 'Voltar',
        loading: 'Carregando distribuição...',
        error: 'Erro ao carregar a distribuição',
        retry: 'Tentar novamente',
      },
      success: '{{count}} contagens cíclicas criadas com sucesso',
      success_with_skipped: '{{created}} contagens cíclicas criadas ({{skipped}} localizações omitidas)',
      success_with_take_over_and_skipped: '{{created}} contagens cíclicas criadas, {{taken_over}} pendentes tomadas ({{skipped}} localizações omitidas)',
      success_multi: '{{count}} contagens criadas: {{details}}',
      success_multi_with_skipped: '{{count}} contagens criadas: {{details}} ({{skipped}} localizações omitidas, {{taken_over}} contagens pendentes assumidas)',
      error: 'Erro ao criar contagens cíclicas',
    },
    unassign_button: 'Desatribuir',
    reassign_button: 'Reatribuir',
    unassign_modal: {
      title: 'Desatribuir localizações',
      summary: '{{batches}} contagens selecionadas ({{locations}} localizações)',
      review_pending_warning: 'Algumas localizações já foram contadas pelo operador. Ao desatribuir a contagem registrada será apagada.',
      unassigned_warning: 'As contagens sem atribuição selecionadas serão removidas da fila e deixarão de aparecer nesta lista.',
      operator: 'Operador',
      locations: 'Localizações',
      status: 'Estado',
      status_pending: 'Pendente',
      status_unassigned: 'Sem Atribuição',
      status_review_pending: 'Revisão Atribuída',
      status_submitted: 'Enviado',
      status_review_submitted: 'Revisado',
      confirm: 'Desatribuir',
      cancel: 'Cancelar',
      success: '{{count}} localizações desatribuídas',
      error: 'Erro ao desatribuir localizações',
    },
    reassign_modal: {
      title: 'Reatribuir localizações',
      summary: '{{batches}} contagens selecionadas ({{locations}} localizações)',
      mode_single: 'Um único operador',
      mode_distribute: 'Distribuir entre vários',
      mixed_status_error: 'Só é possível reatribuir localizações no mesmo estado.',
      confirm: 'Reatribuir',
      cancel: 'Cancelar',
      success: '{{count}} localizações reatribuídas',
      error: 'Erro ao reatribuir localizações',
      counter_notice: 'O contador destas localizações ({{names}}) não pode ser o revisor.',
      review_title: 'Atribuir revisão',
      review_summary: '{{locations}} revisões selecionadas',
    },
    errors: {
      REVIEWER_IS_COUNTER: 'O revisor não pode ser quem contou estas localizações: {{locations}}.',
      THIRD_COUNT_REQUIRES_DISAGREEMENT: 'Só é possível enviar para uma terceira contagem quando há divergência entre o contador e o revisor.',
      REVIEW_REASSIGNED: 'Esta revisão foi reatribuída ou encerrada enquanto você a avaliava. Atualize a lista e tente novamente.',
      NOT_REVIEW_SUBMITTED: 'Esta contagem não está mais aguardando resolução. Atualize a lista e tente novamente.',
      OPERATORS_DISABLED: 'Um ou mais operadores selecionados estão desabilitados. Escolha outro operador.',
    },
    found_stock: {
      declared_banner_one: '{{count}} sobra foi declarada em {{location}}.',
      declared_banner_other: '{{count}} sobras foram declaradas em {{location}}.',
      skipped_banner_one: '{{count}} linha não foi declarada: {{reasons}}.',
      skipped_banner_other: '{{count}} linhas não foram declaradas: {{reasons}}.',
      view_link: 'Ver em Sobras',
      surplus_link: 'Sobra detectada · ver em Sobras',
      reasons: {
        stale: 'o estoque mudou desde a contagem',
        transient_units_present: 'há peças em trânsito',
        lot_ambiguous: 'lote ambíguo',
        lot_unknown: 'lote desconhecido',
        unit_code_product: 'produto com código de unidade',
        product_missing: 'produto inexistente',
        product_not_in_count: 'produto fora da contagem',
        duplicate_row: 'linha duplicada',
        surplus_exceeds_cap: 'excede o máximo por declaração',
        resolve_cap_exceeded: 'excede o máximo por resolução',
        found_stock_disabled: 'sobras desativado no armazém',
        error: 'erro interno',
        FOUND_STOCK_NOT_AUTHORIZED: 'sem autorização para declarar sobras',
      },
    },
    events: {
      tab: 'Eventos',
      wall_to_wall: 'Wall to Wall',
      create_button: 'Novo evento',
      empty: 'Não há eventos neste armazém.',
      unavailable: 'Os eventos não estão disponíveis nesta versão do sistema.',
      load_error: 'Não foi possível carregar os eventos.',
      gate: {
        banner_title: 'Eventos desativados neste armazém',
        banner_body: 'Os eventos existentes podem ser consultados, mas não criados nem ampliados até a função ser ativada.',
      },
      filters: { store_id: 'Loja', area: 'Área', row: 'Fila', location_type: 'Tipo' },
      columns: {
        label: 'Evento',
        store: 'Loja',
        trigger: 'Origem',
        created_by: 'Criado por',
        created_at: 'Criado',
        coverage: 'Cobertura',
        status: 'Situação',
      },
      trigger: { manual: 'Manual', accuracy_gate: 'Automático' },
      status: {
        open: 'Aberto',
        reconciling: 'Conciliando',
        pending_approval: 'Aguardando assinatura',
        signed: 'Assinado',
        closed: 'Fechado',
        canceled: 'Cancelado',
      },
      status_filter: {
        all: 'Todos',
        open: 'Abertos',
        closed: 'Fechados',
        canceled: 'Cancelados',
        reconciling: 'Conciliando',
        pending_approval: 'Aguardando assinatura',
        signed: 'Assinados',
      },
      create: {
        title: 'Novo evento de contagem',
        preview_title: 'Prévia',
        to_spawn: '{{count}} localizações receberão uma contagem nova',
        watched: '{{count}} localizações já têm contagem ativa e serão acompanhadas sem duplicar',
        store_wide_hint: 'Este evento cobre toda a loja: será exibido como Wall to Wall.',
        signature_toggle: 'Exige assinatura do cliente ao executar os ajustes',
        store_wide_signature_locked: 'Obrigatória para eventos de toda a loja',
        confirm: 'Criar evento',
        created: 'Evento criado.',
      },
      detail: {
        title: 'Evento',
        open_event: 'Evento #{{id}}',
        retry: 'Tentar novamente',
        load_error_stale: 'Não foi possível atualizar; exibindo a última visão carregada.',
        totals: {
          locations: 'Localizações',
          satisfied: 'Cobertas',
          in_review: 'Em revisão',
          assigned: 'Atribuídas',
          unassigned: 'Sem atribuição',
          uncovered: 'Sem contagem',
        },
        state: { satisfied: 'Coberta', in_review: 'Em revisão', assigned: 'Atribuída', unassigned: 'Sem atribuição', uncovered: 'Sem contagem' },
        state_filter_all: 'Todas',
        columns: { location: 'Localização', state: 'Situação', count: 'Contagem', assigned_to: 'Atribuído a' },
        unassigned: 'Sem atribuição',
        added_after_snapshot: 'Adicionada após o início',
        satisfied_by: 'Coberta pela contagem #{{id}} ({{origin}})',
        tabs: { locations: 'Localizações', differences: 'Diferenças', drift: 'Mudanças desde o início' },
        close: 'Fechar evento',
        cancel: 'Cancelar evento',
        closed: 'Evento fechado.',
        canceled: 'Evento cancelado. Contagens pendentes sem atribuição removidas: {{count}}.',
        confirm_close: 'Fechar o evento? As diferenças ficam registradas; nesta fase o estoque não é ajustado.',
        confirm_cancel:
          'Cancelar o evento? Serão removidas apenas as contagens deste evento pendentes e sem atribuição; as atribuídas e as iniciadas continuam.',
      },
      differences: {
        shortages: 'Faltas',
        surpluses: 'Sobras',
        none: 'Sem diferenças.',
        owned: 'Próprio',
        watched: 'Acompanhado',
        no_declaration: 'Sem declaração',
        columns: {
          origin: 'Origem',
          location: 'Localização',
          product: 'Produto',
          lot: 'Lote',
          system: 'Sistema',
          counted: 'Contado',
          difference: 'Diferença',
          declared: 'Declarado',
          settlement: 'Situação',
          settled_at: 'Resolvido',
        },
        settlement: { unsettled: 'Pendente em Sobras', matched: 'Pareado', handed_off: 'Recebido', mixed: 'Pareado e recebido' },
        corrected: 'corrigido',
        totals:
          'Localizações contadas: {{counted}} · com diferenças: {{with_differences}} · faltam {{short_owned}} próprias + {{short_watched}} acompanhadas · sobram {{surplus_owned}} próprias + {{surplus_watched}} acompanhadas ({{declared}} declaradas, {{settled}} resolvidas)',
        view_in_found_stock: 'Ver em Sobras',
      },
      drift: {
        empty: 'Nenhuma localização nova corresponde aos filtros do evento.',
        not_open: 'A verificação de mudanças só se aplica a eventos abertos.',
        add_selected: 'Adicionar ao evento',
        added: 'Adicionadas {{added}} localizações ({{spawned}} contagens novas, {{watched}} acompanhadas, {{satisfied}} já cobertas).',
        has_active_count: 'já tem contagem ativa',
      },
      errors: {
        COVERAGE_EVENTS_DISABLED: 'Os eventos estão desativados neste armazém.',
        FULL_WAREHOUSE_EVENT_RESERVED: 'Escolha ao menos um filtro; o evento de armazém completo está reservado.',
        COVERAGE_EVENT_NOT_OPEN: 'O evento não está mais aberto. A tela foi atualizada.',
        COVERAGE_INCOMPLETE:
          'Cobertura incompleta: {{unassigned}} sem atribuição, {{assigned}} atribuídas, {{in_review}} em revisão, {{uncovered}} sem contagem.',
        LOCATIONS_NOT_ELIGIBLE: 'Alguma localização não é contável neste armazém.',
        FORBIDDEN: 'Você não tem acesso aos eventos deste armazém.',
        NOT_FOUND: 'O evento não existe.',
        STORE_NOT_FOUND: 'A loja selecionada não atende este armazém; recarregue os filtros.',
        UNEXPECTED: 'Ocorreu um erro inesperado.',
        COVERAGE_INCOMPLETE_GENERIC: 'Faltam localizações para cobrir.',
        COVERAGE_EVENT_NOT_RECONCILING: 'O evento não está em conciliação. A tela foi atualizada.',
        PROPOSAL_NOT_FROZEN: 'A proposta ainda está sendo calculada.',
        PROPOSAL_FINGERPRINT_MISMATCH: 'A proposta mudou. Revise a versão atual antes de aprovar.',
        MERCHANT_SIGNATURE_REQUIRED: 'Este evento exige a assinatura do cliente antes de executar.',
        EXECUTION_ALREADY_APPROVED: 'A execução já foi aprovada.',
        EXECUTION_IN_PROGRESS: 'A execução já está aprovada; o evento não pode ser cancelado.',
        MERCHANT_SIGNATURE_REQUIRED_FOR_STORE_WIDE: 'Um evento de toda a loja sempre exige a assinatura do cliente.',
        SETTLEMENT_AUTHORITY: 'Conciliar exige permissão de baixa para LOST neste armazém.',
        NOT_AWAITING_SIGNATURE: 'O evento não está aguardando a assinatura do cliente. A tela foi atualizada.',
        SIGNATURE_NOT_REQUIRED: 'Este evento não exige a assinatura do cliente.',
        ALREADY_SIGNED: 'O cliente já assinou este evento. A tela foi atualizada.',
        EVIDENCE_REQUIRED: 'Anexe ao menos um arquivo de evidência.',
        EVIDENCE_TOO_LARGE: 'Algum arquivo passa de 25 MB.',
        EVIDENCE_TYPE_NOT_ALLOWED: 'Somente imagens ou PDF são aceitos.',
        NOTE_REQUIRED: 'Escreva a nota: quem aprovou e por qual canal.',
      },
      reconciliation: {
        tab: 'Conciliação',
        unavailable: 'A conciliação não está disponível nesta versão do sistema.',
        state: {
          open: 'Aberto',
          computing: 'Calculando a proposta…',
          frozen: 'Proposta pronta para aprovar',
          pending_approval: 'Aguardando assinatura do cliente',
          signed: 'Assinado pelo cliente, pronto para aceitar',
          executing: 'Executando ajustes',
          settled: 'Conciliado',
          closed: 'Fechado sem conciliar',
          canceled: 'Cancelado',
        },
        kind: { write_off: 'Baixa para LOST', match: 'Emparelhar', handoff: 'Dar entrada', removal: 'Remover LOST' },
        outcome: { pending: 'Pendente', executed: 'Executado', partial: 'Parcial', skipped: 'Ignorado', blocked: 'Bloqueado' },
        columns: {
          location: 'Localização',
          kind: 'Ação',
          product: 'Produto',
          lot: 'Lote',
          existing: 'Existentes',
          planned: 'Planejado',
          since: 'Desde (aprox.)',
          executed: 'Executado',
          outcome: 'Resultado',
          reason: 'Motivo',
        },
        // W-7: `totals`/`progress` are count-aware via i18next's JSON v4 `_one`/`_other`
        // suffixes rather than a hardcoded plural noun — call i18n.t with `count` set to the
        // driving number (the kind's item rows for totals, the phase total for progress); the
        // adjectives lead the numbers so the `_one` variant stays grammatical.
        totals_one: '{{kind}}: planejadas {{planned}} · executadas {{executed}} · {{count}} linha',
        totals_other: '{{kind}}: planejadas {{planned}} · executadas {{executed}} · {{count}} linhas',
        progress_one: 'Fase {{phase}}: {{done}} de {{count}} ajuste',
        progress_other: 'Fase {{phase}}: {{done}} de {{count}} ajustes',
        computing_progress_one: 'Calculando: {{done}} de {{count}} localização',
        computing_progress_other: 'Calculando: {{done}} de {{count}} localizações',
        computing_error_hint: 'O cálculo parou; use Tentar o cálculo novamente.',
        finalizing: 'Encerrando o evento…',
        no_proposal: 'Este evento foi fechado sem proposta de conciliação.',
        stalled: 'A execução não avança desde {{since}}. Avise o suporte: o guia de recuperação retoma a fase pendente.',
        stalled_since_unknown: 'A execução não avança. Avise o suporte: o guia de recuperação retoma a fase pendente.',
        paused: 'Atualização pausada',
        outcome_unknown: 'Não foi possível confirmar o resultado da execução. Tente novamente para ler o estado real.',
        outcome_unknown_panel: 'Não foi possível confirmar o resultado da última execução. Abra a aba Conciliação para ler o estado real.',
        outcome_not_applied: 'A execução não havia sido aplicada; você pode aprovar novamente.',
        proposal_outdated: 'Esta página mostra uma proposta anterior. Atualize antes de aprovar.',
        loading: 'Carregando…',
        last_error_at: 'Último erro: {{date}}',
        phases: { write_off: 'Baixas', match: 'Emparelhamentos', handoff: 'Entradas', removal: 'Retiradas' },
        approve: 'Aprovar e executar',
        accept: 'Aceitar e executar',
        confirm_approve:
          'Aprovar esta proposta e executar os ajustes? Serão baixadas {{write_off}} peças, emparelhadas {{match}} e recebidas {{handoff}}. Não é possível desfazer.',
        confirm_blocked_one: '{{count}} peça bloqueada fica declarada em Sobras.',
        confirm_blocked_other: '{{count}} peças bloqueadas ficam declaradas em Sobras.',
        confirm_blocked_write_off_one: '{{count}} peça de baixa bloqueada (estoque movimentado após a contagem) não é ajustada.',
        confirm_blocked_write_off_other: '{{count}} peças de baixa bloqueadas (estoque movimentado após a contagem) não são ajustadas.',
        confirm_removal_one: 'Além disso, será retirada até {{count}} unidade LOST da loja neste armazém.',
        confirm_removal_other: 'Além disso, serão retiradas até {{count}} unidades LOST da loja neste armazém.',
        removal_missing: 'A proposta inclui uma retirada de LOST que esta tela não recebeu. Atualize antes de continuar.',
        approved: 'Execução aprovada. Os ajustes são aplicados em segundo plano.',
        reconcile: 'Conciliar',
        confirm_reconcile: 'Conciliar o evento? A proposta de ajustes será calculada a partir das diferenças próprias; nada é ajustado até a aprovação.',
        retry_reconcile: 'Tentar o cálculo novamente',
        confirm_retry_reconcile: 'Tentar novamente o cálculo da proposta? O evento continua em conciliação.',
        reconciling: 'Evento em conciliação. A proposta está sendo calculada.',
        signature_banner: 'Este evento exige a assinatura do cliente. Aguarde a assinatura no portal.',
        signature_banner_record: 'Este evento exige a assinatura do cliente. Aguarde a assinatura no portal ou registre-a aqui com a evidência.',
        rebaselined: 'A janela de acurácia da loja foi reiniciada com este fechamento.',
        blocked_hint: 'As linhas bloqueadas ficam declaradas em Sobras.',
        none: 'Sem diferenças próprias: não há ajustes a executar.',
        retry: 'Tentar novamente',
        view_declaration: 'Ver declaração',
        view_receipt: 'Ver recibo',
        unexecuted_hint: '{{count}} sem executar',
        reasons: {
          insufficient_candidates: 'Menos unidades elegíveis do que a falta (estoque movimentado após a contagem)',
          mid_picking: 'Reservas em picking, não são tocadas',
          container_bound: 'Peças em contêiner, não são tocadas',
          units_changed: 'As unidades mudaram depois de congelar a proposta',
          insufficient_lost_candidates: 'Não há perdidos elegíveis suficientes',
          bay_retired: 'Localização desativada',
          location_not_eligible_for_found_stock: 'A localização não aceita mais sobras',
          found_stock_disabled: 'Sobras desativado no armazém',
          replenishment_invoice_required: 'A loja fatura seus recibos; não é possível dar entrada',
          billing_config_missing: 'Falta o serviço de recepção na configuração de cobrança',
          unit_code_product: 'Produto com código de unidade',
          product_missing: 'O produto não existe mais',
          store_missing: 'A loja não existe mais',
          concurrent_modification: 'Modificação concorrente; tentado novamente e ignorado',
          no_lost_bay: 'O armazém não tem localização LOST',
          error: 'Erro inesperado',
          settlement_authority_lost: 'Quem aprovou perdeu a permissão de conciliação durante a execução',
          multiple_stores: 'Unidades de várias lojas',
        },
        blocked_reasons: {
          units_changed: 'Estoque movimentado após a contagem',
        },
        removal: {
          hint: 'Ao conciliar, todas as unidades LOST recuperáveis da loja neste armazém são retiradas: as mais antigas primeiro e nunca mais do que o planejado. A data é aproximada.',
          none: 'Não há unidades LOST a retirar.',
        },
        signature: {
          evidence_expired: 'Os links de evidência expiraram.',
          renew_links: 'Renovar links',
          banner_signed_portal: 'Assinado pelo cliente em {{date}} no portal ({{name}}).',
          banner_signed_staff: 'Assinatura do cliente registrada em {{date}} por {{name}}.',
          banner_signed: 'Assinado pelo cliente em {{date}} ({{name}}).',
          note: 'Nota: {{note}}',
          evidence: 'Evidência:',
          record_button: 'Registrar assinatura do cliente',
          dialog_title: 'Registrar a assinatura do cliente',
          dialog_body: 'Para marcas fora do portal: registre a aprovação recebida e anexe a evidência. A assinatura fica vinculada à proposta como exibida.',
          may_refuse: 'Se o estoque se mover depois da assinatura, algum ajuste pode ser recusado na execução.',
          note_label: 'Nota: quem aprovou e por qual canal',
          note_placeholder: 'Ex.: aprovado por Ana Gil (Dublinense) por e-mail em 22/09',
          evidence_label: 'Evidência (imagem ou PDF, até 25 MB por arquivo)',
          evidence_hint: 'Anexe ao menos um arquivo.',
          evidence_invalid_type: '{{name}}: somente imagens ou PDF.',
          evidence_too_large: '{{name}}: passa de 25 MB.',
          submit: 'Registrar assinatura',
          cancel: 'Cancelar',
          close: 'Fechar',
          recorded: 'Assinatura registrada. Você já pode aceitar e executar a proposta.',
        },
      },
      pool: {
        capped: 'Exibindo {{shown}} de {{total}} localizações. A atribuição incluirá todas as do grupo.',
        assigning_chunks: 'Atribuindo {{done}} de {{total}} contagens…',
        unassigning_chunks: 'Desatribuindo {{done}} de {{total}} contagens…',
        scope: 'Serão atribuídas todas as contagens sem responsável do armazém: {{count}} contagens.',
        unassign_scope: 'Serão removidas todas as contagens sem atribuição do armazém: {{count}} contagens.',
        partial: 'Atribuídas {{done}} de {{total}} contagens antes do erro.',
        unassign_partial: 'Desatribuídas {{done}} de {{total}} contagens antes do erro.',
        fallback: 'Esta versão atribui apenas as {{count}} localizações listadas.',
        unassign_fallback: 'Esta versão desatribui apenas as {{count}} localizações listadas.',
        resolving: 'Calculando o tamanho da bolsa…',
        mixed_selection: 'Selecione apenas a bolsa sem atribuição para agir sobre todas as suas localizações.',
      },
    },
  },
  found_stock: {
    title: 'Sobras',
    subtitle: 'Peças encontradas pendentes de liquidação',
    refresh: 'Atualizar',
    open_by_id_label: 'Abrir declaração #',
    open_by_id_button: 'Abrir',
    dialog_product_label: 'Produto',
    dialog_close: 'Fechar',
    tabs: {
      queue: 'Sobras',
      awaiting: 'Pendentes de armazenagem',
    },
    queue: {
      declaration: 'Declaração',
      product: 'Produto',
      lot: 'Lote',
      location: 'Localização',
      quantity: 'Quantidade',
      declared_quantity_one: 'declarada: {{count}}',
      declared_quantity_other: 'declaradas: {{count}}',
      declared_by: 'Declarado por',
      source: 'Origem',
      candidates: 'Perdidos elegíveis',
      actions: 'Ações',
      cycle_count: 'Contagem #{{id}}',
      lot_value: 'Lote #{{id}}',
      lot_expires: 'Vence {{date}}',
      no_lot: 'Sem lote',
      product_fallback: 'Produto #{{id}}',
      empty_table: 'Sem sobras pendentes.',
      load_error: 'Não foi possível carregar as sobras. Tente novamente mais tarde.',
      forbidden: 'Você não tem acesso às sobras deste armazém.',
      match_button: 'Emparelhar',
      inbound_button: 'Receber',
      correct_button: 'Corrigir',
      match_disabled_hint: 'Sem perdidos elegíveis; use Receber.',
      retry: 'Tentar novamente',
      highlight_notice: 'Destacando as sobras da contagem #{{id}}',
      highlight_clear: 'Remover destaque',
      filters: {
        location: 'Localização',
        declaration: 'Nº da declaração',
        product: 'ID do produto',
      },
    },
    source: {
      AD_HOC: 'Manual',
      CYCLE_COUNT: 'Contagem',
    },
    awaiting: {
      location: 'Localização',
      product: 'Produto',
      lot: 'Lote',
      status: 'Status',
      status_ACTIVE: 'À venda',
      status_HOLDED: 'Pausadas',
      status_FOUND: 'Sobras',
      quantity: 'Quantidade',
      empty_table: 'Não há peças pendentes de armazenagem.',
      load_error: 'Não foi possível carregar a lista. Tente novamente mais tarde.',
      hint: 'Estas peças já foram liquidadas e saem da localização FOUND com uma transferência pelo handheld.',
    },
    match_dialog: {
      title: 'Emparelhar com perdidos',
      summary: 'Declaração #{{id}} em {{location}}: {{quantity}} peças pendentes, {{candidates}} perdidos elegíveis.',
      quantity_label: 'Peças a emparelhar',
      explanation: 'Cada peça recupera uma unidade perdida do mesmo produto e lote; a peça excedente é retirada.',
      confirm: 'Emparelhar',
      cancel: 'Cancelar',
      success_one: '{{count}} peça perdida foi recuperada.',
      success_other: '{{count}} peças perdidas foram recuperadas.',
      replayed: 'Estas peças já estavam liquidadas; a lista foi atualizada.',
      replayed_units_one: 'Estas peças já estavam liquidadas: {{count}} retirada, {{recovered}} perdidas recuperadas.',
      replayed_units_other: 'Estas peças já estavam liquidadas: {{count}} retiradas, {{recovered}} perdidas recuperadas.',
    },
    inbound_dialog: {
      title: 'Receber como recebimento',
      summary: 'Declaração #{{id}} em {{location}}: {{quantity}} peças.',
      consequence: 'Será criado um recebimento concluído em nome da loja, a recepção será cobrada e a loja receberá o e-mail de recebimento concluído.',
      found_bay_note:
        'Se a localização for do tipo FOUND, as peças permanecem ali até que o handheld as transfira para uma prateleira; em uma prateleira ficam vendáveis de imediato.',
      confirm: 'Receber',
      cancel: 'Cancelar',
      success_one: 'Recebimento #{{replenishment_id}} criado com {{count}} peça.',
      success_other: 'Recebimento #{{replenishment_id}} criado com {{count}} peças.',
      replayed: 'Estas peças já estavam liquidadas; a lista foi atualizada.',
      replayed_receipt_one: 'Recebimento #{{replenishment_id}} já registrado com {{count}} peça.',
      replayed_receipt_other: 'Recebimento #{{replenishment_id}} já registrado com {{count}} peças.',
    },
    correct_dialog: {
      title: 'Corrigir quantidade declarada',
      summary: 'Declaração #{{id}} em {{location}}: {{quantity}} peças pendentes.',
      quantity_label: 'Quantidade correta',
      quantity_hint: 'Entre 0 e 1000. Zero retira toda a declaração.',
      reason_label: 'Motivo',
      reason_hint: 'Obrigatório, máximo de 500 caracteres. Fica em auditoria e não é exibido na tela.',
      reason_counter: '{{count}}/500',
      confirm: 'Corrigir',
      cancel: 'Cancelar',
      success: 'Quantidade corrigida de {{before}} para {{after}}.',
      replayed: 'Quantidade corrigida de {{before}} para {{after}} (já registrada).',
      validation_quantity: 'Informe uma quantidade inteira entre 0 e 1000.',
    },
    detail: {
      title: 'Detalhe da sobra',
      declaration: 'Declaração',
      product: 'Produto',
      lot: 'Lote',
      location: 'Localização',
      source: 'Origem',
      declared_by: 'Declarado por',
      declared_quantity: 'Quantidade declarada',
      effective_quantity: 'Quantidade vigente',
      live_quantity: 'Pendentes agora',
      units_title: 'Peças por resultado',
      show_ids: 'Ver IDs',
      hide_ids: 'Ocultar IDs',
      corrections_title: 'Correções',
      corrections_empty: 'Sem correções.',
      correction_when: 'Data',
      correction_change: 'Alteração',
      correction_by: 'Usuário',
      correction_units: 'Peças',
      correction_added_one: '+{{count}} adicionada',
      correction_added_other: '+{{count}} adicionadas',
      correction_retired_one: '−{{count}} retirada',
      correction_retired_other: '−{{count}} retiradas',
      legs_title: 'Movimentos',
      legs_empty: 'Sem movimentos.',
      leg_when: 'Data',
      leg_action: 'Ação',
      leg_location: 'Localização',
      leg_change: 'Quantidade',
      leg_by: 'Usuário',
      location_fallback: 'Localização #{{id}}',
      user_fallback: 'Usuário #{{id}}',
      load_error: 'Não foi possível carregar o detalhe.',
    },
    buckets: {
      found: 'Pendentes',
      retired: 'Retiradas por emparelhamento',
      corrected_out: 'Retiradas por correção',
      converted: 'Recebidas como recebimento',
      recovered: 'Perdidas recuperadas',
    },
    gate: {
      banner_title: 'Sobras está desativado neste armazém.',
      banner_body: 'Liquidações e correções não estão disponíveis até que a Cubbo o habilite.',
    },
    errors: {
      UNAUTHORIZED: 'Você não tem autorização para liquidar sobras.',
      UNKNOWN: 'Não foi possível concluir a operação ({{code}}).',
      NETWORK: 'Não foi possível concluir a operação (NETWORK).',
      FOUND_STOCK_DISABLED: 'Sobras está desativado neste armazém.',
      UNITS_ALREADY_SETTLED: 'A página estava desatualizada: algumas peças já foram liquidadas.',
      UNITS_NOT_FOUND_STOCK: 'As peças selecionadas já não são sobras deste armazém.',
      UNITS_OUTSIDE_WAREHOUSE: 'As peças selecionadas já não são sobras deste armazém.',
      CONCURRENT_MODIFICATION: 'Outra operação moveu estas peças; tente novamente.',
      INSUFFICIENT_LOST_CANDIDATES:
        'Há apenas {{available}} perdidos elegíveis para {{requested}} peças. Você pode emparelhar menos ou recebê-las como recebimento.',
      TOO_MANY_DECLARATIONS: 'Solicitação inválida (TOO_MANY_DECLARATIONS).',
      TOO_MANY_UNITS: 'Solicitação inválida (TOO_MANY_UNITS).',
      QUANTITY_INVALID: 'Solicitação inválida (QUANTITY_INVALID).',
      INVALID_PARAMETER: 'Solicitação inválida (INVALID_PARAMETER).',
      MULTIPLE_STORES: 'As peças pertencem a mais de uma loja; receba-as separadamente.',
      STORE_NOT_FOUND: 'A loja destas peças não foi encontrada.',
      BILLING_CONFIG_MISSING: 'A loja não tem serviço de recebimento vigente; configure o faturamento antes de receber.',
      DECLARATION_SETTLED: 'A declaração já foi liquidada; não admite correções.',
      DECLARATION_INCONSISTENT: 'A declaração é inconsistente; escale para a engenharia.',
      DECLARATION_NOT_FOUND: 'A declaração não existe mais.',
      PRODUCT_NOT_FOUND: 'O produto não existe mais ou virou produto pai.',
      LOCATION_NOT_ELIGIBLE_FOR_FOUND_STOCK: 'A localização mudou de tipo e já não admite sobras.',
      IDEMPOTENCY_CONFLICT: 'Esta solicitação já foi enviada com outros valores. Tente novamente.',
      UNIT_CODE_PRODUCTS_NOT_SUPPORTED: 'Produtos com código de unidade não suportados: {{product_ids}}.',
      REPLENISHMENT_INVOICE_REQUIRED:
        'Os recebimentos desta loja têm nota fiscal; o excedente não pode ser recebido. Faça o pareamento com uma falta ou deixe-o declarado.',
      INTERNAL_ERROR: 'Erro interno do servidor; tente novamente.',
      DECLARATION_IN_FROZEN_PROPOSAL: 'A declaração está em uma proposta de conciliação congelada (evento #{{id}}).',
    },
    frozen_proposal: {
      view_event: 'Ver evento',
    },
  },
  packing_camera_notifications: {
    upload_failed_title: 'Erro ao salvar a gravação',
    upload_failed_description: 'Não foi possível enviar o vídeo do empacotamento. Reporte este pedido ao seu supervisor.',
    chunk_failed_title: 'Problema ao enviar o vídeo',
    chunk_failed_description: 'Foi detectada uma falha intermitente ao enviar parte do vídeo. Verifique sua conexão.',
  },
  reassign_carrier: {
    scanner: {
      label: 'Número da guia',
      hint: 'Escaneie ou cole a guia e pressione Enter',
      placeholder: 'Escaneie ou digite uma guia',
      counter: '{{count}} / {{max}} guias',
      empty_state: 'As guias escaneadas aparecerão aqui.',
      limit_reached_title: 'Limite de {{max}} guias atingido',
      limit_reached_description: 'Você só pode escanear até {{max}} guias por reatribuição. Processe estas e crie uma nova reatribuição para continuar.',
      limit_reached_advice: 'Reatribua estas {{max}} guias para Uber e crie uma nova reatribuição para continuar com as próximas.',
      duplicate_title: 'Guia já escaneada',
      duplicate_description: 'A guia {{label}} já está na lista.',
      remove_label: 'Remover guia {{label}}',
    },
    bulk_error_title: 'Erro ao reatribuir',
    bulk_error_description: 'Não foi possível reatribuir as guias para Uber. Tente novamente.',
    error_cross_warehouse_labels: 'Guias de outros armazéns: {{labels}}',
    error_not_found_labels: 'Guias não encontradas: {{labels}}',
    created_batches_label: 'Lotes criados:',
    failed_labels_header: 'Guias com falha',
    retry_failed_labels: 'Tentar novamente guias com falha',
    error_column: 'Erro',
    shipping_number_column: 'N° da guia',
    batch_label_input: 'Rótulo do lote (opcional)',
    batch_label_placeholder: 'Ex. MORNING-DRIVER-A',
    batch_label_hint_auto: 'Será gerado automaticamente',
    batch_label_hint_will_add: 'Será adicionado ao lote existente {{label}} (já tem {{count}} entregas)',
    batch_label_hint_submitted: 'O lote {{label}} já foi enviado para a Uber. Escolha outro nome.',
    batch_label_hint_will_create: 'Será criado um novo lote {{label}}',
  },
  uber_batches: {
    list_title: 'Lotes Uber',
    empty_table: 'Nenhum lote Uber para exibir.',
    status: {
      pending: 'Pendente de agrupamento',
      submitted: 'Enviado para Uber',
      route_planned: 'Rota planejada',
      failed: 'Falhou',
    },
    headers: {
      id: 'ID',
      warehouse: 'Almoxarifado',
      status: 'Status',
      internal_label: 'Etiqueta interna',
      dispatch_window: 'Janela de despacho',
      deliveries_count: 'Entregas',
      submitted_at: 'Enviado em',
      failed_at: 'Falhou em',
      actions: 'Ações',
    },
    filters: {
      status: 'Status',
      all_statuses: 'Todos os status',
      created_at: 'Criado entre',
      reset: 'Limpar filtros',
    },
    actions: {
      view: 'Ver',
      reload: 'Recarregar',
      submit_pending: 'Enviar pendentes agora',
      submit_pending_success_title: 'Lotes enviados',
      submit_pending_success_description: '{{count}} lote(s) pendente(s) enviado(s) para Uber.',
      retry: 'Tentar novamente',
      retry_success_title: 'Lote reiniciado',
      retry_success_description: 'O lote voltou a pendente; será enviado na próxima janela de despacho ou com "Enviar pendentes agora".',
    },
    errors: {
      no_access: 'Você não tem acesso a esta seção.',
      fetch_error: 'Erro ao carregar os lotes Uber.',
      submit_error_title: 'Erro ao enviar lotes',
      submit_error: 'Não foi possível enviar os lotes pendentes. Tente novamente.',
      retry_error_title: 'Erro ao tentar novamente',
      retry_error: 'Não foi possível tentar novamente o lote. Tente novamente.',
    },
    detail: {
      title: 'Lote Uber #{{id}}',
      back: 'Voltar',
      not_found: 'Lote não encontrado.',
      fields: {
        id: 'ID',
        status: 'Status',
        warehouse: 'Almoxarifado',
        dispatch_window_start: 'Início da janela',
        dispatch_window_end: 'Fim da janela',
        submitted_at: 'Enviado em',
        failed_at: 'Falhou em',
        deliveries_count: 'Entregas',
        failure_reason: 'Motivo da falha',
        internal_label: 'Etiqueta interna',
        uber_batch_id: 'ID do lote Uber',
        last_webhook_at: 'Último webhook',
      },
      deliveries: {
        title: 'Entregas',
        empty: 'Este lote não possui entregas.',
        uber_delivery_id: 'ID de entrega Uber',
        shipping_number: 'Número da guia',
        recipient: 'Destinatário',
        shipping_city: 'Cidade',
        status: 'Status',
        return_pin_code: 'PIN de devolução',
        failed_reason: 'Motivo da falha',
        actions: 'Ações',
        view_order: 'Ver pedido',
      },
    },
  },
  coberturas: {
    createCoverages: {
      title: 'Criar coberturas — {{method}}',
      button: 'Criar coberturas',
      validate: 'Validar',
      create: 'Criar',
      coverageCount: '{{count}} coberturas no lote',
      addRow: 'Adicionar linha',
      queuedRows: '{{count}} linhas na fila',
      advancedFields: 'Campos avançados',
      status: {
        readyToCreate: '· Validado — pronto para criar',
        validateFirst: '· Valide para habilitar Criar',
        fixErrors: '· Corrija as linhas marcadas e valide novamente',
      },
      modes: {
        single: 'Linha única',
        csv: 'Colar CSV',
        range: 'Faixa de CEP',
      },
      fields: {
        value: 'CEP',
        zone: 'Zona',
        zoneSuggestions: 'Zonas existentes',
        start: 'Início da faixa',
        end: 'Fim da faixa',
        status: 'Estado',
        cost: 'Custo de envio (por zona)',
        extended_zone: 'Zona estendida',
        po_box_dropoff: 'Entrega em filial',
        delivery_sla_in_hours: 'SLA de entrega',
        delivery_sla_offset: 'SLA offset',
        eta_offset: 'ETA offset',
        content_value_fee: 'Tarifa de seguro',
        fee_offset: 'Fee offset',
      },
      see_more: 'Ver mais',
      see_less: 'Ver menos',
      status_active: 'Ativa',
      status_disabled: 'Desativada',
      units: {
        hours: 'horas',
        percent: '%',
      },
      fieldHelp: {
        cost: 'Custo base de envio para esta zona. Se a zona já tiver custo, deixe vazio.',
        cost_existing: 'Esta zona já tem um custo configurado.',
        cost_set: 'Esta zona ainda não tem custo; defina-o aqui.',
        delivery_sla_in_hours: 'Compromisso da transportadora para entregar.',
        delivery_sla_offset: 'Horas somadas à data de entrega prometida.',
        eta_offset: 'Horas somadas ao tempo estimado de chegada.',
        content_value_fee: 'Porcentagem cobrada sobre o total do pedido.',
        fee_offset: 'Valor fixo somado à tarifa do envio.',
      },
      fieldTip: {
        cost: 'Custo de envio aplicado a toda a zona (não por CEP). Se a zona já tiver um custo configurado, deixe vazio para não duplicar.',
        po_box_dropoff:
          'Se a transportadora não conseguir entregar no CEP de destino, o pacote é entregue na filial da transportadora mais próxima do endereço.',
        content_value_fee:
          'Porcentagem extra cobrada sobre o total do pedido (produtos + envio + cobranças extra − descontos). Por exemplo, 1% sobre um pedido de $1.000 soma $10 ao custo de envio.',
      },
      csv: {
        help: "Cole um CSV com cabeçalho seguindo o modelo. A primeira coluna deve ser 'value' e a segunda 'zone'.",
        template: 'Baixar modelo CSV',
        parse: 'Processar CSV',
        parseErrors: '{{count}} erro(s) de leitura — corrija as linhas indicadas e tente de novo',
        parseErrorLine: 'linha {{line}}: {{message}}',
        parseErrorsMore: '…e mais {{count}} erro(s).',
        needsHeaderAndRow: 'O CSV precisa de uma linha de cabeçalho e ao menos uma linha de dados',
        missingRequiredFields: "Campos obrigatórios 'value' ou 'zone' ausentes",
        preview: 'Prévia ({{shown}} de {{total}} linhas)',
      },
      range: {
        preview: '{{count}} CEPs serão adicionados',
        expand: 'Expandir para o rascunho',
        error: {
          'same-length-digits': 'Início e fim da faixa devem ser numéricos e ter o mesmo comprimento',
          'start-after-end': 'O início da faixa não pode ser maior que o fim',
          'too-large': 'Tamanho da faixa ({{count}}) excede o limite de {{max}} — estreite a faixa',
        },
      },
      preview: {
        clean: 'OK',
        fix: 'corrigir',
        remove: 'Remover',
        errorsColumn: 'Erros',
        prereqsBanner: 'Pré-requisitos com erro — remova os itens com falha ou abra o painel para corrigi-los',
        removeBinding: 'Remover do rascunho',
        removeCost: 'Remover do rascunho',
      },
      bindXdock: {
        title: "Vincular '{{zone}}' a um xdock",
        help: "A zona '{{zone}}' não está vinculada a nenhum xdock em {{country}}. Selecione um xdock abaixo; ele será incluído neste lote e gravado junto com as coberturas.",
        existingZones: 'Já atende',
        alreadyQueued: 'Já incluído para os xdocks {{xdocks}}',
        add: 'Adicionar ao lote',
      },
      configureCost: {
        title: "Configurar custo de frete para '{{zone}}'",
        help: 'Não existe linha de shipping_cost para esta zona neste método. Defina o preço abaixo; ela será criada junto com as coberturas.',
        cost: 'Custo',
        maxWeight: 'Peso composto máximo (kg)',
        currency: 'Código de moeda',
        alreadyQueued: 'Já incluído: {{cost}} {{currency}}',
        add: 'Adicionar ao lote',
      },
      errors: {
        INVALID_VALUE: 'Valor inválido',
        DUPLICATE_VALUE_IN_PAYLOAD: 'Duplicado no lote',
        COVERAGE_ALREADY_EXISTS: 'Já existe (id {{id}})',
        ZONE_HAS_NO_XDOCK: 'Sem xdock para esta zona',
        ZONE_HAS_NO_SHIPPING_COST: 'Sem shipping cost para esta zona',
      },
      prereqErrors: {
        XDOCK_NOT_FOUND: 'Xdock não encontrado',
        XDOCK_COUNTRY_MISMATCH: 'O xdock está em um país diferente',
        INVALID_ZONE_NAMES: 'Nomes de zona inválidos',
        ZONE_BOUND_TO_OTHER_XDOCK: 'Zona já vinculada a outro xdock',
        SHIPPING_COST_ALREADY_EXISTS: 'Já existe um custo para esta zona',
        SHIPPING_COST_DUPLICATE_IN_PAYLOAD: 'Custo duplicado neste lote',
        INVALID_SHIPPING_COST: 'Valor de custo inválido',
        xdockPrefix: 'Xdock #{{id}}',
        costPrefix: 'Custo para {{zone}}',
      },
      progress: {
        title: 'Criando coberturas',
        processing: 'Criando coberturas…',
        processingHint: 'Isso pode levar alguns segundos.',
        successTitle: 'Coberturas criadas',
        successBody: '{{coverages}} coberturas criadas',
        successExtra: ', {{costs}} custos de frete e {{zones}} zonas xdock',
        partialTitle: 'Criação com omissões',
        partialBody: '{{created}} de {{attempted}} coberturas criadas; {{skipped}} ignoradas.',
        failedTitle: 'Erro na criação',
        failedBody: 'O trabalho não pôde ser concluído. Corrija os erros e tente novamente.',
        failedRowErrors: 'Algumas linhas não passaram na validação.',
        submittedTitle: 'Alterações enviadas',
        submittedBody: 'Suas alterações foram enviadas. Se não as vir de imediato, aparecerão em alguns segundos.',
        reload: 'Recarregar página',
        hide: 'Ocultar',
      },
    },
    jobProgress: {
      title: 'Progresso do trabalho',
      processing: 'Processando…',
      processingHint: 'Isso pode levar alguns segundos.',
      successCreate: '{{coverages}} coberturas criadas',
      successCreateExtra: ', {{costs}} custos de frete e {{zones}} zonas xdock',
      partialCreate: '{{created}} de {{attempted}} coberturas criadas; {{skipped}} ignoradas.',
      successUpdate: '{{rows}} coberturas atualizadas',
      partialUpdate: '{{updated}} atualizadas, {{failed}} com falha ({{rows}} linhas modificadas).',
      successCosts: '{{succeeded}} tarifas processadas com sucesso',
      partialCosts: '{{succeeded}} de {{attempted}} tarifas processadas; {{failed}} com erro.',
      successTitle: 'Concluído',
      partialTitle: 'Concluído com algumas omissões',
      failedTitle: 'Erro no trabalho',
      failedBody: 'O trabalho não pôde ser concluído. Verifique e tente novamente.',
      failedRowErrors: 'Algumas linhas não passaram na validação.',
      submittedTitle: 'Alterações enviadas',
      submittedBody: 'Suas alterações foram enviadas. Se não as vir de imediato, aparecerão em alguns segundos.',
      unavailableTitle: 'Status indisponível',
      unavailableBody: 'Não foi possível confirmar o resultado da alteração. Verifique as tarifas da zona para confirmar se foi aplicada.',
      interruptedTitle: 'Alteração interrompida',
      interruptedBody:
        'O trabalho parou antes de terminar, então parte das coberturas pode já ter sido alterada e parte não. Confira a lista e reenvie se precisar.',
      reload: 'Recarregar página',
      hide: 'Ocultar',
      close: 'Fechar',
    },
  },
  login: {
    invalid_credentials: 'usuário/senha inválidos',
    // The API answers USER_DISABLED only after Auth0 verified the password, so
    // this is never shown to someone who simply mistyped it.
    account_disabled: 'Esta conta foi desativada. Entre em contato com um administrador para reativá-la.',
    sso_failed: 'Não foi possível entrar com o Google. Tente novamente.',
    sso_no_account:
      'Sua conta do Google é válida, mas não existe um usuário com esse endereço. Fale com um administrador; seu usuário pode usar outro endereço.',
    too_many_attempts: 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
  },
  handheld_link: {
    title: 'Vincular HandHeld',
    lead_title: 'Vincule seu HandHeld',
    intro: 'Associe um dispositivo HandHeld à sua conta para começar a usá-lo com suas permissões.',
    step1_title: '1. Digite o código do dispositivo',
    code_label: 'Código do dispositivo',
    code_placeholder: 'XXXX-XXXX',
    code_hint: 'Ele aparece na tela do HandHeld que você quer vincular.',
    lookup_button: 'Buscar',
    lookup_loading: 'Buscando...',
    step2_title: '2. Confirme a vinculação',
    device_label: 'Dispositivo',
    requested_at: 'Solicitado',
    link_to_account: 'Será vinculado à conta de',
    link_button: 'Vincular à minha conta',
    link_loading: 'Vinculando...',
    search_another: 'Usar outro código',
    success: 'HandHeld vinculado — volte ao dispositivo.',
    success_title: 'HandHeld vinculado',
    success_description: 'Volte ao dispositivo HandHeld: ele já está pronto para uso com sua conta.',
    link_another: 'Vincular outro dispositivo',
    go_to_wms: 'Ir para o WMS',
    errors: {
      not_found: 'Código não encontrado ou expirado.',
      not_found_hint: 'Verifique se o código está correto ou gere um novo no dispositivo e tente novamente.',
      sso_required: 'Você só pode vincular um HandHeld a partir de uma sessão iniciada com SSO.',
      sso_required_hint: 'Saia e entre novamente com sua conta Google da Cubbo, depois tente outra vez.',
      identity_mismatch: 'Este código foi solicitado por outra conta',
      identity_mismatch_hint: 'Peça à pessoa que solicitou o código para fazer login aqui com a própria conta.',
      identity_unbound: 'Este código não indica quem o pediu',
      identity_unbound_hint: 'No HandHeld, peça o código novamente fazendo login com o seu e-mail. Se continuar, feche e abra o app para que ele se atualize.',
      generic: 'Ocorreu um erro. Tente novamente.',
    },
  },

  c2c_receiving: {
    title: 'Cubbitos',
    subtitle: 'Recebimento e etiqueta de pacotes C2C',
    loading: 'Carregando…',
    outcome: {
      pending: 'Em andamento',
      printed: 'Etiqueta impressa',
      label_unprinted: 'Etiqueta gerada, não impressa',
      label_replayed: 'Etiqueta existente — reimpressa',
      label_failed: 'Não foi possível gerar a etiqueta',
    },
    scan: {
      placeholder: 'Escaneie o código do rolo (CBT…)',
      read_only: 'Seu usuário pode ver a fila, mas não receber nem imprimir.',
      status: {
        idle: 'Pronto para escanear',
        scanning: 'Recebendo…',
        labeling: 'Gerando etiqueta…',
        printing: 'Imprimindo…',
        done: 'Pronto. Escaneie o próximo pacote',
      },
      scan_replayed: 'Já estava recebido',
      fields: {
        roll_code: 'Rolo',
        order_number: 'Pedido',
        arrived_at: 'Chegada',
        shipping_number: 'Etiqueta',
        tracking: 'Ver rastreio',
        no_file: 'Etiqueta sem arquivo',
        open_label: 'Abrir etiqueta',
      },
      actions: {
        reprint: 'Reimprimir',
        retry_label: 'Tentar etiqueta novamente',
        cancel: 'Cancelar e liberar a estação',
      },
      cancelled: 'Estação liberada. Se a etiqueta foi gerada, aparecerá em Processados com «Gerar etiqueta».',
      print_fallback: 'Não foi possível imprimir diretamente; a etiqueta foi aberta em outra aba.',
      print_blocked: 'O navegador bloqueou a janela de impressão; abra a etiqueta pelo link.',
      dismiss: 'Fechar',
      no_result: 'Escaneie um pacote para ver seus dados aqui.',
    },
    queue: {
      title: 'Pacotes recebidos sem etiqueta',
      search_placeholder: 'Rolo, número do pedido ou destinatário',
      refresh: 'Atualizar',
      empty: 'Não há pacotes aguardando etiqueta',
      fetch_error: 'Não foi possível carregar a fila.',
      retry: 'Tentar novamente',
      truncated: 'Mostrando {{shown}} de {{total}}. Busque para restringir a lista.',
      forbidden: 'Sem acesso a este armazém.',
      forbidden_hint: 'Se você acabou de receber acesso, tente novamente ou selecione o armazém de novo.',
      headers: {
        arrived_at: 'Chegada',
        roll_code: 'Rolo',
        order_number: 'Pedido',
        receiver: 'Destinatário',
        destination: 'Ponto de destino',
        carrier: 'Transportadora',
        label: 'Etiqueta',
        actions: 'Ação',
      },
      label_state: {
        pending: 'Pendente',
        existing: 'Existente',
      },
      generate_label: 'Gerar e imprimir etiqueta',
    },
    processed: {
      title: 'Processados nesta sessão',
      reprint: 'Reimprimir',
      generate_label: 'Gerar etiqueta',
    },
    notifications: {
      forbidden_action: 'Sem permissão para receber neste armazém',
    },
    errors: {
      generic: 'Ocorreu um erro inesperado.',
      network: 'Sem conexão com a plataforma. Verifique a rede e tente novamente.',
      forbidden: 'Sem permissão para receber neste armazém.',
      timeout: 'A plataforma demorou demais para responder. Se o pacote já tem etiqueta, use Reimprimir; senão, escaneie novamente.',
      INVALID_PARAMS: 'Código vazio ou inválido.',
      ROLL_CODE_NOT_FOUND: 'Código de rolo não reconhecido.',
      NOT_FOUND: 'Rolo ou pedido não encontrado neste armazém.',
      WRONG_WAREHOUSE: 'Este pacote não é recebido neste armazém.',
      NOT_RECEIVABLE: 'O pedido não está em um estado que permita recebê-lo (já enviado ou cancelado).',
      NOT_LABELABLE: 'O pedido não permite mais gerar etiqueta (outro operador a gerou?).',
      LABEL_GENERATION_FAILED: 'A transportadora não conseguiu gerar a etiqueta',
      LABEL_GENERATION_IN_PROGRESS: 'Outro operador está gerando esta etiqueta; tente novamente em alguns segundos.',
      CUBBITO_RETURN_NOT_C2C: 'É uma devolução: escaneie-a em Retornos.',
    },
  },

  crash: {
    title: 'Algo deu errado',
    description: 'A tela não pôde ser carregada. A equipe já foi avisada; recarregue para continuar.',
    reload: 'Recarregar',
    go_home: 'Voltar ao início',
  },
  fulfillment_errors: {
    error_codes: {
      INVOICE_NFSE_REJECTED: 'A prefeitura recusou a NFS-e',
      CARRIER_ACCOUNT_SUSPENDED: 'A transportadora suspendeu a conta por faturas vencidas',
      INVOICE_ISSUER_LOCKED: 'O emissor bloqueou o pedido e escondeu o motivo real',
      MARKETPLACE_INVOICE_NOT_RECEIVED: 'A nota fiscal não chegou ao marketplace',
      MARKETPLACE_ORDER_CANCELLED: 'O marketplace cancelou este pedido: não haverá etiqueta',
      SHIPPING_ADDRESS_INVALID: 'A transportadora recusou o endereço como está escrito',
      CARRIER_ORDER_RESTRICTION: 'A transportadora recusou este envio por uma restrição dela',
      CARRIER_SERVICE_UNAVAILABLE: 'A transportadora não ofereceu serviço para este destino',
      CARRIER_WAYBILL_STOCK_DEPLETED: 'A transportadora ficou sem numeração de guias',
      CLICK_AND_COLLECT_CARRIER_MISMATCH: 'O ponto de retirada é de outra transportadora',
      INVALID_PARAMETER: 'A tela enviou um dado inválido. Recarregue',
      INVOICE_FILE_UNAVAILABLE: 'Não foi possível baixar o arquivo da nota fiscal',
      INVOICE_FISCAL_CONFIGURATION_MISSING: 'Falta configuração fiscal do produto ou da loja',
      INVOICE_RATE_LIMITED: 'O emissor de notas está sobrecarregado e recusou esta',
      INVOICE_SERVICE_PARAMETER_INVALID: 'A NFS-e está com a configuração da loja errada',
      INVOICE_TAX_PARAMETER_INVALID: 'A classificação tributária do produto não corresponde ao seu NCM',
      ORDER_IN_REVIEW: 'Este pedido está em revisão e não pode ser empacotado',
      ORDER_MISSING_STOCK: 'Falta estoque atribuído a este pedido',
      PACKAGES_DO_NOT_MATCH_BOXES: 'As embalagens enviadas não são as das caixas deste pedido',
      PACKING_INCOMPLETE: 'Sobraram peças sem empacotar ou alguma caixa sem fechar',
      PROVIDER_TIMEOUT: 'O provedor não respondeu a tempo',
      SHIPPING_COST_UNAVAILABLE: 'A transportadora não tem tarifa ativa para o peso deste pedido',
      SHIPPING_METHOD_NOT_CONFIGURED: 'O pedido é nacional mas tem um método de envio internacional',
      T1_ADDRESS_UPDATE_FAILED: 'Não foi possível atualizar o endereço junto à transportadora',
      UNIT_CODE_VALIDATION_FAILED: 'Algum código de unidade bipado não corresponde a este pedido',
      CARRIER_API_ERROR: 'Erro temporário da transportadora. Tente novamente em alguns momentos',
      CARRIER_CIRCUIT_OPEN: 'A transportadora está fora do ar; paramos de chamá-la por um minuto. Reabre sozinha',
      CARRIER_TEMPORARY_FAILURE: 'A transportadora não respondeu por uma falha passageira. Aguarde o contador e tente de novo',
      CARRIER_NO_COVERAGE: 'A transportadora não atende esta região',
      CARRIER_ORIGIN_NOT_COVERED: 'A transportadora não atende este destino a partir deste armazém',
      DESTINATION_ADDRESS_INVALID: 'A transportadora recusou o destino: o CEP não existe',
      CARRIER_LABEL_GENERATION_FAILED: 'Não foi possível gerar a etiqueta de envio',
      CARRIER_PDF_GENERATION_FAILED: 'Não foi possível gerar o PDF da etiqueta',
      CARRIER_UNSUPPORTED: 'Transportadora não suportada para este pedido',
      INVOICE_CONTINGENCY: 'A nota fiscal foi gerada em modo contingência',
      INVOICE_PROCESSING: 'A nota fiscal está em processamento. Tente novamente em alguns minutos',
      INVOICE_ATTACHMENT_CORRUPT: 'Os arquivos da nota fiscal estão danificados',
      INVOICE_REJECTED: 'A nota fiscal foi rejeitada por dados fiscais incorretos',
      INVOICE_CERTIFICATE_EXPIRED: 'O certificado fiscal da loja está vencido',
      INVOICE_SEFAZ_UNAVAILABLE: 'SEFAZ não está disponível. Tente novamente em alguns minutos',
      INVOICE_CREDENTIALS_MISSING: 'A loja não tem credenciais fiscais configuradas',
      SHIPPING_INVOICE_ERROR: 'Erro ao gerar nota fiscal de envio',
      SALE_INVOICE_MISSING: 'O pedido não tem nota fiscal de venda. O time Fiscal precisa emiti-la ou reenviar o faturamento',
      INVOICE_SERVICE_ERROR: 'Erro interno do serviço de faturamento',
      IMEI_VALIDATION_FAILED: 'Erro na validação de IMEIs',
      PACKAGE_VALIDATION_FAILED: 'Erro na validação do pacote',
      PACKAGE_NOT_ALLOWED_FOR_STORE: 'Esta caixa não é permitida para esta marca',
      MULTIPACKAGE_NOT_SUPPORTED: 'Esta transportadora não suporta múltiplos pacotes',
      SHIPPING_METHOD_INVALID: 'O método de envio não é válido para este pedido',
      ORDER_WRONG_STATUS: 'O pedido não está em um status válido para empacotamento',
      ORDER_ALREADY_PACKED: 'Este pedido já foi empacotado',
      ORDER_NOT_FOUND: 'Pedido não encontrado',
      ORDER_MISSING_DATA: 'Faltam dados no pedido',
      EDIT_RESTRICTION: 'Não é possível modificar este pedido',
      CLICK_AND_COLLECT_ERROR: 'Erro na reserva do ponto de coleta',
      STORE_BILLING_CONFIGURATION_INVALID: 'A loja tem mais de uma configuração de cobrança vigente para o mesmo serviço',
      STORE_PACKING_DISABLED: 'O empacotamento está desabilitado para esta loja',
      ORDER_AWAITING_FIX: 'O pedido está aguardando correção',
      NOT_AUTHORIZED: 'Você não tem permissão para realizar esta ação',
      LABEL_GENERATION_IN_PROGRESS: 'Já está sendo gerada uma etiqueta. Aguarde alguns segundos',
      INVOICE_GENERATION_IN_PROGRESS: 'Já está sendo gerada uma nota fiscal. Aguarde alguns segundos',
      UNEXPECTED_ERROR: 'Erro inesperado. Se persistir, reporte ao suporte',
    },
    operator_headline: {
      retry: 'Tente novamente agora',
      wait: 'Aguarde e tente de novo',
      move_on: 'Passe para o próximo pedido',
      escalate: 'Reporte para {{area}}',
      escalate_no_area: 'Avise seu supervisor',
    },
    card: {
      order: 'Pedido',
      tote: 'Tote',
      order_id: 'ID interno',
      carrier: 'Transportadora',
      destination: 'Destino',
      weight: 'Peso',
      retry_in: 'Tente em {{seconds}} s',
      wait_countdown: 'Costuma se resolver sozinho. Tente de novo em {{seconds}} s.',
      wait_elapsed: 'Já pode tentar novamente.',
      checking: 'Verificando se já foi resolvido…',
      checking_short: 'Verificando…',
      copy_report: 'Copiar relatório',
      copied: 'Copiado',
      report_to: 'Reportar para {{area}}',
      store: 'Loja',
      report_title: 'Erro de embalagem',
      detail: 'Detalhe',
      technical_detail: 'Detalhe técnico',
      attempt: 'Tentativa {{attempt}} de {{total}}',
      attempts_exhausted: 'Não tente de novo: o caso já está com o Tech.',
    },
    operator_action: {
      fix_address: 'Escalar ao supervisor — a loja deve corrigir o endereço',
      fix_fiscal: 'Escalar ao supervisor — a loja deve corrigir dados fiscais',
      fix_shipping: 'Escalar ao supervisor — a loja deve corrigir o método de envio',
      fix_order_data: 'Escalar ao supervisor — a loja deve corrigir os dados do pedido',
      contact_support: 'Avisar a loja para entrar em contato com o suporte',
      wait: 'Aguardar alguns minutos e tentar novamente',
      retry: 'Tentar novamente o empacotamento',
      move_on: 'Passar para o próximo pedido — não há nada a fazer com este na mesa',
      validate_address: 'Escalar ao supervisor — a loja deve validar o endereço',
      escalate: 'Sem mais tentativas — o caso fica com o Tech',
    },
    category: {
      LAST_MILE: 'Última milha',
      INVOICING: 'Faturamento',
      VALIDATION: 'Validação',
      AUTHORIZATION: 'Autorização',
      CONCURRENCY: 'Concorrência',
      SYSTEM: 'Sistema',
    },
    responsible_area: {
      customer: 'Customer',
      cubbo_ops: 'Cubbo Ops',
      lastmile: 'Last Mile',
      tech: 'Tech',
      fiscal: 'Fiscal',
    },
    error_status: {
      open: 'Pendente de correção',
      pending_retry: 'Pronto para tentar novamente',
      retry_failed: 'Nova tentativa falhou',
      solved: 'Resolvido',
    },
    history: {
      title: 'Erros de fulfillment',
      code: 'Código',
      category: 'Categoria',
      responsible: 'Responsável',
      status: 'Estado',
      action: 'Ação',
      message: 'Mensagem',
      date: 'Data',
      resolution: 'Resolução',
      no_errors: 'Sem erros de fulfillment',
      go_to_packing: 'Ir para empacotamento',
      since: 'desde',
      attempt: 'tentativa {{n}}',
      retry_count_one: '{{count}} nova tentativa do ciclo',
      retry_count_other: '{{count}} novas tentativas do ciclo',
      collapsed_hint: 'Vezes seguidas em que este mesmo erro foi registrado. Clique para ver cada tentativa',
    },
    resolution: {
      retried_success: 'Nova tentativa bem-sucedida',
      edited_order: 'Pedido corrigido',
      cancelled_order: 'Pedido cancelado',
      externally_solved: 'Resolvido externamente',
      store_config_fixed: 'Configuração da loja corrigida',
      manual_override: 'Resolução manual',
      superseded: 'Substituído por erro mais recente',
    },
    error_modal: {
      title: 'Erro ao gerar a etiqueta',
      responsible: 'Responsável',
      operator_action: 'O que fazer',
      close: 'Fechar',
      retry: 'Tentar novamente',
    },
    packing_banner: {
      title: 'Erro de fulfillment',
      pending_retry: 'A loja já corrigiu este pedido. Você pode tentar novamente o empacotamento.',
      generic: 'Este pedido tem um erro de fulfillment pendente.',
    },
    page: {
      title: 'Erros de fulfillment',
      empty: 'Não há pedidos com erros ativos',
      headers: {
        order_number: 'Pedido',
        store: 'Loja',
        tote: 'Tote',
        category: 'Categoria',
        responsible_area: 'Responsável',
        operator_action: 'Ação',
        error_status: 'Estado',
        created_at: 'Desde',
      },
      filters: {
        responsible_area: 'Responsável',
        responsible_area_placeholder: 'Filtrar por responsável',
        error_status: 'Estado',
        error_status_placeholder: 'Filtrar por estado',
        tote: 'Tote',
        tote_placeholder: 'Buscar por tote',
        order_number: 'Pedido',
        store: 'Loja',
      },
    },
  },
  pending_prints: {
    title: 'Impressões pendentes',
    scan: {
      title: 'Escaneie ou digite o código',
      subtitle:
        'Qualquer código gerado no HH que precise de etiqueta chega aqui, independentemente do fluxo que o originou. Escaneie com a pistola ou digite e pressione Enter para enviá-lo à impressora.',
      placeholder: 'Escaneie ou digite o código de impressão ou do contêiner',
      submit: 'Imprimir',
      printing: 'Imprimindo…',
    },
    outcome: {
      iframe: '{{code}} enviado para a impressora.',
      fallback: 'Abrimos a etiqueta em uma nova aba; imprima-a de lá.',
      blocked: 'O navegador bloqueou a janela de impressão. Abra a etiqueta para imprimi-la.',
      timeout: 'A etiqueta não chegou à impressora. Abra a etiqueta para imprimi-la.',
      copies: 'Imprima {{count}} cópias: escolha-as na caixa de diálogo de impressão.',
      open_label: 'Abrir etiqueta',
    },
    history: {
      title: 'Impressões realizadas',
    },
    table: {
      print_code: 'Código de impressão',
      what: 'O que é impresso',
      kind: 'Tipo',
      origin: 'Origem',
      store: 'Loja',
      last_printed: 'Última impressão',
    },
    what: {
      one_label: '1 etiqueta',
    },
    kind: {
      box: 'Caixa',
      pallet: 'Pallet',
    },
    origin: {
      replenishment: 'Recebimento',
      replenishment_id: '#{{id}}',
    },
    ambiguous: {
      title: 'Este código corresponde a várias etiquetas',
      subtitle: 'O código {{code}} corresponde a várias etiquetas. Escolha a que você vai imprimir.',
      print: 'Imprimir',
      cancel: 'Cancelar',
      new_code: 'Será gerado um novo código de impressão',
      pieces_per_box: '{{count}} pç/caixa',
      sku: 'SKU: {{sku}}',
      lot: 'Lote {{lot}}',
      lot_expires: 'vence {{date}}',
      store: 'Loja:',
      origin: 'Origem:',
      created: 'Criada:',
      print_code: 'Código de impressão:',
    },
    actions: {
      print: 'Imprimir',
      reprint: 'Reimprimir',
    },
    filters: {
      print_code: 'Código de impressão',
      barcode: 'Código do contêiner',
      store: 'Loja',
      store_placeholder: 'Nome da loja',
      origin: 'Origem',
      origin_id: 'ID de origem',
      origin_id_placeholder: 'Número, ex.: 1864',
      kind: 'Tipo',
      unprinted: 'Não impressas',
      last_printed: 'Última impressão',
    },
    empty: 'Não há impressões para mostrar.',
    footer: 'impressões',
    unavailable: 'Esta tela ainda não está disponível.',
    errors: {
      PRINT_JOB_NOT_FOUND: 'O código {{code}} não existe no sistema.',
      INVALID_PARAMS: 'Digite ou escaneie um código',
      FORBIDDEN: 'Você não tem acesso a este armazém',
      timeout: 'O servidor demorou demais para responder. Tente novamente.',
      network: 'Sem conexão com o servidor. Verifique sua rede e tente novamente.',
      generic: 'Algo deu errado. Tente novamente.',
      unprintable_barcode: 'Este código tem caracteres que não podem ser impressos na etiqueta. Avise seu supervisor.',
      PRINT_JOB_AMBIGUOUS: 'Este código corresponde a várias etiquetas e não conseguimos mostrá-las. Tente novamente.',
      time_zone: 'Não conseguimos carregar o fuso horário do armazém, então não é possível filtrar pela data de impressão. Recarregue a página.',
    },
  },
  romaneios: {
    title: 'Romaneios',
    headers: {
      number: 'Romaneio',
      carrier: 'Transportadora',
      status: 'Status',
      pickup: 'Coleta',
      boxes: 'Volumes',
      driver: 'Motorista',
      documents: 'Documentos',
    },
    filters: {
      number: 'Número do romaneio',
      order_number: 'Número do pedido',
      carrier: 'Transportadora',
      all_carriers: 'Todas as transportadoras',
      status: 'Status',
      all_statuses: 'Todos os status',
      from: 'De',
      to: 'Até',
    },
    statuses: {
      open: 'Aberto',
      handed_over: 'Entregue',
    },
    overdue: 'Atrasado',
    scheduled: 'Agendada',
    picked_up: 'Coletado',
    boxes_count_one: '{{count}} volume',
    boxes_count_other: '{{count}} volumes',
    orders_count_one: '{{count}} pedido',
    orders_count_other: '{{count}} pedidos',
    handed_over_by: 'Entregou: {{name}}',
    opened_by: 'Abriu: {{name}}',
    signed: 'Assinado',
    unsigned: 'Sem assinatura',
    document: 'PDF',
    partial: 'Parcial {{sequence}}',
    verification: 'Página de verificação',
    no_document_open: 'Ainda aberto',
    document_pending: 'Gerando PDF',
    companion_of: 'Externos de {{number}} ({{carrier}})',
    companion: 'Externos: {{number}}',
    empty: 'Nenhum romaneio com estes filtros',
    error: 'Não foi possível carregar os romaneios. Tente novamente.',
  },
  proof_video_coverage: {
    title: 'Cobertura de vídeo de packing',
    period: {
      group: 'Período',
      previous_month: 'Mês anterior',
      next_month: 'Mês seguinte',
      custom: 'Intervalo personalizado',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
      range: 'De {{from}} a {{to}}',
      errors: {
        span_too_long: 'O período não pode ser maior que um mês.',
        to_before_from: 'A data final não pode ser anterior à inicial.',
        to_in_future: 'A data final não pode ser posterior a hoje.',
        malformed: 'Informe datas válidas.',
      },
    },
    headline: {
      label: 'Cobertura de vídeo de packing',
      description: 'Pedidos com vídeo de packing salvo e sem tentativas com falha.',
      of_packed_one: 'de {{orders}} pedido empacotado',
      of_packed_other: 'de {{orders}} pedidos empacotados',
    },
    table: {
      caption: 'Pedidos empacotados de {{from}} a {{to}}',
      situation: 'Situação',
      orders: 'Pedidos',
      share: 'Proporção',
      total: 'Total de pedidos empacotados',
    },
    slices: {
      covered: { label: 'Com vídeo', description: 'Vídeo de packing salvo.' },
      partial: {
        label: 'Com vídeo após tentativa com falha',
        description: 'Há vídeo salvo, mas uma tentativa anterior de gravação falhou: o início do packing pode não estar no vídeo.',
      },
      salvaged: {
        label: 'Vídeo recuperado',
        description: 'O envio não terminou corretamente; foi salvo o que chegou a ser enviado, e o vídeo pode estar incompleto.',
      },
      pending: {
        label: 'Envio em andamento',
        description: 'O envio do vídeo ainda não foi confirmado; o sistema vai marcá-lo como salvo ou perdido.',
      },
      not_stored: { label: 'Vídeo não salvo', description: 'A gravação foi iniciada, mas nenhuma tentativa chegou a ser salva.' },
      no_session: { label: 'Sem gravação', description: 'Não há registro de gravação para este pedido (inclui estações sem câmera).' },
    },
    states: {
      loading: 'Carregando cobertura…',
      time_zone_missing: 'Não foi possível determinar o fuso horário do armazém, então não dá para calcular o período.',
      invalid_period: 'O período da URL não é válido.',
      forbidden: 'Você não tem permissão para ver a cobertura de vídeo deste armazém.',
      not_found: 'Não encontramos este armazém.',
      rejected: 'O período de {{from}} a {{to}} não foi aceito.',
      failed: 'Não foi possível carregar a cobertura. Tente novamente.',
      empty: 'Não houve pedidos empacotados de {{from}} a {{to}}.',
      retry: 'Tentar novamente',
    },
  },
}
